webpackJsonp([1],{

/***/ "3/5g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5kmU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8oXI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DE+O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KUHQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-gtag/dist/vue-gtag.esm.js
var vue_gtag_esm = __webpack_require__("Z3T5");

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/js-search/dist/commonjs/index.js
var commonjs = __webpack_require__("5KK7");
var commonjs_default = /*#__PURE__*/__webpack_require__.n(commonjs);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FeatherIcon.vue
//
//
//
//

var feather = __webpack_require__("/qmR");
//  feather.icons.x
// {
//    name: 'x',
//    contents: '<line ... /><line ... />`,
//    tags: ['cancel', 'close', 'delete', 'remove'],
//    attrs: {
//      class: 'feather feather-x',
//      xmlns: 'http://www.w3.org/2000/svg',
//      width: 24,
//      height: 24,
//      viewBox: '0 0 24 24',
//      fill: 'none',
//      stroke: 'currentColor',
//      'stroke-width': 2,
//      'stroke-linecap': 'round',
//      'stroke-linejoin': 'round',
//    }
// }
/* harmony default export */ var FeatherIcon = ({
  name: 'feather-icon',
  props: ['icon', 'options'],
  computed: {
    iconSvg: function iconSvg() {
      return feather.icons[this.icon].toSvg(this.options);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4a906d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeatherIcon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{domProps:{"innerHTML":_vm._s(_vm.iconSvg)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_FeatherIcon = (esExports);
// CONCATENATED MODULE: ./src/components/FeatherIcon.vue
function injectStyle (ssrContext) {
  __webpack_require__("bp21")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  FeatherIcon,
  components_FeatherIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_FeatherIcon = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PublishPage.vue

//
//
//
//
//



/* harmony default export */ var PublishPage = ({
  name: 'kpPage',
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  props: ['page', 'width', 'height', 'classes', 'double'],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['basePath']), {
    styleObject: function styleObject() {
      if (this.classes == "rightPage") {
        return {
          width: this.width + 'px',
          height: this.height + 'px',
          'background-image': 'url(' + this.basePath + '/static/_content/' + this.page.original + ')',
          left: '-1px'
        };
      } else {
        return {
          width: this.width + 'px',
          height: this.height + 'px',
          'background-image': 'url(' + this.basePath + '/static/_content/' + this.page.original + ')'
        };
      }
    }
  }),
  updated: function updated() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);

      if (this.classes == "currentPage" && p == 2) {
        if (this.double == false) {} else {
          if (window["p" + p + "s" + s + "onPageEnter"]) {
            window["p" + p + "s" + s + "onPageEnter"]();
          }
        }
      } else {
        if (window["p" + p + "s" + s + "onPageEnter"]) {
          window["p" + p + "s" + s + "onPageEnter"]();
        }
      }
    }
  },
  mounted: function mounted() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (this.classes == "currentPage" && p == 2) {
        if (this.double == false) {} else {
          if (window["p" + p + "s" + s + "onPageEnter"]) {
            window["p" + p + "s" + s + "onPageEnter"]();
          }
        }
      } else {
        if (window["p" + p + "s" + s + "onPageEnter"]) {
          window["p" + p + "s" + s + "onPageEnter"]();
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f6053c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PublishPage.vue
var PublishPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page",class:_vm.classes,style:(_vm.styleObject),attrs:{"data-page":((_vm.page.pageIndex) + "-" + (_vm.page.sectionIndex + 1))},domProps:{"innerHTML":_vm._s(_vm.page.content)}})}
var PublishPage_staticRenderFns = []
var PublishPage_esExports = { render: PublishPage_render, staticRenderFns: PublishPage_staticRenderFns }
/* harmony default export */ var components_PublishPage = (PublishPage_esExports);
// CONCATENATED MODULE: ./src/components/PublishPage.vue
function PublishPage_injectStyle (ssrContext) {
  __webpack_require__("YibV")
}
var PublishPage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PublishPage___vue_template_functional__ = false
/* styles */
var PublishPage___vue_styles__ = PublishPage_injectStyle
/* scopeId */
var PublishPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PublishPage___vue_module_identifier__ = null
var PublishPage_Component = PublishPage_normalizeComponent(
  PublishPage,
  components_PublishPage,
  PublishPage___vue_template_functional__,
  PublishPage___vue_styles__,
  PublishPage___vue_scopeId__,
  PublishPage___vue_module_identifier__
)

/* harmony default export */ var src_components_PublishPage = (PublishPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobilePage.vue

//
//
//
//
//
//
//



/* harmony default export */ var MobilePage = ({
  name: 'kpMobilePage',
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentMobilePage', 'mobilePageContent']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3190bf5a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobilePage.vue
var MobilePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mobile-page",class:_vm.currentMobilePage.cssClass},[_c('header',{staticClass:"mobile-header",domProps:{"textContent":_vm._s(_vm.currentMobilePage.title)}}),_vm._v(" "),_c('article',{staticClass:"mobile-content",domProps:{"innerHTML":_vm._s(_vm.mobilePageContent(_vm.currentMobilePage))}})])}
var MobilePage_staticRenderFns = []
var MobilePage_esExports = { render: MobilePage_render, staticRenderFns: MobilePage_staticRenderFns }
/* harmony default export */ var mobile_MobilePage = (MobilePage_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobilePage.vue
function MobilePage_injectStyle (ssrContext) {
  __webpack_require__("QkI9")
}
var MobilePage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobilePage___vue_template_functional__ = false
/* styles */
var MobilePage___vue_styles__ = MobilePage_injectStyle
/* scopeId */
var MobilePage___vue_scopeId__ = "data-v-3190bf5a"
/* moduleIdentifier (server only) */
var MobilePage___vue_module_identifier__ = null
var MobilePage_Component = MobilePage_normalizeComponent(
  MobilePage,
  mobile_MobilePage,
  MobilePage___vue_template_functional__,
  MobilePage___vue_styles__,
  MobilePage___vue_scopeId__,
  MobilePage___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobilePage = (MobilePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileNavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var MobileNavigationBar = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['title', 'companyLogo', 'showContents', 'isMobileFontLarge'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS',
    toggleFontSize: 'TOGGLE_FONT_SIZE'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16e24576","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileNavigationBar.vue
var MobileNavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar",attrs:{"id":"mobile-nav-bar"}},[_c('div',{staticClass:"nav-menu-button",class:{ mobileFontLarge: _vm.isMobileFontLarge },attrs:{"id":"mobile-font-size-toggle"},on:{"click":_vm.toggleFontSize}},[_c('span',{staticClass:"font-size-toggle-small"},[_vm._v("Aa")]),_vm._v(" "),_c('span',{staticClass:"font-size-toggle-large"},[_vm._v("Aa")])]),_vm._v(" "),_c('img',{attrs:{"id":"mobile-nav-bar__logo","src":_vm.companyLogo}}),_vm._v(" "),_c('div',{staticClass:"nav-menu-button",attrs:{"id":"mobile-nav-button"},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"menu"}})],1)])}
var MobileNavigationBar_staticRenderFns = []
var MobileNavigationBar_esExports = { render: MobileNavigationBar_render, staticRenderFns: MobileNavigationBar_staticRenderFns }
/* harmony default export */ var mobile_MobileNavigationBar = (MobileNavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileNavigationBar.vue
function MobileNavigationBar_injectStyle (ssrContext) {
  __webpack_require__("WAiT")
}
var MobileNavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileNavigationBar___vue_template_functional__ = false
/* styles */
var MobileNavigationBar___vue_styles__ = MobileNavigationBar_injectStyle
/* scopeId */
var MobileNavigationBar___vue_scopeId__ = "data-v-16e24576"
/* moduleIdentifier (server only) */
var MobileNavigationBar___vue_module_identifier__ = null
var MobileNavigationBar_Component = MobileNavigationBar_normalizeComponent(
  MobileNavigationBar,
  mobile_MobileNavigationBar,
  MobileNavigationBar___vue_template_functional__,
  MobileNavigationBar___vue_styles__,
  MobileNavigationBar___vue_scopeId__,
  MobileNavigationBar___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileNavigationBar = (MobileNavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileMenu.vue

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MobileMenu = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['mobilePages', 'mobilePageLink', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb238d82","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileMenu.vue
var MobileMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showContents)?_c('div',{attrs:{"id":"mobile-menu"}},[_c('ul',{attrs:{"id":"mobile-list"}},_vm._l((_vm.mobilePages),function(mobilePage,index){return (!mobilePage.hideInMenu)?_c('li',{key:index,on:{"click":_vm.toggleContents}},[_c('router-link',{attrs:{"to":_vm.mobilePageLink(mobilePage)}},[_vm._v(_vm._s(mobilePage.title))])],1):_vm._e()}))]):_vm._e()}
var MobileMenu_staticRenderFns = []
var MobileMenu_esExports = { render: MobileMenu_render, staticRenderFns: MobileMenu_staticRenderFns }
/* harmony default export */ var mobile_MobileMenu = (MobileMenu_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileMenu.vue
function MobileMenu_injectStyle (ssrContext) {
  __webpack_require__("3/5g")
}
var MobileMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileMenu___vue_template_functional__ = false
/* styles */
var MobileMenu___vue_styles__ = MobileMenu_injectStyle
/* scopeId */
var MobileMenu___vue_scopeId__ = "data-v-eb238d82"
/* moduleIdentifier (server only) */
var MobileMenu___vue_module_identifier__ = null
var MobileMenu_Component = MobileMenu_normalizeComponent(
  MobileMenu,
  mobile_MobileMenu,
  MobileMenu___vue_template_functional__,
  MobileMenu___vue_styles__,
  MobileMenu___vue_scopeId__,
  MobileMenu___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileMenu = (MobileMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var MobileContainer = ({
  components: {
    MobilePage: components_mobile_MobilePage,
    MobileNavigationBar: components_mobile_MobileNavigationBar,
    MobileMenu: components_mobile_MobileMenu
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['nextMobilePage', 'previousMobilePage', 'currentMobilePage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a441386","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileContainer.vue
var MobileContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mobile-container"}},[_c('mobile-navigation-bar'),_vm._v(" "),(_vm.currentMobilePage)?_c('mobile-page'):_vm._e(),_vm._v(" "),_c('mobile-menu'),_vm._v(" "),_c('div',{staticClass:"nav-buttons",attrs:{"id":"navButtons"}},[(_vm.previousMobilePage)?_c('button',{staticClass:"advert-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnPrev","onclick":"Publish.goToPreviousMobilePage();"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('button',{staticClass:"aqua-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnNext","onclick":"Publish.goToNextMobilePage();"}}):_vm._e()])],1)}
var MobileContainer_staticRenderFns = []
var MobileContainer_esExports = { render: MobileContainer_render, staticRenderFns: MobileContainer_staticRenderFns }
/* harmony default export */ var mobile_MobileContainer = (MobileContainer_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileContainer.vue
function MobileContainer_injectStyle (ssrContext) {
  __webpack_require__("oPvi")
}
var MobileContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileContainer___vue_template_functional__ = false
/* styles */
var MobileContainer___vue_styles__ = MobileContainer_injectStyle
/* scopeId */
var MobileContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileContainer___vue_module_identifier__ = null
var MobileContainer_Component = MobileContainer_normalizeComponent(
  MobileContainer,
  mobile_MobileContainer,
  MobileContainer___vue_template_functional__,
  MobileContainer___vue_styles__,
  MobileContainer___vue_scopeId__,
  MobileContainer___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileContainer = (MobileContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LanguagesPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LanguagesPanel = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['languages']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c0d9e23","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguagesPanel.vue
var LanguagesPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"languages-fade"}},[_c('nav',{staticClass:"languages-panel"},[_c('ul',{staticClass:"languages-list"},_vm._l((_vm.languages),function(language,index){return _c('li',{key:index,staticClass:"languages-item"},[_c('a',{attrs:{"rel":"alternate","href":language.href,"target":"_blank"}},[_vm._v(_vm._s(language.code))])])}))])])}
var LanguagesPanel_staticRenderFns = []
var LanguagesPanel_esExports = { render: LanguagesPanel_render, staticRenderFns: LanguagesPanel_staticRenderFns }
/* harmony default export */ var components_LanguagesPanel = (LanguagesPanel_esExports);
// CONCATENATED MODULE: ./src/components/LanguagesPanel.vue
function LanguagesPanel_injectStyle (ssrContext) {
  __webpack_require__("i9d8")
}
var LanguagesPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var LanguagesPanel___vue_template_functional__ = false
/* styles */
var LanguagesPanel___vue_styles__ = LanguagesPanel_injectStyle
/* scopeId */
var LanguagesPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LanguagesPanel___vue_module_identifier__ = null
var LanguagesPanel_Component = LanguagesPanel_normalizeComponent(
  LanguagesPanel,
  components_LanguagesPanel,
  LanguagesPanel___vue_template_functional__,
  LanguagesPanel___vue_styles__,
  LanguagesPanel___vue_scopeId__,
  LanguagesPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_LanguagesPanel = (LanguagesPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/EditionsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var EditionsPanel = ({
  // components: {
  //   EditionsJson
  // },
  computed: extends_default()({
    editions_data: function editions_data() {
      if (window.editions_data && window.editions_data.length) {
        return window.editions_data;
      } else {
        return editions;
      }
    }
  }, Object(vuex_esm["e" /* mapState */])({
    currentLanguage: function currentLanguage(state) {
      return state.document.currentLanguage;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['currentLanguage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dd022a4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditionsPanel.vue
var EditionsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"editions-fade"}},[_c('nav',{staticClass:"editions-panel"},[_c('ul',{staticClass:"editions-list"},_vm._l((_vm.editions_data),function(edition,index){return _c('li',{key:index,staticClass:"editions-item"},[_c('a',{attrs:{"rel":"alternate","href":edition.href + _vm.currentLanguage.toLowerCase(),"target":"_blank"}},[_vm._v(_vm._s(edition.code))])])}))])])}
var EditionsPanel_staticRenderFns = []
var EditionsPanel_esExports = { render: EditionsPanel_render, staticRenderFns: EditionsPanel_staticRenderFns }
/* harmony default export */ var components_EditionsPanel = (EditionsPanel_esExports);
// CONCATENATED MODULE: ./src/components/EditionsPanel.vue
function EditionsPanel_injectStyle (ssrContext) {
  __webpack_require__("uDJ7")
}
var EditionsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var EditionsPanel___vue_template_functional__ = false
/* styles */
var EditionsPanel___vue_styles__ = EditionsPanel_injectStyle
/* scopeId */
var EditionsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var EditionsPanel___vue_module_identifier__ = null
var EditionsPanel_Component = EditionsPanel_normalizeComponent(
  EditionsPanel,
  components_EditionsPanel,
  EditionsPanel___vue_template_functional__,
  EditionsPanel___vue_styles__,
  EditionsPanel___vue_scopeId__,
  EditionsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_EditionsPanel = (EditionsPanel_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-slider-component/dist/vue-slider-component.umd.min.js
var vue_slider_component_umd_min = __webpack_require__("lCKi");
var vue_slider_component_umd_min_default = /*#__PURE__*/__webpack_require__.n(vue_slider_component_umd_min);

// EXTERNAL MODULE: ./node_modules/vue-slider-component/theme/material.css
var material = __webpack_require__("KUHQ");
var material_default = /*#__PURE__*/__webpack_require__.n(material);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var NavigationBar = ({
  data: function data() {
    return {
      editions: [],
      zoomValue: 1
    };
  },

  props: ["logoURL", "title", "page", "companyName", "width"],
  components: {
    FeatherIcon: src_components_FeatherIcon,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel,
    VueSlider: vue_slider_component_umd_min_default.a
  },
  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomNavEnabled", "contentsEnabled", "contentsPinned", "searchEnabled", "languagesEnabled", "editionsEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "rightToLeft", "companyLogo", "downloadPath", "showContents", "showLanguages", "showEditions", "showSearch", "showGuide", "isZoomed", "isMobile", "mobileSwitch", "currentMobilePage", "fullscreenEnabled", "zoomScrollEnabled", "isDoublePage"]), {
    divider: function divider() {
      if (this.rightToLeft) return "chevron-left";
      return "chevron-right";
    }
  }),
  mounted: function mounted() {
    this.loadEditionsScript();
  },

  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS",
    toggleLanguages: "TOGGLE_LANGUAGES",
    toggleEditions: "TOGGLE_EDITIONS",
    toggleZoom: "TOGGLE_ZOOM",
    slideZoom: "SLIDE_ZOOM",
    toggleSearch: "TOGGLE_SEARCH",
    toggleGuide: "TOGGLE_GUIDE",
    toggleReader: "TOGGLE_READER",
    toggleFullscreen: "TOGGLE_FULLSCREEN"
  }), {
    loadEditionsScript: function loadEditionsScript() {
      var editionsJson = document.createElement('script');
      editionsJson.setAttribute('src', 'https://touchline-uefa.s3-eu-west-1.amazonaws.com/editions.js');
      document.head.appendChild(editionsJson);
      this.editions = editionsJson;
    },
    updateSliderZoom: function updateSliderZoom() {
      Publish.$store.commit("SLIDE_ZOOM", { zoomValue: this.zoomValue });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0995be6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationBar.vue
var NavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"nav-bar"},[_c('div',{staticClass:"nav-bar__container"},[_c('div',{staticClass:"nav-bar__logo"},[_c('img',{staticClass:"nav-bar__logo-image",attrs:{"src":_vm.companyLogo,"alt":_vm.companyName}})]),_vm._v(" "),_c('div',{staticClass:"nav-bar__text"},[(_vm.isDoublePage)?_c('span',{staticClass:"nav-bar__title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__divider"},[_c('feather-icon',{attrs:{"icon":_vm.divider}})],1):_vm._e(),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__page"},[_vm._v(_vm._s(_vm.page))]):_vm._e()]),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && !_vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Reader is available")]):_vm._e(),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && _vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Return to magazine")]):_vm._e(),_vm._v(" "),_c('nav',{staticClass:"nav-bar__links"},[_c('ul',[(!((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader))?[(_vm.zoomScrollEnabled)?_c('li',{staticClass:"nav-bar__link nav-bar__zoom-slider"},[_c('vue-slider',{ref:"zoomSlider",attrs:{"min":1,"max":2,"interval":0.01,"tooltip-placement":'bottom'},on:{"change":function($event){_vm.updateSliderZoom()},"click":_vm.slideZoom},model:{value:(_vm.zoomValue),callback:function ($$v) {_vm.zoomValue=$$v},expression:"zoomValue"}})],1):_vm._e(),_vm._v(" "),(_vm.guideEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showGuide},on:{"click":_vm.toggleGuide}},[_c('feather-icon',{attrs:{"icon":"help-circle"},on:{"click":_vm.toggleGuide}})],1):_vm._e(),_vm._v(" "),((_vm.zoomNavEnabled && (!_vm.isMobile)))?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.isZoomed},on:{"click":_vm.toggleZoom}},[_c('feather-icon',{attrs:{"icon":"zoom-in"},on:{"click":_vm.toggleZoom}})],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showSearch},on:{"click":_vm.toggleSearch}},[_c('feather-icon',{attrs:{"icon":"search"}})],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showLanguages},on:{"click":_vm.toggleLanguages}},[_c('feather-icon',{attrs:{"icon":"globe"}}),_vm._v(" "),_c('languages-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLanguages),expression:"showLanguages"}]})],1):_vm._e(),_vm._v(" "),(_vm.editionsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showEditions},on:{"click":_vm.toggleEditions}},[_c('feather-icon',{attrs:{"icon":"book"}}),_vm._v(" "),_c('editions-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showEditions),expression:"showEditions"}]})],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('a',{attrs:{"href":_vm.downloadPath,"target":"_blank","download":""}},[_c('feather-icon',{attrs:{"icon":"download"}})],1)]):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('feather-icon',{attrs:{"icon":"printer"}})],1):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.contentsEnabled && _vm.contentsPinned)?_c('li',{staticClass:"nav-bar__link hidden-large",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}}):(_vm.contentsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"grid"}})],1):_vm._e(),_vm._v(" "),(_vm.fullscreenEnabled && !_vm.isMobile)?_c('li',{staticClass:"nav-bar__link",on:{"click":_vm.toggleFullscreen}},[_c('feather-icon',{attrs:{"icon":"maximize"}})],1):_vm._e()],2)])])])}
var NavigationBar_staticRenderFns = []
var NavigationBar_esExports = { render: NavigationBar_render, staticRenderFns: NavigationBar_staticRenderFns }
/* harmony default export */ var components_NavigationBar = (NavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/NavigationBar.vue
function NavigationBar_injectStyle (ssrContext) {
  __webpack_require__("NYpa")
}
var NavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationBar___vue_template_functional__ = false
/* styles */
var NavigationBar___vue_styles__ = NavigationBar_injectStyle
/* scopeId */
var NavigationBar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationBar___vue_module_identifier__ = null
var NavigationBar_Component = NavigationBar_normalizeComponent(
  NavigationBar,
  components_NavigationBar,
  NavigationBar___vue_template_functional__,
  NavigationBar___vue_styles__,
  NavigationBar___vue_scopeId__,
  NavigationBar___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationBar = (NavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationLink.vue
//
//
//
//
//
//



/* harmony default export */ var NavigationLink = ({
  props: ['to', 'rotation', 'width', 'height', 'color', 'classes'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: this.width,
        height: this.height
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cec1756","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationLink.vue
var NavigationLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes},[_c('router-link',{attrs:{"to":_vm.to}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)],1)}
var NavigationLink_staticRenderFns = []
var NavigationLink_esExports = { render: NavigationLink_render, staticRenderFns: NavigationLink_staticRenderFns }
/* harmony default export */ var components_NavigationLink = (NavigationLink_esExports);
// CONCATENATED MODULE: ./src/components/NavigationLink.vue
function NavigationLink_injectStyle (ssrContext) {
  __webpack_require__("zUAv")
}
var NavigationLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationLink___vue_template_functional__ = false
/* styles */
var NavigationLink___vue_styles__ = NavigationLink_injectStyle
/* scopeId */
var NavigationLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationLink___vue_module_identifier__ = null
var NavigationLink_Component = NavigationLink_normalizeComponent(
  NavigationLink,
  components_NavigationLink,
  NavigationLink___vue_template_functional__,
  NavigationLink___vue_styles__,
  NavigationLink___vue_scopeId__,
  NavigationLink___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationLink = (NavigationLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MobileLink.vue
//
//
//
//
//
//



/* harmony default export */ var MobileLink = ({
  props: ['to', 'rotation', 'color', 'classes', 'click'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04cebad8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileLink.vue
var MobileLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes,on:{"click":_vm.click}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)}
var MobileLink_staticRenderFns = []
var MobileLink_esExports = { render: MobileLink_render, staticRenderFns: MobileLink_staticRenderFns }
/* harmony default export */ var components_MobileLink = (MobileLink_esExports);
// CONCATENATED MODULE: ./src/components/MobileLink.vue
function MobileLink_injectStyle (ssrContext) {
  __webpack_require__("OGji")
}
var MobileLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileLink___vue_template_functional__ = false
/* styles */
var MobileLink___vue_styles__ = MobileLink_injectStyle
/* scopeId */
var MobileLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileLink___vue_module_identifier__ = null
var MobileLink_Component = MobileLink_normalizeComponent(
  MobileLink,
  components_MobileLink,
  MobileLink___vue_template_functional__,
  MobileLink___vue_styles__,
  MobileLink___vue_scopeId__,
  MobileLink___vue_module_identifier__
)

/* harmony default export */ var src_components_MobileLink = (MobileLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentItem.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ContentItem = ({
  props: ['page', 'index'],
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'titledPages', 'basePath', 'currentPage', 'contentsPinned', 'contentsNumbers', 'contentsTitles']), {

    currentPageIndex: function currentPageIndex() {
      return this.page[0].pageIndex;
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['goToPage']), Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS"
  }), {

    getBackgroundURL: function getBackgroundURL(index, sectionIndex) {
      if (sectionIndex == 0) {
        return 'url(' + this.basePath + '/static/_thumbs/' + index + '.png)';
      } else {
        return 'url(' + this.basePath + '/static/_thumbs/' + index + '-' + (sectionIndex + 1) + '.png)';
      }
    },

    toggleExpanded: function toggleExpanded(index) {
      this.isExpanded = !this.isExpanded;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72e27905","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentItem.vue
var ContentItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"contents-item"},[_c('div',{staticClass:"contents-item__section",class:{active: _vm.currentPage.pageIndex == _vm.currentPageIndex && _vm.currentPage.sectionIndex == 0}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.goToPage({pageIndex: _vm.currentPageIndex, sectionIndex: 1});_vm.toggleContents();}}},[(_vm.contentsNumbers)?_c('p',{staticClass:"contents-item__text--index"},[_vm._v("\n          "+_vm._s(_vm.currentPageIndex)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.contentsTitles)?_c('p',{class:['contents-item__text--title', _vm.contentsPinned ? '' : '']},[_vm._v("\n          "+_vm._s(_vm.page[0].title)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.contentsPinned && _vm.page.length > 1)?_c('div',{staticClass:"content-item__chevrons"},[_c('div',{staticClass:"contents-item__expander",on:{"click":function($event){_vm.toggleExpanded(_vm.index)}}},[(_vm.isExpanded)?_c('feather-icon',{attrs:{"icon":"chevron-up"}}):_c('feather-icon',{attrs:{"icon":"chevron-down"}})],1)]):_vm._e()]),_vm._v(" "),(_vm.contentsPinned)?_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.currentPageIndex, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.currentPageIndex, sectionIndex: 1});_vm.toggleContents();}}}):_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index, sectionIndex: 1});_vm.toggleContents();}}})]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"contents-item__sections",class:{'collapsed': !_vm.isExpanded}},_vm._l((_vm.page),function(section,sectionIndex){return (sectionIndex != 0)?_c('div',{key:(_vm.index) + '-' + (sectionIndex + 1),staticClass:"contents-item__subsection",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == sectionIndex}},[(_vm.contentsPinned)?_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index)+" - "+_vm._s(sectionIndex + 1))])]):_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index)+" - "+_vm._s(sectionIndex + 1))])]),_vm._v(" "),_c('div',{staticClass:"contents-section__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, sectionIndex)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}})]):_vm._e()})):_vm._e()])}
var ContentItem_staticRenderFns = []
var ContentItem_esExports = { render: ContentItem_render, staticRenderFns: ContentItem_staticRenderFns }
/* harmony default export */ var components_ContentItem = (ContentItem_esExports);
// CONCATENATED MODULE: ./src/components/ContentItem.vue
function ContentItem_injectStyle (ssrContext) {
  __webpack_require__("8oXI")
}
var ContentItem_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentItem___vue_template_functional__ = false
/* styles */
var ContentItem___vue_styles__ = ContentItem_injectStyle
/* scopeId */
var ContentItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentItem___vue_module_identifier__ = null
var ContentItem_Component = ContentItem_normalizeComponent(
  ContentItem,
  components_ContentItem,
  ContentItem___vue_template_functional__,
  ContentItem___vue_styles__,
  ContentItem___vue_scopeId__,
  ContentItem___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentItem = (ContentItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var ContentsPanel = ({
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon,
    ContentItem: src_components_ContentItem
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'titledPages', 'basePath', 'currentPage', 'showContents', 'contentsPinned']))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ee1b5e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentsPanel.vue
var ContentsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('nav',{staticClass:"contents-panel"},[(_vm.contentsPinned)?_c('ul',{staticClass:"contents-list"},_vm._l((_vm.titledPages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})})):_c('ul',{staticClass:"contents-list"},_vm._l((_vm.pages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})}))])])}
var ContentsPanel_staticRenderFns = []
var ContentsPanel_esExports = { render: ContentsPanel_render, staticRenderFns: ContentsPanel_staticRenderFns }
/* harmony default export */ var components_ContentsPanel = (ContentsPanel_esExports);
// CONCATENATED MODULE: ./src/components/ContentsPanel.vue
function ContentsPanel_injectStyle (ssrContext) {
  __webpack_require__("DE+O")
}
var ContentsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentsPanel___vue_template_functional__ = false
/* styles */
var ContentsPanel___vue_styles__ = ContentsPanel_injectStyle
/* scopeId */
var ContentsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentsPanel___vue_module_identifier__ = null
var ContentsPanel_Component = ContentsPanel_normalizeComponent(
  ContentsPanel,
  components_ContentsPanel,
  ContentsPanel___vue_template_functional__,
  ContentsPanel___vue_styles__,
  ContentsPanel___vue_scopeId__,
  ContentsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentsPanel = (ContentsPanel_Component.exports);

// CONCATENATED MODULE: ./src/helpers/modules/trackingHandler.js
/* harmony default export */ var trackingHandler = ({
  init: function init() {
    // Events

    //External Links clicked
    document.addEventListener('click', this.trackOutboundLinks, false);
    //Video Played
    //https://medium.com/@matt_west/track-html5-video-events-using-google-analytics-and-javascript-3be691b8bd45

  },
  trackOutboundLinks: function trackOutboundLinks(event) {
    if (event.target.tagName != 'A') return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Outbound Link',
        eventAction: 'Click',
        eventLabel: event.target.href,
        transport: 'beacon'
      });
    }
  },
  trackSearchTerms: function trackSearchTerms(searchTerm) {
    if (searchTerm == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Search',
        eventAction: 'Search',
        eventLabel: searchTerm
      });
    }
  },
  trackVideoPlay: function trackVideoPlay(filename) {
    if (filename == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Video',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  },
  trackAudioPlay: function trackAudioPlay(filename) {
    if (filename == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Audio',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SearchPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var SearchPanel = ({
  // TODO Highlight search text */

  data: function data() {
    return {
      searchText: '',
      searchResults: [],
      noResults: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'rightToLeft', 'basePath'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleSearch: 'TOGGLE_SEARCH'
  }), Object(vuex_esm["b" /* mapActions */])(['goToPage']), {
    // getBackgroundURL: (index) => "url(/static/_thumbs/"+(index)+"="+1+"-w140-h105.png)",
    // getBackgroundURL: (background) => 'url(/static/_content/'+ background +')',
    getBackgroundURL: function getBackgroundURL(background) {
      return this.basePath + '/static/_thumbs/' + background + '.png';
    },
    search: function search() {
      this.noResults = false;
      trackingHandler.trackSearchTerms(this.searchText);
      this.searchResults = window.search.search(this.searchText);
      if (this.searchResults.length == 0) {
        this.noResults = true;
      }
    },
    goToResultPage: function goToResultPage(pageIndex, sectionIndex) {
      this.goToPage({ pageIndex: pageIndex, sectionIndex: sectionIndex });
      this.toggleSearch();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-482838ad","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchPanel.vue
var SearchPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"search-fade"}},[_c('div',{staticClass:"search-container"},[_c('div',{staticClass:"search-panel"},[_c('div',{staticClass:"search-bar"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"search-input",attrs:{"type":"text","placeholder":"Search Publication"},domProps:{"value":(_vm.searchText)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"search-button",on:{"click":_vm.search}},[_c('feather-icon',{attrs:{"icon":"search"}})],1)]),_vm._v(" "),_c('transition-group',{staticClass:"search-results",attrs:{"name":"list","tag":"ul"}},_vm._l((_vm.searchResults),function(searchResult){return _c('li',{key:searchResult.id,staticClass:"search-result",on:{"click":function($event){_vm.goToResultPage(searchResult.pageIndex, searchResult.sectionIndex)}}},[_c('img',{staticClass:"search-result__image",attrs:{"src":_vm.getBackgroundURL(searchResult.thumb),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"search-result__text"},[_c('div',{staticClass:"search-result__title"},[_vm._v("\n            "+_vm._s(searchResult.id)+". "+_vm._s(searchResult.title)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"search-result__body"},[_vm._v("\n            "+_vm._s(searchResult.body)+"\n          ")])])])})),_vm._v(" "),(_vm.noResults)?_c('div',{attrs:{"id":"noResultsContainer"}},[_c('h2',[_vm._v("No results found. Please try again")])]):_vm._e()],1)])])}
var SearchPanel_staticRenderFns = []
var SearchPanel_esExports = { render: SearchPanel_render, staticRenderFns: SearchPanel_staticRenderFns }
/* harmony default export */ var components_SearchPanel = (SearchPanel_esExports);
// CONCATENATED MODULE: ./src/components/SearchPanel.vue
function SearchPanel_injectStyle (ssrContext) {
  __webpack_require__("opfQ")
}
var SearchPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SearchPanel___vue_template_functional__ = false
/* styles */
var SearchPanel___vue_styles__ = SearchPanel_injectStyle
/* scopeId */
var SearchPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SearchPanel___vue_module_identifier__ = null
var SearchPanel_Component = SearchPanel_normalizeComponent(
  SearchPanel,
  components_SearchPanel,
  SearchPanel___vue_template_functional__,
  SearchPanel___vue_styles__,
  SearchPanel___vue_scopeId__,
  SearchPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_SearchPanel = (SearchPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ExternalResource.vue
//
//
//
//

/* harmony default export */ var ExternalResource = ({
  props: ['source']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1f72b0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExternalResource.vue
var ExternalResource_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('script',{attrs:{"type":"application/javascript","src":_vm.source}})}
var ExternalResource_staticRenderFns = []
var ExternalResource_esExports = { render: ExternalResource_render, staticRenderFns: ExternalResource_staticRenderFns }
/* harmony default export */ var components_ExternalResource = (ExternalResource_esExports);
// CONCATENATED MODULE: ./src/components/ExternalResource.vue
var ExternalResource_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ExternalResource___vue_template_functional__ = false
/* styles */
var ExternalResource___vue_styles__ = null
/* scopeId */
var ExternalResource___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ExternalResource___vue_module_identifier__ = null
var ExternalResource_Component = ExternalResource_normalizeComponent(
  ExternalResource,
  components_ExternalResource,
  ExternalResource___vue_template_functional__,
  ExternalResource___vue_styles__,
  ExternalResource___vue_scopeId__,
  ExternalResource___vue_module_identifier__
)

/* harmony default export */ var src_components_ExternalResource = (ExternalResource_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PageDots.vue

//
//
//
//
//
//



/* harmony default export */ var PageDots = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentPages', 'width', 'height', 'zeroedPageIndex', 'zeroedSectionIndex', 'rightToLeft']), {
    styleObject: function styleObject() {
      var xTranslation = -(this.width / 2 + 20);
      var yTranslation = -(this.height / 2 - 5);
      if (this.rightToLeft) {
        xTranslation = this.width / 2;
      }
      return {
        transform: 'translate(' + xTranslation + 'px, ' + yTranslation + 'px)',
        width: '20px'
      };
    }
  }),
  methods: {
    activePage: function activePage(page) {
      if (this.zeroedPageIndex == page.pageIndex && this.zeroedSectionIndex == page.sectionIndex) return true;
      return false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-745923cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageDots.vue
var PageDots_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-dots",style:(_vm.styleObject)},_vm._l((_vm.currentPages),function(page,index){return _c('div',{key:index,staticClass:"page-dot",class:{'page-dot--active': _vm.activePage(page)}})}))}
var PageDots_staticRenderFns = []
var PageDots_esExports = { render: PageDots_render, staticRenderFns: PageDots_staticRenderFns }
/* harmony default export */ var components_PageDots = (PageDots_esExports);
// CONCATENATED MODULE: ./src/components/PageDots.vue
function PageDots_injectStyle (ssrContext) {
  __webpack_require__("pXbK")
}
var PageDots_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PageDots___vue_template_functional__ = false
/* styles */
var PageDots___vue_styles__ = PageDots_injectStyle
/* scopeId */
var PageDots___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageDots___vue_module_identifier__ = null
var PageDots_Component = PageDots_normalizeComponent(
  PageDots,
  components_PageDots,
  PageDots___vue_template_functional__,
  PageDots___vue_styles__,
  PageDots___vue_scopeId__,
  PageDots___vue_module_identifier__
)

/* harmony default export */ var src_components_PageDots = (PageDots_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/VideoContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var VideoContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['videoURL', 'isDoublePage']), {
    isYoutube: function isYoutube() {
      return this.videoURL.search('youtube') !== -1;
    },
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0eb99c71","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoContainer.vue
var VideoContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[(_vm.isYoutube)?_c('div',{attrs:{"id":"video-container"}},[_c('div',{staticClass:"embed-container"},[_c('iframe',{attrs:{"id":"video","width":"854","height":"480","src":_vm.videoURL,"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2):_c('div',{attrs:{"id":"video-container"}},[_c('video',{attrs:{"id":"video","src":_vm.videoURL,"autoplay":"","controls":"controls","width":"967","height":"544"}},[_c('source',{attrs:{"src":_vm.videoURL,"type":"video/mp4"}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var VideoContainer_staticRenderFns = []
var VideoContainer_esExports = { render: VideoContainer_render, staticRenderFns: VideoContainer_staticRenderFns }
/* harmony default export */ var components_VideoContainer = (VideoContainer_esExports);
// CONCATENATED MODULE: ./src/components/VideoContainer.vue
function VideoContainer_injectStyle (ssrContext) {
  __webpack_require__("P1S/")
}
var VideoContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var VideoContainer___vue_template_functional__ = false
/* styles */
var VideoContainer___vue_styles__ = VideoContainer_injectStyle
/* scopeId */
var VideoContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VideoContainer___vue_module_identifier__ = null
var VideoContainer_Component = VideoContainer_normalizeComponent(
  VideoContainer,
  components_VideoContainer,
  VideoContainer___vue_template_functional__,
  VideoContainer___vue_styles__,
  VideoContainer___vue_scopeId__,
  VideoContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_VideoContainer = (VideoContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GalleryContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GalleryContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["galleryImages", "galleryCaptions", "basePath", "galleryIndex", "isDoublePage"]), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    nextOptions: function nextOptions() {
      return {
        width: 50,
        height: 50
      };
    },
    prevOptions: function prevOptions() {
      return {
        class: "r180",
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobileNextOptions: function mobileNextOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobilePrevOptions: function mobilePrevOptions() {
      return {
        class: "r180",
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27efe336","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GalleryContainer.vue
var GalleryContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"gallery-container"}},[(_vm.isDoublePage)?[_c('feather-icon',{attrs:{"id":"gallery-next","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.nextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.prevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('feather-icon',{attrs:{"id":"gallery-next-mobile","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.mobileNextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous-mobile","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.mobilePrevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close-mobile","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)],_vm._v(" "),_vm._l((_vm.galleryImages),function(image,index){return _c('img',{class:{'active': index == _vm.galleryIndex, 'inactive': index != _vm.galleryIndex},attrs:{"src":_vm.basePath + '/static/_content/' + image,"alt":""}})}),_vm._v(" "),_c('div',{staticClass:"gallery-captions"},[(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])?_c('p',{staticClass:"gallery-caption"},[_vm._v("\n        "+_vm._s(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"gallery-dots"},_vm._l((_vm.galleryImages),function(image,index){return _c('div',{staticClass:"gallery-dot",class:{'gallery-dot--active': index == _vm.galleryIndex}})}))],2)])}
var GalleryContainer_staticRenderFns = []
var GalleryContainer_esExports = { render: GalleryContainer_render, staticRenderFns: GalleryContainer_staticRenderFns }
/* harmony default export */ var components_GalleryContainer = (GalleryContainer_esExports);
// CONCATENATED MODULE: ./src/components/GalleryContainer.vue
function GalleryContainer_injectStyle (ssrContext) {
  __webpack_require__("u/WO")
}
var GalleryContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GalleryContainer___vue_template_functional__ = false
/* styles */
var GalleryContainer___vue_styles__ = GalleryContainer_injectStyle
/* scopeId */
var GalleryContainer___vue_scopeId__ = "data-v-27efe336"
/* moduleIdentifier (server only) */
var GalleryContainer___vue_module_identifier__ = null
var GalleryContainer_Component = GalleryContainer_normalizeComponent(
  GalleryContainer,
  components_GalleryContainer,
  GalleryContainer___vue_template_functional__,
  GalleryContainer___vue_styles__,
  GalleryContainer___vue_scopeId__,
  GalleryContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GalleryContainer = (GalleryContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GuideContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GuideContainer = ({
    name: 'guide',
    components: {
        FeatherIcon: src_components_FeatherIcon
    },
    computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
        sectionIndices: function sectionIndices(state) {
            return state.sectionIndices;
        }
    }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomNavEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "isMobile", "fullscreenEnabled"]))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b990a520","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GuideContainer.vue
var GuideContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"guide-container"}},[_c('div',{attrs:{"id":"guide-page"}},[_c('div',{staticClass:"guide-title"},[_c('h4',[_vm._v("User Guide")])]),_vm._v(" "),_c('ul',{staticClass:"guide-items"},[_c('li',[_c('div',[_c('feather-icon',{staticClass:"guide-icons guide-navigation-prev",attrs:{"icon":"play"}}),_vm._v(" "),(_vm.isMobile && !(_vm.sectionIndices.length == 0))?_c('feather-icon',{staticClass:"guide-icons guide-navigation-down",attrs:{"icon":"play"}}):_vm._e(),_vm._v(" "),_c('feather-icon',{staticClass:"guide-icons guide-navigation-next",attrs:{"icon":"play"}})],1),_vm._v(" "),(_vm.isMobile)?_c('p',[_vm._v("Navigate using the arrows or by swiping")]):_c('p',[_vm._v("Navigate using arrows, your keyboard or by dragging the page")])]),_vm._v(" "),(_vm.zoomNavEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"zoom-in"}}),_vm._v(" "),_c('p',[_vm._v("Zoom in and out")])],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"search"}}),_vm._v(" "),_c('p',[_vm._v("Search for words or phrases")])],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"globe"}}),_vm._v(" "),_c('p',[_vm._v("Change language")])],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"download"}}),_vm._v(" "),_c('p',[_vm._v("Download PDF")])],1):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"printer"}}),_vm._v(" "),_c('p',[_vm._v("Print PDF")])],1):_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"grid"}}),_vm._v(" "),_c('p',[_vm._v("Content navigation")])],1):_vm._e(),_vm._v(" "),(_vm.fullscreenEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"maximize-2"}}),_vm._v(" "),_c('p',[_vm._v("Toggle fullscreen")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"viewBox":"0 0 160.62 157.733","enable-background":"new 0 0 160.62 157.733"}},[_c('g',[_c('path',{attrs:{"fill":"#000","d":"M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477\n\t\t\t\t\t\t\t\t\t\tc-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218\n\t\t\t\t\t\t\t\t\t\tc-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945\n\t\t\t\t\t\t\t\t\t\th85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2\n\t\t\t\t\t\t\t\t\t\tc-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z\n\t\t\t\t\t\t\t\t\t\tM123.685,63.134h-20.209v-5.966h20.209V63.134z"}})]),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#000","d":"M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633\n\t\t\t\t\t\t\t\t\t\tc-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29\n\t\t\t\t\t\t\t\t\t\tc-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026\n\t\t\t\t\t\t\t\t\t\tc0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471\n\t\t\t\t\t\t\t\t\t\tc6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404\n\t\t\t\t\t\t\t\t\t\tc3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7\n\t\t\t\t\t\t\t\t\t\tc-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0\n\t\t\t\t\t\t\t\t\t\tC70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648\n\t\t\t\t\t\t\t\t\t\tc-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694\n\t\t\t\t\t\t\t\t\t\tc6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2\n\t\t\t\t\t\t\t\t\t\tc14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856\n\t\t\t\t\t\t\t\t\t\tL154.856,78.867z"}})])]),_vm._v(" "),_c('p',[_vm._v("Image gallery")])]),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"675px","height":"675px","viewBox":"0 0 675 675","enable-background":"new 0 0 675 675","xml:space":"preserve"}},[_c('circle',{attrs:{"fill":"none","stroke":"#000","stroke-width":"30","stroke-miterlimit":"10","cx":"339.195","cy":"340","r":"321"}}),_vm._v(" "),_c('polyline',{attrs:{"fill":"#000","points":"558,356 207,563 207,117 "}})]),_vm._v(" "),_c('p',[_vm._v("Video")])]),_vm._v(" "),(_vm.guideEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"help-circle"}}),_vm._v(" "),_c('p',[_vm._v("User guide")])],1):_vm._e()])])])])}
var GuideContainer_staticRenderFns = []
var GuideContainer_esExports = { render: GuideContainer_render, staticRenderFns: GuideContainer_staticRenderFns }
/* harmony default export */ var components_GuideContainer = (GuideContainer_esExports);
// CONCATENATED MODULE: ./src/components/GuideContainer.vue
function GuideContainer_injectStyle (ssrContext) {
  __webpack_require__("biBg")
}
var GuideContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GuideContainer___vue_template_functional__ = false
/* styles */
var GuideContainer___vue_styles__ = GuideContainer_injectStyle
/* scopeId */
var GuideContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GuideContainer___vue_module_identifier__ = null
var GuideContainer_Component = GuideContainer_normalizeComponent(
  GuideContainer,
  components_GuideContainer,
  GuideContainer___vue_template_functional__,
  GuideContainer___vue_styles__,
  GuideContainer___vue_scopeId__,
  GuideContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GuideContainer = (GuideContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AudioContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var AudioContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['audioURL', 'isDoublePage']), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12525ca8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AudioContainer.vue
var AudioContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"audio-container"}},[_c('audio',{staticStyle:{"width":"300px","height":"36px"},attrs:{"controls":"","controlsList":"nodownload","autoplay":"","preload":"metadata"}},[_c('source',{attrs:{"src":_vm.audioURL,"type":"audio/mp3"}}),_vm._v("\n      Your browser does not support the audio element.\n    ")]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"audio-close","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"audio-close-mobile","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var AudioContainer_staticRenderFns = []
var AudioContainer_esExports = { render: AudioContainer_render, staticRenderFns: AudioContainer_staticRenderFns }
/* harmony default export */ var components_AudioContainer = (AudioContainer_esExports);
// CONCATENATED MODULE: ./src/components/AudioContainer.vue
function AudioContainer_injectStyle (ssrContext) {
  __webpack_require__("NXlJ")
}
var AudioContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var AudioContainer___vue_template_functional__ = false
/* styles */
var AudioContainer___vue_styles__ = AudioContainer_injectStyle
/* scopeId */
var AudioContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AudioContainer___vue_module_identifier__ = null
var AudioContainer_Component = AudioContainer_normalizeComponent(
  AudioContainer,
  components_AudioContainer,
  AudioContainer___vue_template_functional__,
  AudioContainer___vue_styles__,
  AudioContainer___vue_scopeId__,
  AudioContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_AudioContainer = (AudioContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















/* harmony default export */ var App = ({
  name: 'app',
  components: {
    PublishPage: src_components_PublishPage,
    NavigationBar: src_components_NavigationBar,
    NavigationLink: src_components_NavigationLink,
    ExternalResource: src_components_ExternalResource,
    ContentsPanel: src_components_ContentsPanel,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel,
    SearchPanel: src_components_SearchPanel,
    PageDots: src_components_PageDots,
    GalleryContainer: src_components_GalleryContainer,
    MobileContainer: components_mobile_MobileContainer,
    VideoContainer: src_components_VideoContainer,
    GuideContainer: src_components_GuideContainer,
    MobileLink: src_components_MobileLink,
    AudioContainer: src_components_AudioContainer
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['title', 'description', 'width', 'height', 'visiblePages', 'currentPage', 'previousPage', 'nextPage', 'nextNextPage', 'previousPreviousPage', 'previousPageURI', 'nextPageURI', 'previousSection', 'nextSection', 'previousSectionURI', 'nextSectionURI', 'previousMobilePage', 'nextMobilePage', 'previousMobilePageURI', 'nextMobilePageURI', 'externalResources', 'searchObject', 'pageScripts', 'documentScript', 'zoomLevel', 'pageContainerStyle', 'rightToLeft', 'isMobile', 'mobileSwitch', 'videoURL', 'showContents', 'contentsPinned', 'showLanguages', 'showSearch', 'showGuide', 'showEditions', 'isZoomed', 'isIE11', 'isPhantom', 'companyLogo', 'publishURL', 'galleryImages', 'galleryCaptions', 'isDoublePage', 'audioURL', 'isMobileFontLarge'])),
  mounted: function mounted() {
    var _this = this;

    // console.log('mounted app component')
    this.setTitle();
    this.setDescription();
    if (this.publishURL != '') this.setOGImage();
    if (!(this.isMobile && this.mobileSwitch || this.isPhantom)) {
      this.loadScripts();
      window.addEventListener("load", function (event) {
        var p = parseInt(Publish.currentPage.pageIndex);
        var s = parseInt(Publish.currentPage.sectionIndex);
        if (window["p" + p + "s" + s + "onPageEnter"]) {
          window["p" + p + "s" + s + "onPageEnter"]();
        }
      });
      this.buildSearchIndex();
      this.resetSectionIndices();
      // this.changeSize()
    }
    if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
      this.setInitialWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
      this.changeWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
    } else if (document.documentElement.dataset.mobile == "android") {
      this.setInitialWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
      this.changeWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
    } else {
      this.changeWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener("orientationchange", function () {
      if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
        _this.setInitialWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
        _this.changeWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
      } else {
        _this.setInitialWindowSize({
          width: screen.width,
          height: screen.height
        });
        _this.changeWindowSize({
          width: screen.width,
          height: screen.height
        });
      }
    });
  },

  watch: {
    currentPage: function currentPage(oldPage, newPage) {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
    }
  },
  methods: extends_default()({
    setTitle: function setTitle() {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
      var meta = document.createElement('meta');
      meta.name = "og:title";
      meta.content = newTitle;
      meta.setAttribute('property', 'og:title');
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    setDescription: function setDescription() {
      var newDescription = this.description;
      if (this.currentPage.searchText && this.currentPage.searchText.length > 0) {
        newDescription = this.currentPage.searchText.substr(0, 250);
      }
      var meta = document.createElement('meta');
      meta.name = "description";
      meta.content = newDescription;
      document.getElementsByTagName('head')[0].appendChild(meta);
      var og = document.createElement('meta');
      og.name = "og:description";
      og.content = newDescription;
      og.setAttribute('property', 'og:description');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    setOGImage: function setOGImage() {
      var og = document.createElement('meta');
      og.name = "og:image";
      og.content = this.publishURL + (this.currentPage.index + 1) + '.png';
      og.setAttribute('property', 'og:image');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    buildSearchIndex: function buildSearchIndex() {
      window.search = new commonjs["Search"]('id');
      window.search.searchIndex = new commonjs["UnorderedSearchIndex"]();
      window.search.addIndex('title');
      window.search.addIndex('body');
      window.search.addDocuments(this.searchObject);
    },
    changeSize: function changeSize() {
      // if(this.currentPage.pageIndex == 0){
      //   this.changePageSize({
      //     double: true
      //   })
      // } else {
      //   this.changePageSize({
      //     double: false
      //   })
      // }
    },
    loadScripts: function loadScripts() {
      this.loadDocumentScript();
      this.loadPageScript();
      this.loadAddThis();
    },
    loadDocumentScript: function loadDocumentScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.documentScript);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadPageScript: function loadPageScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.pageScripts);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadAddThis: function loadAddThis() {
      if (!this.isMobile) {
        var addthisScript = document.createElement('script');
        addthisScript.setAttribute('src', 'https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5a2eb48d8548953f');
        document.body.appendChild(addthisScript);
      }
    }
  }, Object(vuex_esm["b" /* mapActions */])(['goToPage', 'goToNextPage', 'goToPreviousPage', 'goToNextSection', 'goToPreviousSection', 'resetSectionIndices', 'checkMobileLanding', 'goToPreviousMobilePage', 'goToNextMobilePage', 'changeWindowSize', 'setInitialWindowSize', 'changePageSize']), {
    onLeave: function onLeave(el) {
      el.style.opacity = 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a8ce84ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{class:{'right-to-left': _vm.rightToLeft, 'mobile': _vm.isMobile, 'zoomed': _vm.isZoomed, 'mobile-switch': _vm.mobileSwitch, 'mobile-font-large': _vm.isMobileFontLarge, 'ie11': _vm.isIE11, 'reader': _vm.isReader, 'doublePage': _vm.isDoublePage},attrs:{"id":"app"}},[(_vm.isPhantom)?[_c('img',{staticClass:"logo-loading centre",attrs:{"src":_vm.companyLogo,"alt":""}})]:[_c('navigation-bar',{ref:"navBar",attrs:{"title":_vm.title,"page":_vm.currentPage.title}}),_vm._v(" "),((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader)?[_c('mobile-container'),_vm._v(" "),(_vm.isReader)?[(_vm.previousMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToPreviousMobilePage,"rotation":"180","width":"25","height":"25","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToNextMobilePage,"width":"25","height":"25","classes":"navigation-link--next"}}):_vm._e()]:_vm._e()]:[_c('transition-group',{class:{contentsPinned: _vm.contentsPinned},style:(_vm.pageContainerStyle),attrs:{"name":"pages","tag":"div","id":"page-container"},on:{"leave":_vm.onLeave}},[_c('page-dots',{key:"page-dots"}),_vm._v(" "),_vm._l((_vm.visiblePages),function(page,key){return (page)?_c('publish-page',{key:page.pageIndex + 'a' + page.sectionIndex,attrs:{"classes":key,"page":page,"width":(page.pageIndex == 0 || page.pageIndex == 1) ? _vm.width * 2 : _vm.width,"height":_vm.height,"double":_vm.isDoublePage}}):_vm._e()})],2),_vm._v(" "),((_vm.isMobile && !_vm.isDoublePage))?[(_vm.previousPageURI)?_c('navigation-link',{attrs:{"to":_vm.previousPageURI,"rotation":"180","width":"25","height":"25","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.previousSectionURI)?_c('navigation-link',{attrs:{"to":_vm.previousSectionURI,"rotation":"270","classes":"navigation-link--up"}}):_vm._e(),_vm._v(" "),(_vm.nextPageURI)?_c('navigation-link',{class:[_vm.contentsPinned ? 'navigation-link--next__contents' : 'navigation-link--next'],attrs:{"to":_vm.nextPageURI,"width":"25","height":"25"}}):_vm._e(),_vm._v(" "),(_vm.nextSectionURI)?_c('navigation-link',{attrs:{"to":_vm.nextSectionURI,"rotation":"90","classes":"navigation-link--down"}}):_vm._e()]:[(_vm.previousPageURI)?_c('navigation-link',{attrs:{"to":_vm.previousPageURI,"rotation":"180","width":"50","height":"50","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.previousSectionURI)?_c('navigation-link',{attrs:{"to":_vm.previousSectionURI,"rotation":"270","classes":"navigation-link--up"}}):_vm._e(),_vm._v(" "),(_vm.nextPageURI)?_c('navigation-link',{class:[_vm.contentsPinned ? 'navigation-link--next__contents' : 'navigation-link--next'],attrs:{"to":_vm.nextPageURI,"width":"50","height":"50"}}):_vm._e(),_vm._v(" "),(_vm.nextSectionURI)?_c('navigation-link',{attrs:{"to":_vm.nextSectionURI,"rotation":"90","classes":"navigation-link--down"}}):_vm._e()],_vm._v(" "),_c('contents-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}]}),_vm._v(" "),_c('search-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearch),expression:"showSearch"}]}),_vm._v(" "),_c('guide-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGuide),expression:"showGuide"}]}),_vm._v(" "),_vm._l((_vm.externalResources),function(resource){return (_vm.externalResources.length > 0)?_c('external-resource',{key:resource,attrs:{"source":resource}}):_vm._e()})]],_vm._v(" "),(_vm.videoURL != '')?_c('video-container'):_vm._e(),_vm._v(" "),(_vm.galleryImages.length)?_c('gallery-container'):_vm._e(),_vm._v(" "),(_vm.audioURL !=  '')?_c('audio-container'):_vm._e()],2)])}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("5kmU")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/store/mutation-types.js
// Toggles for panels/overlays/zoom
var TOGGLE_CONTENTS = 'TOGGLE_CONTENTS';
var TOGGLE_LANGUAGES = 'TOGGLE_LANGUAGES';
var TOGGLE_GUIDE = 'TOGGLE_GUIDE';
var TOGGLE_EDITIONS = 'TOGGLE_EDITIONS';
var TOGGLE_FONT_SIZE = 'TOGGLE_FONT_SIZE';

var TOGGLE_ZOOM = 'TOGGLE_ZOOM';
var UPDATE_ZOOM = 'UPDATE_ZOOM';
var SLIDE_ZOOM = 'SLIDE_ZOOM';

var TOGGLE_SEARCH = 'TOGGLE_SEARCH';
var TOGGLE_READER = 'TOGGLE_READER';
var TOGGLE_FULLSCREEN = 'TOGGLE_FULLSCREEN';
var UPDATE_FULLSCREEN = 'UPDATE_FULLSCREEN';

var RESET_SECTION_INDICES = 'RESET_SECTION_INDICES';
var CHANGE_SECTION_INDEX = 'CHANGE_SECTION_INDEX';
var UPDATE_INITIAL_WINDOW_SIZE = 'UPDATE_INITIAL_WINDOW_SIZE';
var UPDATE_PAGE_SCALE = 'UPDATE_PAGE_SCALE';
var UPDATE_VIDEO_URL = 'UPDATE_VIDEO_URL';
var UPDATE_AUDIO_URL = 'UPDATE_AUDIO_URL';
var UPDATE_IS_DOUBLE_PAGE = 'UPDATE_IS_DOUBLE_PAGE';
var UPDATE_GALLERY = 'UPDATE_GALLERY';
var UPDATE_GALLERY_INDEX = 'UPDATE_GALLERY_INDEX';
var UPDATE_CONTENT_PANEL = 'UPDATE_CONTENT_PANEL';
var UPDATE_IS_FRONT_PAGE = 'UPDATE_IS_FRONT_PAGE';
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/document.js
/* harmony default export */ var src_document = ({
  "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
  "title": "Cartier Philanthropy for People and Nature ⎯ Annual Report 2025-2026",
  "shortTitle": "",
  "description": "",
  "width": 737,
  "height": 917,
  "currentLanguage": "EN",
  "languages": [],
  // "basePath": "",
  "basePath": "/AR2025-26",
  "companyLogo": "logo.png",
  "publishURL": "https://reports.cartierphilanthropy.org/AR2025-26/static/_thumbs/",
  "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  "options": {
    "doublePage": true,
    "rightToLeft": false,
    "searchEnabled": true,
    "downloadEnabled": true,
    "downloadPath": '/AR2025-26/static/_content/Cartier-Philanthropy-Annual-Report-2025-2026.pdf',
    "printEnabled": false,
    "zoom": {
      "navEnabled": false,
      "sliderEnabled": true,
      "clickEnabled": true,
      "scrollEnabled": true
    },
    "contents": {
      "enabled": true,
      "pinned": false,
      "numbers": true,
      "titles": true
    },
    "languagesEnabled": false,
    "editionsEnabled": false,
    "mobileSwitch": false,
    "guideEnabled": false,
    "galleryCaptions": {},
    "fullscreenEnabled": true
  },
  "pages": [[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 0,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg0.jpg",
    "zoom": null,
    "content": "\n      <img class=\"abs halfScaleC cover-logo\" style=\"top:15px;left:850px;\" src=\"/AR2025-26/static/_content/cover-logo-1.png\"/>\n      <img class=\"abs halfScaleC cover-title\" style=\"top:237px;left:939px;\" src=\"/AR2025-26/static/_content/cover-title-1.png\"/>\n      <img class=\"abs halfScaleC cover-title\" style=\"top:260px;left:1012px;\" src=\"/AR2025-26/static/_content/cover-title-2.png\"/>\n\n        ",
    "script": "\n          function onPageEnter() {\n            pgCoverAnim = new TimelineMax();\n            pgCoverAnim.fromTo(cOf(\"cover-logo\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1)\n            .staggerFromTo(cOf(\"cover-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1.2);\n          }\n\n          function onPageLeave() {\n            pgCoverAnim.stop();\n          }\n      ",
    "searchText": "ANNUAL REPORT 2025 - 2026"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 1,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg1.jpg",
    "zoom": null,
    "content": "\n      <img class=\"abs halfScaleC content-title\" style=\"top:128px;left:886px;\" src=\"/AR2025-26/static/_content/content-title-1.png\"/>\n      <img class=\"abs halfScaleC content-title\" style=\"top:376px;left:47px;\" src=\"/AR2025-26/static/_content/content-title-2.png\"/>\n      <img class=\"abs halfScaleC content-line\" style=\"top:457px;left:-34px;\" src=\"/AR2025-26/static/_content/content-line-1.png\"/>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top: 173px;left: 963px;width: 429px;height: 60px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(3);\" style=\"top:239px; left:963px; width:429px; height:60px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(4);\" style=\"top:305px; left:963px; width:429px; height:60px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(6);\" style=\"top:375px; left:963px; width:429px; height:60px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(8);\" style=\"top:443px; left:963px; width:429px; height:60px;\"></div>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(10);\" style=\"top:514px; left:963px; width:429px; height:50px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(12);\" style=\"top:565px; left:963px; width:429px; height:18px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(26);\" style=\"top:585px; left:963px; width:429px; height:32px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(40);\" style=\"top:618px; left:963px; width:429px; height:18px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(54);\" style=\"top:637px; left:963px; width:429px; height:18px;\"></div>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(60);\" style=\"top:669px; left:963px; width:429px; height:60px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(64);\" style=\"top:732px; left:963px; width:429px; height:60px;\"></div>\n\n        ",
    "script": "\n          function onPageEnter() {\n            pgContentAnim = new TimelineMax();\n            pgContentAnim.staggerFromTo(cOf(\"content-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n            .fromTo(cOf(\"content-line\"), 0.4, {opacity:0, x: -40}, {opacity: 1, x: 0, ease: Power2.easeOut, onComplete: addContentLinks}, 1.2)\n          }\n\n          function onPageLeave() {\n            pgContentAnim.stop();\n            pg2Anim.stop();\n            removeContentLinks();\n          }\n      ",
    "searchText": "CREATING THE CONDITIONS FOR VULNERABLE COMMUNITIES AND ECOSYSTEMS TO THRIVE CONTENTS  2  Message from the President of the Board  3  Strategic Advisor's Message  4 Who we are  6 How we work  8  Focus areas  10  A Year of Partnership Unlocking women's potential, transforming communities 12 Investing in sustainable livelihoods and craftsmanship, building opportunities 26 Protecting nature, fostering resilience 40 Responding to emergencies, sustaining life 54  60  Strengthening organisations, deepening impact  64  All our partners during the financial year 2026  1"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 2,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg2.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScaleC 2-img-1\" style=\"top:13px;left:217px;\" src=\"/AR2025-26/static/_content/2-img-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          \n          if(!Publish.isDoublePage){\n          pg2Anim = new TimelineMax();\n          pg2Anim.fromTo(cOf(\"2-img-1\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1)\n          } else {\n            pg2Anim = new TimelineMax();\n          }\n        }\n\n        function onPageLeave() {\n          pg2Anim.stop();\n        }\n      ",
    "searchText": "MESSAGE FROM THE PRESIDENT OF THE BOARD Luxury starts where necessity ends. It is sometimes questioned. Is it right to spend resources to create what is not even necessary? For many, the answer is yes. A profound aspect of what makes us human is our capacity to go beyond necessity and make things that are simply beautiful. This impulse to constantly try to make life better and more pleasant is a powerful human characteristic. It is also deeply human to cooperate, at scale, and shape the world. Our sense of wellbeing and happiness often emerges from experiences that transcend mere necessity: love, art, beauty, travels, shared experiences. Jewellers work with precious and rare materials. They know their value, their rarity. They create what lasts, what outlives us. They love to share these creations, hoping they will be cherished for their artistry and enduring beauty. They work within the eternity of precious stones, forged by the Earth over millions of years. Cartier is the magician of the real world, transforming intangible feelings into concrete objects of desire. Cartier sees beauty wherever it may lie. Yet the Maison also sees what needs to be protected and preserved, what needs to be nurtured, and what needs to be mended and repaired. This applies both individually and collectively. Today, we are encouraged by a growing movement across philanthropy, civil society, business and public institutions that embraces this collective responsibility. We recognise that the most meaningful progress is born of collaboration, strengthened by mutual respect. This is the spirit that guides Cartier Philanthropy for People and Nature. Across every partnership, we witness courage with humility, as well as determination with respect for the people and ecosystems they serve. It is both a privilege and a responsibility to stand beside our partners who act every day. Patiently. Respectfully. Cyrille Vigneron Cartier Chairman of Culture and Philanthropy  2"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 3,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg3.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScaleC 3-img-1\" style=\"top:13px;left:207px;\" src=\"/AR2025-26/static/_content/3-img-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          if(!Publish.isDoublePage){\n            pg3Anim = new TimelineMax();\n            pg3Anim.fromTo(cOf(\"3-img-1\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1)\n            \n          } else {\n            pg3Anim = new TimelineMax();\n            pg3Anim.fromTo(cOf(\"3-img-1\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1)\n          .fromTo(cOf(\"2-img-1\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1)\n            }\n        }\n\n        function onPageLeave() {\n          pg3Anim.stop();\n        }\n      ",
    "searchText": "STRATEGIC ADVISOR'S MESSAGE Last year, much of the social sector was shaken by the scale and speed of the contraction in international development funding. The consequences across public health, education, food security, livelihoods, and conservation were immediate, deep and harrowing, both for non-profit organisations and for the communities they serve. This unprecedented situation brought the fragility of the global system of aid and development into stark relief. However, throughout this year, we have seen the emergence of robust strategies of iteration, adaptation, prioritisation and resilience. Across the sector, organisations are rethinking their models, embracing stronger community leadership, greater cost discipline, organisational redesign, funding diversification and closer collaboration. Many of the partners who were grappling with this upheaval are now showing us the way forward. In spite of intensifying conflicts, accelerating impacts of climate change and deepening inequality, our partners are forging ahead, refining their solutions, using resources ever more effectively and working more closely with governments and other partners, all in pursuit of a shared ambition: achieving the scale of positive social and environmental impact that today's challenges demand. In our conversations, many inspiring non-profit founders and leaders reminded me that human beings are at the centre of everything they – and we - do: whether within their teams, alongside partner communities or across government institutions. Investing in deep and enduring human connections remains the most important decision we need to make. This annual report – like those that came before it – serves as a tribute to the dedicated individuals behind the hard work and achievements of our portfolio organisations. Its publication arrives at a meaningful moment for our foundation. The recent consolidation of Cartier Philanthropy and Cartier for Nature into Cartier Philanthropy for People and Nature embodies a conviction that has long guided our work: that the futures of people and nature are inseparable. Enjoy the read! Pascale de la Frégonnière Strategic Advisor to the Board  3"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 4,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg4.jpg",
    "zoom": null,
    "content": "\n      <img class=\"abs halfScaleC 4-text\" style=\"top:91px;left:-30px;\" src=\"/AR2025-26/static/_content/4-text-1.png\"/>\n      <img class=\"abs halfScaleC 4-text\" style=\"top:92px;left:-87px;\" src=\"/AR2025-26/static/_content/4-text-2.png\"/>\n\n        ",
    "script": "\n          function onPageEnter() {\n            pg4Anim = new TimelineMax();\n            pg4Anim.staggerFromTo(cOf(\"4-text\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1);\n          }\n\n          function onPageLeave() {\n            pg4Anim.stop();\n          }\n      ",
    "searchText": "WHO WE ARE Cartier Philanthropy for People and Nature is Cartier's philanthropic foundation  4"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 5,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg5.jpg",
    "zoom": null,
    "content": "\n      <img class=\"abs halfScale 5-text\" style=\"top:147px;left:91px;\" src=\"/AR2025-26/static/_content/5-text-1.png\"/>\n      <img class=\"abs halfScale 5-text\" style=\"top:183px;left:90px;\" src=\"/AR2025-26/static/_content/5-text-2.png\"/>\n      <img class=\"abs halfScale 5-text\" style=\"top:375px;left:195px;\" src=\"/AR2025-26/static/_content/5-text-3.png\"/>\n      <img class=\"abs halfScale 5-text\" style=\"top:385px;left:128px;\" src=\"/AR2025-26/static/_content/5-text-4.png\"/>\n      <img class=\"abs halfScale 5-text\" style=\"top:465px;left:128px;\" src=\"/AR2025-26/static/_content/5-text-5.png\"/>\n      <img class=\"abs halfScale 5-text\" style=\"top:630px;left:90px;\" src=\"/AR2025-26/static/_content/5-text-6.png\"/>\n      <img class=\"abs halfScale 5-text\" style=\"top:703px;left:122px;\" src=\"/AR2025-26/static/_content/5-text-7.png\"/>\n      <img class=\"abs halfScale 5-text\" style=\"top:737px;left:122px;\" src=\"/AR2025-26/static/_content/5-text-8.png\"/>\n      <img class=\"abs halfScale 5-text\" style=\"top:771px;left:122px;\" src=\"/AR2025-26/static/_content/5-text-9.png\"/>\n      <img class=\"abs halfScale 5-text\" style=\"top:805px;left:122px;\" src=\"/AR2025-26/static/_content/5-text-10.png\"/>\n\n        ",
    "script": "\n          function onPageEnter() {\n            pg5Anim = new TimelineMax();\n            pg5Anim.staggerFromTo(cOf(\"5-text\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1);\n          }\n\n          function onPageLeave() {\n            pg5Anim.stop();\n          }\n      ",
    "searchText": "Our vision is a world where people and nature can thrive. When people can rely on the Earth's vital natural resources, along with access to effective healthcare, quality education and sustainable livelihoods, they are empowered to realise their potential and thrive. They are then better equipped to nurture and conserve nature's rich ecosystems which underpin the health of the planet that sustains us all.  O ur missi o n i s t o h e lp cr e at e  t he c onditions fo r v u ln e r able co m m u n i t i e s an d eco sy st e m s t o t h r i v e . We partner with non-profit organisations that share our values and deliver positive measurable results for people and nature. We provide financial and non-financial support to achieve our shared ambitions. Our work is not restricted to any region but addresses situations of vulnerability where the potential for social and environmental impact is high.  C a rti er P hilanthrop y fo r P e o p le an d Nat u r e i s g uided by the fo llo wi n g co r e  v al u es:  Respect that is shown for the communities we engage with Trust that shapes the relationships we build with our partners Integrity that drives our commitment to accountability and continuous improvement Compassion that urges us to create a fairer world 5"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 6,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg6.jpg",
    "zoom": null,
    "content": "\n      <img class=\"abs halfScale 6-text\" style=\"top:157px;left:282px;\" src=\"/AR2025-26/static/_content/6-title-1.png\"/>\n\n        ",
    "script": "\n          function onPageEnter() {\n            pg6Anim = new TimelineMax();\n            pg6Anim.fromTo(cOf(\"6-text\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1);\n          }\n\n          function onPageLeave() {\n            pg6Anim.stop();\n          }\n      ",
    "searchText": "HOW WE WORK 6"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 7,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg7.jpg",
    "zoom": null,
    "content": "\n      <img class=\"abs halfScale 7-text\" style=\"top:90px;left:90px;\" src=\"/AR2025-26/static/_content/7-text-1.png\"/>\n      <img class=\"abs halfScale 7-text\" style=\"top:280px;left:89px;\" src=\"/AR2025-26/static/_content/7-text-2.png\"/>\n\n      <img class=\"abs halfScaleC 7-text-2\" style=\"top:397px;left:-121px;\" src=\"/AR2025-26/static/_content/7-text-3.png\"/>\n      <img class=\"abs halfScaleC 7-text-2\" style=\"top:355px;left:-80px;\" src=\"/AR2025-26/static/_content/7-text-4.png\"/>\n      <img class=\"abs halfScaleC 7-text-2\" style=\"top:315px;left:7px;\" src=\"/AR2025-26/static/_content/7-text-5.png\"/>\n      <img class=\"abs halfScaleC 7-text-2\" style=\"top:272px;left:69px;\" src=\"/AR2025-26/static/_content/7-text-6.png\"/>\n      <img class=\"abs halfScaleC 7-text-2\" style=\"top:232px;left:245px;\" src=\"/AR2025-26/static/_content/7-text-7.png\"/>\n\n      <img class=\"abs halfScaleC 7-icon\" style=\"top:250px;left:333px;\" src=\"/AR2025-26/static/_content/7-icon-1.png\"/>\n\n        ",
    "script": "\n          function onPageEnter() {\n            pg7Anim = new TimelineMax();\n            pg7Anim.staggerFromTo(cOf(\"7-text\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n            .fromTo(cOf(\"7-icon\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, \"-=0.3\")\n            .staggerFromTo(cOf(\"7-text-2\"), 0.6, {scale:0}, {scale: 0.5, ease:  Back.easeOut.config(1.7)}, 0.2, \"-=0.2\")\n          }\n\n          function onPageLeave() {\n            pg7Anim.stop();\n          }\n      ",
    "searchText": "Cartier Philanthropy for People and Nature establishes and nurtures long-term partnerships based on mutual respect and trust. There are already many proven solutions with the potential to reach more people and landscapes across our programme areas. Our main role is to scale what works. Therefore, although we value innovation and research, we step in once programmes have a tested model and strong evidence of impact.  We look for non-profit organisations that:  Share our values of respect, trust, integrity and compassion  Have a deep understanding of the issues they are trying to solve  Implement evidence-based solutions that are effective and low-cost  Leverage science and data to show their interventions work, and to strengthen their programmes  Are ambitious to grow and scale their impact on critical social and environmental issues  7"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 8,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg8.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 8-title\" style=\"top:162px;left:92px;\" src=\"/AR2025-26/static/_content/8-title-1.png\"/>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg8Anim = new TimelineMax();\n          pg8Anim.fromTo(cOf(\"8-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n        }\n\n        function onPageLeave() {\n          pg8Anim.stop();\n        }\n      ",
    "searchText": "FOCUS AREAS Cartier Philanthropy for People and Nature focuses on vulnerable communities and ecosystems, addressing challenges that stem from deeply entrenched social and environmental issues. It structures its grant-making around four closely connected focus areas which we do not treat in isolation.  8"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 9,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg9.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScaleC 9-img\" style=\"top:49px;left:9px;\" src=\"/AR2025-26/static/_content/9-image-1.png\"/>\n        <img class=\"abs halfScale 9-text\" style=\"top:191px;left:272px;\" src=\"/AR2025-26/static/_content/9-text-1.png\"/>\n        <img class=\"abs halfScaleC 9-img\" style=\"top:174px;left:102px;\" src=\"/AR2025-26/static/_content/9-image-2.png\"/>\n        <img class=\"abs halfScale 9-text\" style=\"top:296px;left:365px;\" src=\"/AR2025-26/static/_content/9-text-2.png\"/>\n        <img class=\"abs halfScaleC 9-img\" style=\"top:323px;left:45px;\" src=\"/AR2025-26/static/_content/9-image-3.png\"/>\n        <img class=\"abs halfScale 9-text\" style=\"top:466px;left:307px;\" src=\"/AR2025-26/static/_content/9-text-3.png\"/>\n        <img class=\"abs halfScaleC 9-img\" style=\"top:458px;left:123px;\" src=\"/AR2025-26/static/_content/9-image-4.png\"/>\n        <img class=\"abs halfScale 9-text\" style=\"top:601px;left:384px;\" src=\"/AR2025-26/static/_content/9-text-4.png\"/>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg9Anim = new TimelineMax();\n          pg9Anim.staggerFromTo(cOf(\"9-img\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.2, 1)\n          .staggerFromTo(cOf(\"9-text\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1.1);\n        }\n\n        function onPageLeave() {\n          pg9Anim.stop(); \n        }\n      ",
    "searchText": "Unlock ing women's potential, transforming communities  Investing in sustainable livelihoods and craftsmanship, building opportunities Protecting nature, fostering resilience Responding to emergencies, sustaining life  9"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 10,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg10.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "10"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 11,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg11.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 11-title\" style=\"top:127px;left:386px;\" src=\"/AR2025-26/static/_content/11-title-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg11Anim = new TimelineMax();\n          pg11Anim.fromTo(cOf(\"11-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n        }\n\n        function onPageLeave() {\n          pg11Anim.stop();\n        }\n      ",
    "searchText": "A YEAR OF PARTNERSHIP  11"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 12,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg12.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 13,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg13.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 13-title\" style=\"top:810px;left:90px;\" src=\"/AR2025-26/static/_content/13-title-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg13Anim = new TimelineMax();\n          pg13Anim.fromTo(cOf(\"13-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n        }\n\n        function onPageLeave() {\n          pg13Anim.stop();\n        }\n      ",
    "searchText": "UNLOCKING WOMEN'S POTENTIAL, TRANSFORMIN G COMMUNITIES"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 14,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg14.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Women are leaders in their communities and drivers of prosperity as entrepreneurs, educators, caregivers and earners. Many also take care of the invisible work that keeps families going - fetching water, cooking food, raising children, tending to livestock, and caring for the sick and elderly. In vulnerable communities, where access to essential services such as healthcare, education, safe water and sanitation is often lacking, this added burden becomes even heavier, constraining many women's ability to fulfil their potential and thrive. In addition, many women around the world continue to face persistent gender inequalities, gender-based violence, legal barriers to owning land or property, and limited access to resources, knowledge and support. To empower Women in their Communities, we partner with non-profits that support women and their families in accessing quality childcare, education and health services, as well as safe and reliable water and sanitation. We also support organisations whose work challenges damaging societal expectations about gender, removes inequalities and prevents gender-based violence. The combined impact of such interventions can be profoundly transformative – not only for the women themselves, but also for the communities around them.  14 - Unlocking women's potential, transforming communities"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 15,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg15.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 15-title\" style=\"top:92px;left:93px;\" src=\"/AR2025-26/static/_content/15-title-1.png\"/>\n        <img class=\"abs halfScaleC 15-icon\" style=\"top:238px;left:359px;\" src=\"/AR2025-26/static/_content/15-icon-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg15Anim = new TimelineMax();\n          pg15Anim.fromTo(cOf(\"15-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"15-icon\"), 0.8, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.3\")\n        }\n\n        function onPageLeave() {\n          pg15Anim.stop();\n        }\n      ",
    "searchText": "NEW PARTNERS DARSEL tackles Jordan's maths learning challenge with a free, text-message-based, AI-driven chatbot that allows children to practice maths at home. The bot is specifically designed for learners in low- and middle-income countries: it works on low-cost phones and with poor network connectivity. The chatbot's content follows the country's national curricula. Endorsed by the Ministry of Education, it is introduced to learners by government schoolteachers. To date, more than 250,000 children have used Darsel. On average, they learn twice as much as children who are not in the programme.  Children learn  2x as much with Darsel"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 16,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg16.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScaleC 16-icon\" style=\"top:223px;left:264px;\" src=\"/AR2025-26/static/_content/16-icon-1.png\"/>\n        <img class=\"abs halfScaleC 16-icon\" style=\"top:382px;left:447px;\" src=\"/AR2025-26/static/_content/16-icon-2.png\"/>\n        \n        <h1 id=\"16-no\" class=\"abs brillCutMedium 16-no\" style=\"top:357px;left:352px; font-size: 1.3em; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 3.8, \"decimals\": 1, \"append\": \" million\"}' ></h1>\n        <h1 id=\"16-no\" class=\"abs brillCutMedium 16-no\" style=\"top:517px;left:570px; font-size: 1.3em; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 35, \"append\": \"%\"}' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg16Anim = new TimelineMax();\n          pg16Anim.staggerFromTo(cOf(\"16-icon\"), 0.8, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, 0.2, 1)\n          .fromTo(cOf(\"16-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"16-no\")[0])}}, 1.4)\n          .fromTo(cOf(\"16-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"16-no\")[1])}}, 1.6)\n        }\n\n        function onPageLeave() {\n          pg16Anim.stop();\n          resetNumbers(\"16-no\");\n        }\n      ",
    "searchText": "One in three maternal deaths in Kenya is linked to delays in pregnant women or new mothers seeking life-saving care when they need it – often because they don't recognise the danger signs. In addition, health facilities are ill equipped to provide quality obstetric care in emergency situations, leading to more preventable deaths. JACARANDA HEALTH addresses this challenge by providing vital health information to women through a two-way SMS exchange platform. 88% of the pregnant women reached reported attending 4 antenatal care visits vs 57% nationally. It also helps the government strengthen the health system through a mentorship and upskilling programme for obstetric providers, and enhanced data systems to improve resource allocation and address quality gaps. To date, Jacaranda Health has supported more than 3.8 million mothers via its SMS platform and trained more than 15,000 nurses.  More than  3.8 million mothers supported  Women report  35% In Rwanda, where 45% of married women report experiencing physical or sexual violence from their spouse, RWAMREC works with young men and their partners to challenge harmful gender norms, promote gender equality and prevent gender-based violence. Its flagship programme, Bandebereho, fosters positive masculinity and nurtures healthy relationships in couples and between them and their children. To date, RWAMREC has trained 1,600 community health workers to deliver the programme to 55,000 couples in three districts. RWAMREC's sustained impact is demonstrated by a robust external evaluation: six years after completing the programme, women report 35% less physical and 32% less sexual intimate partner violence compared with couples who did not attend the programme.  16 - Unlocking women's potential, transforming communities  less physical violence"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 17,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg17.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScaleC 17-icon\" style=\"top:99px;left:441px;\" src=\"/AR2025-26/static/_content/17-icon-1.png\"/>\n        <img class=\"abs halfScaleC 17-icon\" style=\"top:611px;left:415px;\" src=\"/AR2025-26/static/_content/17-icon-2.png\"/>\n\n        <h1 id=\"17-no\" class=\"abs brillCutMedium 17-no\" style=\"top:214px;left:564px; font-size: 1.3em; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 40, \"append\": \"%\"}' ></h1>\n        <h1 id=\"17-no\" class=\"abs brillCutMedium 17-no\" style=\"top:721px;left:548px; font-size: 1.8em; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 8}' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg17Anim = new TimelineMax();\n          pg17Anim.staggerFromTo(cOf(\"17-icon\"), 0.8, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, 0.2, 1)\n          .fromTo(cOf(\"17-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"17-no\")[0])}}, 1.4)\n          .fromTo(cOf(\"17-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"17-no\")[1])}}, 1.6)\n        }\n\n        function onPageLeave() {\n          pg17Anim.stop();\n          resetNumbers(\"17-no\");\n        }\n      ",
    "searchText": "40%  improvement in reading fluency  In India, 55% of ten-year-olds cannot read or understand simple text despite attending school. The LANGUAGE AND LEARNING FOUNDATION (LLF) works hand in hand with state governments to improve numeracy and literacy outcomes in the first years of primary school, focusing on states and districts where children are faring the worst. LLF revises state curricula, develops straightforward teacher guides and teaching materials adapted to the reality of these classrooms, and strengthens teacher mentoring. In Haryana state, 65% of children who attend schools directly supported by LLF met or exceeded official reading fluency targets at the end of Grade 2. This represents a 40% improvement on the state average.  Generative AI can enhance the impact of non-profits' programmes, extend their reach and lower their costs. It thus has the potential to help alleviate poverty, improve health and education outcomes, and accelerate vital research and conservation efforts. To harness the potential of these new technologies for the social sector, THE AGENCY FUND runs a one-year AI accelerator programme for a cohort of high-performing nonprofits. The programme includes funding and expert guidance to integrate AI into existing, proven solutions. In 2025, the AI accelerator supported its first cohort of eight non-profits, four of which are our partners.  8  non-profits supported  Unlocking women's potential, transforming communities - 17"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 18,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg18.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 18-text\" style=\"top:88px;left:88px;\" src=\"/AR2025-26/static/_content/18-title-1.png\"/>\n        <img class=\"abs halfScale 18-text\" style=\"top:228px;left:387px;\" src=\"/AR2025-26/static/_content/18-text-1.png\"/>\n        <img class=\"abs halfScaleC 18-icon\" style=\"top:277px;left:185px;\" src=\"/AR2025-26/static/_content/18-icon-1.png\"/>\n\n        <h1 id=\"18-no\" class=\"abs brillCutMedium 18-no\" style=\"top:374px;left:290px; font-size: 1.3em; color: #a51e61; padding: 0px; margin: 0px;\" data-number='{\"to\": 38, \"append\": \"%\"}' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg18Anim = new TimelineMax();\n          pg18Anim.staggerFromTo(cOf(\"18-text\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"18-icon\"), 0.8, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.2\")\n          .fromTo(cOf(\"18-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"18-no\")[0])}}, \"-=0.4\")\n        }\n\n        function onPageLeave() {\n          pg18Anim.stop();\n          resetNumbers(\"18-no\");\n        }\n      ",
    "searchText": "S ELECTED H IG H L IG H T S F R OM OUR PO R T FO L IO  38%  reduction in student morbidity  In Zambia, Healthy Learners works with the government to bring health care directly into schools. The governmentowned School Health Programme trains and selects schoolteachers to become school health workers, equipping them with digital diagnostic tools that allow them to monitor students' health and assess those that feel unwell. Trained teachers can treat mild conditions on the spot, in designated school health rooms set up through the programme. Children who need more specialised care are referred to government health facilities. Each school is assigned a specific clinic, and teachers meet monthly with medical staff to review follow-ups and monitor trends. Harvard University researchers found that the Healthy Learners programme led to a 38% reduction in student morbidity. Healthy Learners and the Zambian Ministries of Health and Education are working in  Many health systems in low-income countries focus on newborns and children under five, with treatment touch points often dropping off significantly once children reach school age. Malaria, intestinal worms, and diarrhoea are among the most common - and most treatable conditions affecting schoolchildren. Left unaddressed, they keep children out of class and hold back learning. close partnership to scale the School Health Programme across all state primary schools. As the programme leverages existing government structures and personnel, the national rollout is progressing rapidly. Once established in a school, the programme sustains itself at less than USD 1.50 per child per year – an amount Zambia's national education budget can support. Today, this approach has become the standard in over 1,000 schools across 45 districts in all ten provinces of Zambia, reaching approximately 1.4 million students."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 19,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg19.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 19-text\" style=\"top:144px;left:90px;\" src=\"/AR2025-26/static/_content/19-text-1.png\"/>\n        <img class=\"abs halfScaleC 19-icon\" style=\"top:382px;left:185px;\" src=\"/AR2025-26/static/_content/19-icon-1.png\"/>\n\n        <h1 id=\"19-no\" class=\"abs brillCutMedium 19-no\" style=\"top:504px;left:283px; font-size: 1.3em; color: #a51e61; padding: 0px; margin: 0px;\" data-number='{\"to\": 18, \"append\": \"%\"}' ></h1>\n        <h1 id=\"19-no\" class=\"abs brillCutMedium 19-no\" style=\"top:530px;left:291px; font-size: 1.3em; color: #a51e61; padding: 0px; margin: 0px;\" data-number='{\"to\": 25, \"append\": \"%\"}' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg19Anim = new TimelineMax();\n          pg19Anim.fromTo(cOf(\"19-text\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"19-icon\"), 0.8, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.2\")\n          .fromTo(cOf(\"19-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"19-no\")[0])}}, \"-=0.4\")\n          .fromTo(cOf(\"19-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"19-no\")[1])}}, \"-=0.4\")\n        }\n\n        function onPageLeave() {\n          pg19Anim.stop();\n          resetNumbers(\"19-no\");\n        }\n      ",
    "searchText": "Our long-term partner MSI is one of Tanzania's leading reproductive health care providers, serving over 2 million clients every year.  IUCD uptake up from  18% to 25%  by normalising the use of Intra-Uterine Contraceptive Devices (IUCDs), which have not only remained widely available, but were overstocked in Tanzania. IUCDs are as safe as implants and more cost-effective – but there are prevailing misconceptions about their effectiveness, and their safe administration requires providers to be trained. MSI is supporting the Tanzanian Ministry of Health in demand forecasting, stock management and the redistribution of contraceptives in order to maintain the supply of family planning options for millions of women and girls. MSI is also working closely with Community Health Workers to address prevailing misconceptions around the use of IUCDs, and is training service providers in their safe administration. IUCD uptake in Tanzania has increased from 18% to over 25% of clients reached within a year, with over 98,000 women opting for IUCDs during the year.  Historically, international aid agencies supplied most of the contraceptive devices in Tanzania, with implants being the preferred method due to their availability and ease of administration. However, severe cuts to global development aid have disrupted this supply chain, causing implant stock levels to fall below 6 months' provision in 2025. This shortage threatens hundreds of thousands of Tanzanian women with a lack of safe and effective family planning methods, potentially leading to unintended pregnancies and unsafe abortions. MSI has turned this challenge into an opportunity to expand contraceptive choice  Unlocking women's potential, transforming communities - 19"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 20,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg20.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 20-text\" style=\"top:158px;left:90px;\" src=\"/AR2025-26/static/_content/20-text-1.png\"/>\n        <img class=\"abs halfScaleC 20-icon\" style=\"top:653px;left:185px;\" src=\"/AR2025-26/static/_content/20-icon-1.png\"/>\n\n        <h1 id=\"20-no\" class=\"abs brillCutMedium 20-no\" style=\"top:751px;left:289px; font-size: 1.3em; color: #a51e61; padding: 0px; margin: 0px;\" data-number='{\"to\": 3}' ></h1>\n        <h1 id=\"20-no\" class=\"abs brillCutMedium 20-no\" style=\"top:751px;left:325px; font-size: 1.3em; color: #a51e61; padding: 0px; margin: 0px;\" data-number='{\"to\": 4}' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg20Anim = new TimelineMax();\n          pg20Anim.fromTo(cOf(\"20-text\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"20-icon\"), 0.8, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.2\")\n          .fromTo(cOf(\"20-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"20-no\")[0])}}, \"-=0.4\")\n          .fromTo(cOf(\"20-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"20-no\")[1])}}, \"-=0.4\")\n        }\n\n        function onPageLeave() {\n          pg20Anim.stop();\n          resetNumbers(\"20-no\");\n        }\n      ",
    "searchText": "A child's first five years are key to their cognitive development. In India, an estimated 50 million children fall behind in these critical first years because they don't have access to high-quality early learning. As a result, they aren't ready to learn when starting grade one. Rocket Learning's mission is to ensure that every Indian child achieves cognitive and physical development milestones by the age of 6, regardless of their background. Having helped reform the National Curriculum for Early Childhood Education, it now partners with the Government of India to deliver this curriculum to millions. This is achieved through the publicly funded “Anganwadi” daycare system, the world's largest state  3 4  in children meet development milestones  preschool network, which provides daily basic nutrition and healthcare to 40 million children aged 3 to 6. Rocket Learning produces short, engaging videos that introduce learning activities designed to stimulate children's cognitive and motor development. These videos, which are informed by the latest science on early learning, are shared daily with Anganwadi educators through WhatsApp groups. Rocket Learning also provides in-person and online training for Anganwadi preschool educators to hone their skills. Rocket Learning's model is designed to leverage existing public resources and infrastructure. It currently reaches over 400,000 Anganwadi educators, amounting to nearly 30% of the total workforce, who use its content to engage more than 6 million children across 14 Indian states and union territories. On average, Anganwadi educators trained by Rocket Learning spend twice as much time on learning activities as before. The impact of their work is transformative: 75% of children attending an Anganwadi centre supported by Rocket Learning meet the developmental milestones expected for them to be ready for school at age 6, compared with the national average of 50%.  20 - Unlocking women's potential, transforming communities"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 21,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg21.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 21-text\" style=\"top:116px;left:90px;\" src=\"/AR2025-26/static/_content/21-text-1.png\"/>\n        <img class=\"abs halfScaleC 21-icon\" style=\"top:290px;left:276px;\" src=\"/AR2025-26/static/_content/21-icon-1.png\"/>\n\n        <h1 id=\"21-no\" class=\"abs brillCutMedium 21-no\" style=\"top:380px;left:385px; font-size: 1.3em; color: #a51e61; padding: 0px; margin: 0px;\" data-number='{\"to\": 31, \"append\": \"%\"}' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg21Anim = new TimelineMax();\n          pg21Anim.fromTo(cOf(\"21-text\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"21-icon\"), 0.8, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.2\")\n          .fromTo(cOf(\"21-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"21-no\")[0])}}, \"-=0.4\")\n        }\n\n        function onPageLeave() {\n          pg21Anim.stop();\n          resetNumbers(\"21-no\");\n        }\n      ",
    "searchText": "For more than a decade, Pivot has worked with national, regional and local authorities in Madagascar to strengthen the health system in remote, hard-to-serve districts, focusing on three key levels of care: community health, primary care and district hospitals. Despite the fragile health system, high poverty rates, and a lack of infrastructure, Pivot has been able to achieve transformative impact. In 2025, 540,000 patients had access to strengthened healthcare services, delivered by over 1,600 community health workers, in 200 community health sites, 33 primary care health centres and 3 referral hospitals.  31%  drop in mortality of children under 5  In 2025, Pivot supported its 2 millionth patient encounter since starting this work in 2014. At that time, one in seven children in Ifanadiana District died before their fifth birthday. Today, the mortality of newborns, infants and children under five has declined by over 31% in Pivot-supported areas there, as confirmed by a study published in the scientific journal PLOS Medicine in 2025. Elsewhere in the country, mortality rates stayed flat or increased during the same period. Since 2022, at the request of Madagascar's Ministry of Public Health, Pivot has expanded its model from Ifanadiana District to the rest of the Vatovavy Region, home to nearly one million people.  Unlocking women's potential, transforming communities - 21"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 22,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg22.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 23,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg23.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 23-text\" style=\"top:187px;left:90px;\" src=\"/AR2025-26/static/_content/23-title-1.png\"/>\n        <img class=\"abs halfScale 23-text\" style=\"top:680px;left:90px;\" src=\"/AR2025-26/static/_content/23-text-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg23Anim = new TimelineMax();\n          pg23Anim.staggerFromTo(cOf(\"23-text\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n        }\n\n        function onPageLeave() {\n          pg23Anim.stop();\n        }\n      ",
    "searchText": "TWO PARTNERS, ONE GOAL : BETTER CARE FOR NEW MOTHERS AND THEIR BABIES RETURNING HOME One Heart Worldwide works to make pregnancy and childbirth safer for mothers and their newborns in rural Nepal. The organisation works hand in hand with local government authorities and communities to identify the specific needs, gaps and challenges in every district. Together, they co-invest in and renovate birth centres, equip them properly, train staff and community workers, and reach out to pregnant women and families to increase the likelihood of their seeking prenatal care and delivering their babies safely in a facility. One Heart Worldwide's efforts have made over 2 million pregnancies and deliveries safer since 2010. However, when a new mother and her baby return home from a birth centre or facility, their journey has only just begun. Many mothers will need support from loved ones  One Heart Worldwide's efforts have made over 2 million pregnancies and deliveries safer since 2010. or other caregivers to ensure that they and their babies are safe and well-nurtured. It  is also critical that any warning signs of complications – for example an infected wound, or a baby showing signs of jaundice - are recognised and acted upon swiftly. In rural parts of Nepal, where four in ten people live further than 30 minutes from the nearest health facility, the presence of a knowledgeable family caregiver can be the difference between life and death. And yet, with medical staff overburdened and short on time, family members do not always receive clear, actionable information that prepares them for this responsibility. To fill this gap and provide family caregivers with the necessary guidance and training, One Heart Worldwide teamed up with Noora Health. Through its “Care Companion Program” (CCP) Noora Health works with existing public health systems and local partners to equip family caregivers with the critical skills they need to better care for their loved ones as they heal, thus preventing unnecessary complications and fatalities. Working in India, Bangladesh and Indonesia, Noora Health covers a range of health issues such as maternal and newborn health, cardiac care or non-communicable diseases. It has served more than 58 million patients and caregivers to date, delivering trainings to 72,000 people every day. Its work has a measurable, life-saving impact:  Unlocking women's potential, transforming communities - 23"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 24,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg24.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 24-text\" style=\"top:302px;left:387px;\" src=\"/AR2025-26/static/_content/24-text-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg24Anim = new TimelineMax();\n          pg24Anim.fromTo(cOf(\"24-text\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n        }\n\n        function onPageLeave() {\n          pg24Anim.stop();\n        }\n      ",
    "searchText": "a 2023 study found that the Companion Care Program for maternal and newborn health had led to an 18% reduction in the risk of newborn death within the first month of birth. For One Heart Worldwide, partnering with Noora Health was a natural fit: It considered equipping caregivers with the skills to support their loved ones to be a key success factor in improving maternal and child health outcomes, and saw Noora Health's expertise as complementary to its own. In early 2024, Noora Health was ready to expand its work to Nepal. When it had first expanded beyond India, to Bangladesh and Indonesia, Noora Health had built teams on  Worldwide, Noora Health found what it had been looking for. In September 2024, the two organisations officially announced their partnership to introduce and implement the CCP in Nepal. After a pilot in three hospitals, the programme was rapidly expanded to reach 11 health facilities across three provinces. By the end of 2025, Noora Health and One Heart Worldwide teams had trained 182 health workers at these facilities to deliver  18% reduction in the risk of newborn death within the first month of birth  the ground to implement the programme in partnership with local authorities. This approach worked well in terms of quality and impact but required significant resources. Noora's team realised that, to scale durably, it needed to find local partners with the right experience to implement and take the programme forward. In One Heart  critical skills around maternal and newborn health to over 31,000 new parents, patients, and caregivers. While Noora Health provides the content and informational materials together with expert advice, One Heart Worldwide teams lead the way in mapping needs and delivering trainings. Over time, the aim is  24 - Unlocking women's potential, transforming communities"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 25,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg25.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScaleC 25-icon\" style=\"top:565px;left:341px;\" src=\"/AR2025-26/static/_content/25-icon-1.png\"/>\n\n        <h1 id=\"25-no\" class=\"abs brillCutMedium 25-no\" style=\"top:694px;left:448px; font-size: 1.3em; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 31000, \"comma\": true}' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg25Anim = new TimelineMax();\n          pg25Anim.fromTo(cOf(\"25-icon\"), 0.8, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, 1)\n          .fromTo(cOf(\"25-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"25-no\")[0])}}, \"-=0.4\")\n        }\n\n        function onPageLeave() {\n          pg25Anim.stop();\n          resetNumbers(\"25-no\");\n        }\n      ",
    "searchText": "for One Heart Worldwide to fully integrate the CCP into its existing programmes. For Noora Health, this partnership model presented an opportunity to expand into a new country without needing a significant presence on the ground. Beyond that, it was also an enormous learning opportunity, yielding valuable insights on how to maintain the quality and consistency of the programme when not directly implemeting it: through capable partners and clearly defined systems and roles. One Heart Worldwide and Noora Health now plan to roll the programme out to a total of 27 hospitals across Nepal by 2028.  More than  31,000 caregivers trained  Unlocking women's potential, transforming communities - 25"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 26,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg26.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 27,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg27.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 27-text\" style=\"top:805px;left:92px;\" src=\"/AR2025-26/static/_content/27-title-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg27Anim = new TimelineMax();\n          pg27Anim.fromTo(cOf(\"27-text\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n        }\n\n        function onPageLeave() {\n          pg27Anim.stop();\n        }\n      ",
    "searchText": "INVESTING IN SUSTAINABLE LIVELIHOODS AND CRAFTSMANSHIP, BUILDING OPPORTUNITIES"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 28,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg28.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "For vulnerable communities to overcome precarity and begin to prosper, they need opportunities to make a living that are socially, economically and ecologically sustainable – as farmers, entrepreneurs, employees and professionals. Initiatives that strengthen skills, foster entrepreneurship and facilitate access to finance and markets can help unlock such opportunities. So too can the promotion of sustainable agriculture, artisanal craftsmanship and heritage practices – activities that empower people through dignified, resilient sources of income while respecting and nurturing the ecosystems around them. The need for such opportunities is growing more urgent than ever in an increasingly volatile world, as the impacts of climate change intensify and technological innovation disrupts industries at scale. To support Sustainable Livelihoods and Craftsmanship, we partner with organisations that take a long-term, locally grounded approach to economic empowerment that is respectful of people and nature.  28 - Investing in sustainable livelihoods and craftsmanship, building opportunities"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 29,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg29.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 29-title\" style=\"top:92px;left:92px;\" src=\"/AR2025-26/static/_content/29-title-1.png\"/>\n        <img class=\"abs halfScaleC 29-icon\" style=\"top:293px;left:457px;\" src=\"/AR2025-26/static/_content/29-icon-1.png\"/>\n\n        <h1 id=\"29-no\" class=\"abs brillCutMedium 29-no\" style=\"top:415px;left:572px; font-size: 1.3em; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 24, \"append\": \"%\", \"preppend\": \"+\"}' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg29Anim = new TimelineMax();\n          pg29Anim.fromTo(cOf(\"29-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"29-icon\"), 0.8, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.4\")\n          .fromTo(cOf(\"29-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"29-no\")[0])}}, \"-=0.4\")\n        }\n\n        function onPageLeave() {\n          pg29Anim.stop();\n          resetNumbers(\"29-no\");\n        }\n      ",
    "searchText": "N EW PAR T NERS Farmers in low- and middle-income countries still form most of the world's poor. They face low yields, destructive pests, and increasingly frequent climate shocks. In addition, the government extension workers tasked with assisting them are often overstretched, and many lack the tools to support farmers effectively. DIGITAL GREEN helps to fill this gap. It lets farmers and extension workers access proven, localised agricultural advice and real-time information through a free, AI-powered app: FarmerChat. This app, available in 16 local languages, allows farmers to make informed decisions on how to protect crops and boost yields. This leads to reduced costs, increased income, greater resilience and stronger rural communities. Research shows that FarmerChat can lower the adoption costs of new farming practices by up to 100 times per farmer compared with conventional extension services.  +24% in farmer profit  Investing in sustainable livelihoods and craftsmanship, building opportunities - 29"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 30,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg30.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScaleC 30-icon\" style=\"top:313px;left:455px;\" src=\"/AR2025-26/static/_content/30-icon-1.png\"/>\n\n        <h1 id=\"30-no\" class=\"abs brillCutMedium 30-no\" style=\"top:428px;left:577px; font-size: 1.3em; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 25, \"append\": \"%\"}' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg30Anim = new TimelineMax();\n          pg30Anim.fromTo(cOf(\"30-icon\"), 0.8, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, 1)\n          .fromTo(cOf(\"30-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"30-no\")[0])}}, \"-=0.4\")\n        }\n\n        function onPageLeave() {\n          pg30Anim.stop();\n          resetNumbers(\"30-no\");\n        }\n      ",
    "searchText": "RAISING THE VILLAGE works with lowincome farming communities in Uganda to increase their income and savings, with a view to overcoming extreme poverty. It provides them with improved seeds, agricultural training and advice on how to obtain higher yields. The programme also includes financial literacy training and support in setting up savings groups. Unlike most “poverty graduation” programmes, Raising the Village's approach is to mobilise every household in a community in its efforts. Its programme has reached 1.5 million people in Uganda to date. On average, participants achieved a 25% increase in household income and 36% increase in wealth three years after joining the programme.  25%  increase in household income  30 - Investing in sustainable livelihoods and craftsmanship, building opportunities"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 31,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg31.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScaleC 31-icon\" style=\"top:60px;left:373px;\" src=\"/AR2025-26/static/_content/31-icon-1.png\"/>\n        <img class=\"abs halfScaleC 31-icon\" style=\"top:409px;left:149px;\" src=\"/AR2025-26/static/_content/31-icon-2.png\"/>\n\n        <h1 id=\"31-no\" class=\"abs brillCutMedium 31-no\" style=\"top:222px;left:496px; font-size: 1.3em; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 34, \"append\": \"%\"}' ></h1>\n        <h1 id=\"31-no\" class=\"abs brillCutMedium 31-no\" style=\"top:531px;left:271px; font-size: 1.3em; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 52, \"append\": \"%\"}' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg31Anim = new TimelineMax();\n          pg31Anim.staggerFromTo(cOf(\"31-icon\"), 0.8, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, 0.2, 1)\n          .fromTo(cOf(\"31-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"31-no\")[0])}}, \"-=0.4\")\n          .fromTo(cOf(\"31-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"31-no\")[1])}}, \"-=0.4\")\n        }\n\n        function onPageLeave() {\n          pg31Anim.stop();\n          resetNumbers(\"31-no\");\n        }\n      ",
    "searchText": "Revenue of Tanzanian SMEs grew by  34% Most smallholder farming families in East Africa rely on a network of modestly sized agriculture businesses to sell them seeds and fertilisers and buy their crops. For this system to be efficient, these businesses need access to commercial loans that allow them to grow. However, many of them – especially those serving low-income farmers – struggle to find lenders willing to extend loans, as serving them is not sufficiently profitable. ACELI AFRICA works with lenders to overcome these hurdles, for example by defraying the high transaction costs of serving enterprises in remote rural areas, and by creating new banking products adapted to these specific clients. In Tanzania, it has supported 2,338 loans totalling USD 145 million, creating growth opportunities for 450,000 smallholder farmers and workers.  52%  drop in cattle mortality  In Zambia's traditional cattle-rearing communities, extreme poverty and environmental decline exacerbate one another: limited veterinary access, degraded rangelands and scarce water leave herds weak, drive mortality rates above 50%, and restrict over 90% of pastoralist families to less than USD 2 per day. MAFISA breaks this cycle by pairing practical livestock services - veterinary care, fair market access, and new water points - with a commitment from participating communities to adopt regenerative grazing. The resulting healthier grasslands unlock carbon financing that covers most programme costs. Farmers working with Mafisa in the Mwandi region have reported a 52% drop in cattle mortality and a 40% increase in calving rates.  Investing in sustainable livelihoods and craftsmanship, building opportunities - 31"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 32,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg32.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 32-text\" style=\"top:91px;left:92px;\" src=\"/AR2025-26/static/_content/32-title-1.png\"/>\n        <img class=\"abs halfScale 32-text\" style=\"top:624px;left:90px;\" src=\"/AR2025-26/static/_content/32-text-1.png\"/>\n        <img class=\"abs halfScaleC 32-icon\" style=\"top:394px;left:176px;\" src=\"/AR2025-26/static/_content/32-icon-1.png\"/>\n\n        <h1 id=\"32-no\" class=\"abs brillCutMedium 32-no\" style=\"top:490px;left:285px; font-size: 1.3em; color: #1274ae; padding: 0px; margin: 0px;\" data-number='{\"to\": 91, \"append\": \"%\"}' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg32Anim = new TimelineMax();\n          pg32Anim.staggerFromTo(cOf(\"32-text\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"32-icon\"), 0.8, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.4\")\n          .fromTo(cOf(\"32-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"32-no\")[0])}}, \"-=0.4\")\n        }\n\n        function onPageLeave() {\n          pg32Anim.stop();\n          resetNumbers(\"32-no\");\n        }\n      ",
    "searchText": "S ELECTED H IG H L IG H T S F R OM OUR PO R T FO L IO  91%  of fishers increased their income  Small-scale fisheries provide protein and income for almost 500 million people around the world. However, many of them face an uncertain future, as industrial overfishing, climate change and pollution have decimated many global fish stocks. Abalobi helps South African small-scale fishing communities, many of whom have historically been marginalised and financially  excluded, to build more sustainable, futureproof fisheries. It offers a suite of innovative solutions for fishers to track and log their catch data, target more abundant and resilient species, aggregate under a collective brand, and sell directly to customers who are willing to pay a fair price for sustainably caught fish. This work benefits people and nature alike, with fishers improving their food security and earning higher incomes, while giving depleted fish stocks a chance to recover. In an independent survey conducted in 2025, nine out of ten fishers working with Abalobi reported improved livelihoods. 91% had increased their incomes and a large majority credited Abalobi with helping them save money and afford more regular meals. Equally important, Abalobi fishers have diversified their catch to include more resilient, less sought-after species such as Cape bream and Carpenter. Abalobi's “Fish with a Story” campaign has created strong local demand for these more sustainable options over the last three years, reducing the pressure on highly popular but overfished species such as Kob or West Coast rock lobster. Today, 93% of all catches recorded on the Abalobi app consist of resilient, non-threatened species – a significant improvement from around 40% before the programme launched. Today, Abalobi supports over 10,000 fishers in South Africa and globally, and has shared its technology and know-how with partners in 21 other countries. It aims to expand its work to reach at least 30,000 people directly by 2030.  32 - Investing in sustainable livelihoods and craftsmanship, building opportunities"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 33,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg33.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 33-text\" style=\"top:98px;left:219px;\" src=\"/AR2025-26/static/_content/33-text-1.png\"/>\n        <img class=\"abs halfScaleC 33-icon\" style=\"top:649px;left:252px;\" src=\"/AR2025-26/static/_content/33-icon-1.png\"/>\n\n        <h1 id=\"33-no\" class=\"abs brillCutMedium 33-no\" style=\"top:792px;left:357px; font-size: 1.3em; color: #1274ae; padding: 0px; margin: 0px;\" data-number='{\"to\": 35, \"append\": \"%\"}' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg33Anim = new TimelineMax();\n          pg33Anim.fromTo(cOf(\"33-text\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"33-icon\"), 0.8, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.4\")\n          .fromTo(cOf(\"33-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"33-no\")[0])}}, \"-=0.4\")\n        }\n\n        function onPageLeave() {\n          pg33Anim.stop();\n          resetNumbers(\"33-no\");\n        }\n      ",
    "searchText": "Tribal women in India's Odisha state have collected sal leaves to make craft products for generations. This has, however, traditionally been informal seasonal work that only generates limited and unreliable income. Industree Foundation supports these producers to turn this natural resource into a steady income stream, assisting them to build and run profitable, self-owned enterprises that produce leaf plates as an eco-friendly alternative to disposable plastic products. Over the last 3 years, we've supported Industree's efforts to establish and grow two such enterprises. Over 800 women artisans are now earning a steady income collecting leaves, sewing them together and operating the hydraulic presses that transform them into biodegradable plates. On average, the women have grown their incomes by at least 35% since joining. Many of them had never had formal employment, a bank account in their name, or a community of peers they could connect and grow with before. Since 2023, the two leaf plate enterprises have increased their production from 180,000 to over 500,000 units per month,  supplying over 630 retailers. The plates are available on e-commerce platforms such as Amazon, Flipkart and Greenkraft as well as in more than 100 stores across India. In 2025, they took a major step towards expanding into international markets, achieving certification by the international testing, inspection and certification company SGS for compliance with EU food contact safety standards.  Women have grown their incomes by  35% Investing in sustainable livelihoods and craftsmanship, building opportunities - 33"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 34,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg34.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 34-text\" style=\"top:89px;left:203px;\" src=\"/AR2025-26/static/_content/34-text-1.png\"/>\n        <img class=\"abs halfScaleC 34-icon\" style=\"top:489px;left:471px;\" src=\"/AR2025-26/static/_content/34-icon-1.png\"/>\n\n        <h1 id=\"34-no\" class=\"abs brillCutMedium 34-no\" style=\"top:631px;left:576px; font-size: 1.3em; color: #1274ae; padding: 0px; margin: 0px;\" data-number='{\"to\": 26, \"append\": \"%\"}' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg34Anim = new TimelineMax();\n          pg34Anim.fromTo(cOf(\"34-text\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"34-icon\"), 0.8, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.4\")\n          .fromTo(cOf(\"34-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"34-no\")[0])}}, \"-=0.4\")\n        }\n\n        function onPageLeave() {\n          pg34Anim.stop();\n          resetNumbers(\"34-no\");\n        }\n      ",
    "searchText": "Many rice farmers burn their crop residues after harvest to prepare their fields to be replanted. In Myanmar, more than 300,000 rice farmers apply this ancient method every year, burning an estimated 4.6 million tons of crop residues across 800,000 hectares of farmland. The burning of crop residues has detrimental effects on the climate, public health and soil productivity, generating 7 million tons of CO2 emissions and causing severe air pollution that leads to respiratory and other diseases. It also deprives soils of valuable organic material and nutrients that could act as natural fertilisers. Proximity Designs – an organisation that helps smallholder farmers in Myanmar increase their productivity and incomes through innovative technologies and services – has developed a practical and affordable alternative method that allows farmers to decompose crop residues within two weeks or less instead of having to burn them. This method uses a biological decomposer agent that farmers mix with nitrogen fertiliser and rice bran before spreading it on their harvested fields. The previous growing season's  straw stubble is decomposed into nutrient-rich soil within two weeks, providing fertile ground for the next planting season. In addition to helping human health and the climate, this “No-Burn Rice Farming” practice has the potential to achieve higher crop yields and to improve soil health year after year. In 2026, results of a Randomised Control Trial study by Michigan State University showed that farmers who adopted the method improved their net income per acre by 26-45%. This led to a householdlevel gain of USD 247 in the summer season and USD 301 in the monsoon season. Farmers who adopted the method burned significantly smaller surfaces than those who did not: up to 33% less during the 2024 monsoon season, and 74% less in the 2025 summer season. 60% of these farmers perceived an improvement in soil health.  Farmers improve income by at least  26%"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 35,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg35.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 35-text\" style=\"top:88px;left:248px;\" src=\"/AR2025-26/static/_content/35-text-1.png\"/>\n        <img class=\"abs halfScaleC 35-icon\" style=\"top:455px;left:466px;\" src=\"/AR2025-26/static/_content/35-icon-1.png\"/>\n\n        <h1 id=\"35-no\" class=\"abs brillCutMedium 35-no\" style=\"top:582px;left:571px; font-size: 1.3em; color: #1274ae; padding: 0px; margin: 0px;\" data-number='{\"to\": 36, \"append\": \"%\"}' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg35Anim = new TimelineMax();\n          pg35Anim.fromTo(cOf(\"35-text\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"35-icon\"), 0.8, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.4\")\n          .fromTo(cOf(\"35-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"35-no\")[0])}}, \"-=0.4\")\n        }\n\n        function onPageLeave() {\n          pg35Anim.stop();\n          resetNumbers(\"35-no\");\n        }\n      ",
    "searchText": "In Zambia, more than half the population live in rural areas and nearly 60% experience poverty. Without reliable transportation, distance becomes one of the biggest barriers to reaching schools, markets and healthcare. World Bicycle Relief works to provide Zambian students, community healthcare workers and low-income farming families with robust, locally assembled bicycles to go to school, reach more patients faster, transport more goods and earn a bigger income, or simply travel around their communities more effectively. To enable this, the organisation works with communities to create a sustainable bicycle ecosystem, including local assembly and distribution centres, retail shops and trained mechanics to provide spare parts and service the bikes – ensuring that they can be used for 10 years or more. Between 2023 and 2025, World Bicycle Relief and IDInsight conducted a Randomised Control Trial to measure the programme's impact on people's incomes, productivity, and access to essential services, as well as its cost-effectiveness.  It confirmed that bicycles generate significant economic and social returns: households receiving bicycles saw their incomes rise by 36% compared with the control group, driving higher consumption, increased savings and fewer debts. The impact study also revealed how bicycles help families to cope better with crises and build resilience. When Zambia experienced its worst drought in 40 years in 2024, many rural households struggled with food insecurity and saw their consumption levels decrease. Households with bicycles were able to maintain their standard of living and adapt to the drought by making more trips to the market and engaging in trade. This resulted in higher monthly income, increased consumption, better food security and a higher-quality diet than households that did not have bicycles. Households with bicycles saw  36%  income growth  Investing in sustainable livelihoods and craftsmanship, building opportunities - 35"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 36,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg36.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 37,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg37.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 37-text\" style=\"top:188px;left:90px;\" src=\"/AR2025-26/static/_content/37-title-1.png\"/>\n        <img class=\"abs halfScale 37-text\" style=\"top:763px;left:90px;\" src=\"/AR2025-26/static/_content/37-text-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg37Anim = new TimelineMax();\n          pg37Anim.staggerFromTo(cOf(\"37-text\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n        }\n\n        function onPageLeave() {\n          pg37Anim.stop();\n        }\n      ",
    "searchText": "A CLEAR VIEW: HOW READING GLASSES CHANGE LIVES Kalpona Khatun was in her early forties when her vision began to blur. Daily tasks became challenges, from making food for her two children to the occasional sewing work that provided additional income for her family. Eventually she had to give up work altogether. Kalpona's husband supported her as best he could, but neither of them knew where to seek help. Over time, Kalpona's confidence diminished and she felt increasingly helpless. A billion people around the world face similar challenges. A billion people who need glasses but don't have them. For many of these people, deteriorating eyesight means a steady fall in income, whether they're artisans, craftspeople, accountants, shopkeepers or construction workers in lowincome communities. They should be at the peak of their professional productivity and skill in their late forties - an age at which four out of five people worldwide need reading glasses - but many struggle to keep a job because they simply can't see clearly. This creates pain, anxiety and hardship for the affected individuals and their families. And it's a colossal waste of potential for society. The World Health Organization estimates  A billion people around the world who need glasses but don't have them.  that impaired vision costs the global economy more than USD 200 billion every year. A quarter of a century ago, the international non-profit VisionSpring set out to find a solution to this problem. Its aim is crystalclear today: to ensure that by 2050, anyone who needs glasses will have them. Its approach is simple: through partnerships with NGOs and government agencies, VisionSpring trains community health workers who carry out free sight tests in vulnerable, low-income communities, and sell affordable, quality glasses to those who need them. Its impact goes much deeper: glasses are a tool that allows for lifelong learning, earning, safety and well-being for people vulnerable to poverty. Since its inception, VisionSpring has provided more than 16 million people with glasses worldwide. We have supported VisionSpring's transformative work since 2018, with three successive grants focused on its “Reading Glasses for Improved Livelihoods” programme in Bangladesh. This programme sees Community Health Workers – rather than specialist optometrists – carrying out free vision tests in rural communities and selling low-cost reading glasses to those who need them. Kalpona Khatun's life changed when she heard about one of the vision screening camps that VisionSpring and its partner BRAC had organised in her village. Upon  Investing in sustainable livelihoods and craftsmanship, building opportunities - 37"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 38,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg38.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScaleC 38-icon\" style=\"top:630px;left:195px;\" src=\"/AR2025-26/static/_content/38-icon-1.png\"/>\n\n        <h1 id=\"38-no\" class=\"abs brillCutMedium 38-no\" style=\"top:739px;left:314px; font-size: 1.3em; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 2.4, \"decimals\": 1, \"preppend\": \">\"}' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg38Anim = new TimelineMax();\n          pg38Anim.fromTo(cOf(\"38-icon\"), 0.8, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, 1)\n          .fromTo(cOf(\"38-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"38-no\")[0])}}, \"-=0.4\")\n        }\n\n        function onPageLeave() {\n          pg38Anim.stop();\n          resetNumbers(\"38-no\");\n        }\n      ",
    "searchText": "learning of Kalpona's struggles, BRAC's local field organiser encouraged her to visit the camp and have her eyesight tested. At the camp, the free test quickly revealed that Kalpona was affected by presbyopia, a common age-related condition which makes it difficult to focus on nearby objects. The solution was simple and affordable: a pair of reading glasses costing just 150 Bangladeshi taka – around 1 US dollar. When Kalpona tried the glasses on, her face lit up with joy: she could see clearly again. She quickly returned home to tell her husband, who warmly supported her decision, and within half an hour she was back with the money and a bright smile, ready to pick up her glasses. For Kalpona, seeing clearly has brought a multitude of benefits: Now I hope to improve my sewing work and earn more to support my family. I can also read and use my phone better and see things up close. I feel more confident in my daily life.  >2.4 million  pairs of glasses sold  38 - Investing in sustainable livelihoods and craftsmanship, building opportunities"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 39,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg39.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Kalpona is one of more than 2.4 million people in Bangladesh who have been able to purchase affordable reading glasses thanks to VisionSpring, in many cases improving their quality of life and income-earning potential as a result. A rigorous impact study published in 2024 showed that people across rural Bangladesh who received a pair of reading glasses – including farmers, artisans, tradespeople and small entrepreneurs – saw their income increase from a median of around USD 35 to USD 47 a month, an average of 33.4%. Meanwhile, people who needed glasses but had not yet received them did not achieve any significant income gains during the period. Participants who received glasses also reported feeling better about their lives overall, enjoying a greater sense of independence and ease when doing daily tasks. The data confirmed what VisionSpring's teams had often heard from customers like Kaplona Khatun - that access to glasses  changes lives. This spurred the organisation on to scale its work further and reach even more people. In Bangladesh, this scaling work is already under way – both horizontally, by expanding into new districts, and vertically, by working to increase the rate at which people take  the opportunity to get tested and purchase glasses if they need them. For years, VisionSpring had observed that many people - and especially men - of the age at which vision problems tend to occur did not show up at vision screening camps to get tested. It further noted that of those who did get tested and diagnosed with blurry near vision (presbyopia), only around two in four actually purchased glasses. With the help of behavioural science specialists from Appleseed and WRP, VisionSpring's teams have been able to unpack the reasons for these challenges and develop strategies to get more people to show up, get tested and buy glasses. For example, they found that a stronger presence in the communities would help mobilise people in advance of the vision screening camp. Handing out individual appointment cards with time slots was helpful in this regard, as it turned screenings into personal consultations. Further, VisionSpring realised that it needed to tweak its messaging. People with blurry vision often normalise their condition and aren't necessarily aware that there are simple solutions which improve their quality of life without any need to see a doctor. Accordingly, it has invested in creating improved communication materials and in training Community Health Workers in customer interactions and sales techniques that help address any misconceptions. The preliminary results of these strategies to build demand and reduce barriers to people buying glasses are highly encouraging: VisionSpring has delivered 36% more screenings across four pilot districts in just four months, achieving a 79% increase in people buying glasses if they need them, and 185% growth in total sales. It has since rolled these approaches out across Bangladesh, reaching over 300,000 people.  Investing in sustainable livelihoods and craftsmanship, building opportunities - 39"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 40,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg40.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 41,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg41.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 41-text\" style=\"top:809px;left:92px;\" src=\"/AR2025-26/static/_content/41-title-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg41Anim = new TimelineMax();\n          pg41Anim.fromTo(cOf(\"41-text\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n        }\n\n        function onPageLeave() {\n          pg41Anim.stop();\n        }\n      ",
    "searchText": "PROTECTING NATURE, FOSTERING RESILIENCE"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 42,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg42.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Climate change and biodiversity loss are making it critically urgent to protect terrestrial, marine and freshwater ecosystems that remain intact and to restore those that are degraded. These ecosystems not only offer a home to the countless forms of life with which we share this planet, but also provide us all with vital resources that underpin our health, livelihoods and resilience. To conserve nature is to conserve humanity – and for conservation actions to be effective and sustainable, they need to address human wellbeing and the health of ecosystems together. Indigenous peoples and local communities play a particularly critical role in these efforts. They have coexisted with wildlife for centuries – sometimes with mutual benefits, but too often at a high cost to their lives and livelihoods. Yet, when they have the rights and means to manage their lands and natural resources, they are the most effective stewards of the natural environment. Our efforts to protect and restore Natural Ecosystems consequently see us partner with non-profits that work with and empower communities to protect nature, to thrive alongside wildlife and to restore natural habitats and species where they have disappeared.  42 - Protecting nature, fostering resilience"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 43,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg43.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 43-text\" style=\"top:91px;left:93px;\" src=\"/AR2025-26/static/_content/43-title-1.png\"/>\n        <img class=\"abs halfScaleC 43-icon\" style=\"top:318px;left:56px;\" src=\"/AR2025-26/static/_content/43-icon-1.png\"/>\n        <img class=\"abs halfScaleC 43-icon\" style=\"top:362px;left:459px;\" src=\"/AR2025-26/static/_content/43-icon-2.png\"/>\n\n        <h1 id=\"43-no\" class=\"abs brillCutMedium 43-no\" style=\"top:432px;left:162px; font-size: 1.3em; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 10000, \"comma\": true}' ></h1>\n        <h1 id=\"43-no\" class=\"abs brillCutMedium 43-no\" style=\"top:495px;left:549px; font-size: 1.3em; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 1.2, \"decimals\": 1, \"append\": \" million\"}' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg43Anim = new TimelineMax();\n          pg43Anim.fromTo(cOf(\"43-text\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n          .staggerFromTo(cOf(\"43-icon\"), 0.8, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, 0.2, \"-=0.4\")\n          .fromTo(cOf(\"43-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"43-no\")[0])}}, \"-=0.4\")\n          .fromTo(cOf(\"43-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"43-no\")[1])}}, \"-=0.4\")\n        }\n\n        function onPageLeave() {\n          pg43Anim.stop();\n          resetNumbers(\"43-no\");\n        }\n      ",
    "searchText": "NEW PARTNERS  10,000 carnivores monitored intensively  Zambia is a stronghold for many of Africa's large carnivores, including African wild dogs, cheetahs, lions, leopards and hyenas. All of them are, however, increasingly under threat from human activity. THE ZAMBIAN CARNIVORE PROGRAMME (ZCP) works to protect these species and their key habitats through ecological research, on-theground conservation efforts, the provision of training for the next generation of conservation leaders, and community engagement to foster peaceful coexistence. Today, ZCP intensively monitors and protects over 1,200 carnivores, including lions, leopards and spotted hyenas, to observe and understand population trends and reduce human-wildlife conflicts. Conservation of  1.2 million  Much of Africa's wildlife habitat is protected by local communities through conservancies or concessions that buffer and connect national parks. Many of these communityrun conservation areas deliver real benefits for people and nature. However, some communities that are willing to conserve their land do not have access to the resources or skills they need to create positive environmental and economic outcomes. CONSERVE GLOBAL provides such communities with support tailored to their specific needs. This can include support to secure or formalise land tenure, to build strong governance and management structures, and to generate income for community members so they can thrive in a healthy ecosystem. Conserve Global currently supports community-led conservation initiatives across a total of almost 1.2 million hectares in Zambia, Namibia, Kenya, Cameroon and Mozambique, generating socioeconomic benefits for more than 7,000 people.  hectares supported  Protecting nature, fostering resilience - 43"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 44,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg44.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScaleC 44-icon\" style=\"top:244px;left:323px;\" src=\"/AR2025-26/static/_content/44-icon-1.png\"/>\n        <img class=\"abs halfScaleC 44-icon\" style=\"top:417px;left:140px;\" src=\"/AR2025-26/static/_content/44-icon-2.png\"/>\n\n        <h1 id=\"44-no\" class=\"abs brillCutMedium 44-no\" style=\"top:367px;left:429px; font-size: 1.3em; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 5}' ></h1>\n        <h1 id=\"44-no\" class=\"abs brillCutMedium 44-no\" style=\"top:533px;left:257px; font-size: 1.3em; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 5, \"append\": \" km\"}' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg44Anim = new TimelineMax();\n          pg44Anim.staggerFromTo(cOf(\"44-icon\"), 0.8, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, 0.2, 1)\n          .fromTo(cOf(\"44-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"44-no\")[0])}}, \"-=0.4\")\n          .fromTo(cOf(\"44-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"44-no\")[1])}}, \"-=0.4\")\n        }\n\n        function onPageLeave() {\n          pg44Anim.stop();\n          resetNumbers(\"44-no\");\n        }\n      ",
    "searchText": "Red coral in the Mediterranean Sea is facing threats due to rising sea temperatures, habitat loss and fishing. These marine animals are critically important for biodiversity and people's livelihoods: they create entire habitats which feed and shelter countless other marine species, while simultaneously supporting fisheries and tourism. The MARILLES FOUNDATION engages with government, NGO and research partners, fisheries associations and tourism operators to better understand and protect marine biodiversity around Spain's Balearic Islands. It works to create no-take zones in particularly critical areas and to put measures in place that prevent further damage to coral ecosystems, creating conditions that enable them to recover over time. Over the next three years, Marilles will set up systematic coral monitoring in at least 5 key sites in the Balearic Islands and ensure that at least two coral-rich areas are strictly protected.  5 km  of dry stone walls restored  44 - Protecting nature, fostering resilience  At least  5 coral sites monitored  The PARC JURA VAUDOIS is one of 20 official Swiss regional parks. Extending over more than 500 sq. km of mixed-use landscape in the Jura mountains, the park has been shaped by centuries of agricultural tradition. Despite this, it boasts a rich diversity of natural habitats that sustain regionally threatened species like the lynx and capercaillie. The park authorities here face the challenge of preserving these precious habitats in the face of climate change and growing pressure from tourism and agriculture. Over the past three years, the park authorities have restored 5km of dry stone walls and over 4km of native hedges, which are key habitat patches for local biodiversity."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 45,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg45.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScaleC 45-icon\" style=\"top:300px;left:298px;\" src=\"/AR2025-26/static/_content/45-icon-1.png\"/>\n        \n        <h1 id=\"45-no\" class=\"abs brillCutMedium 45-no\" style=\"top:416px;left:404px; font-size: 1.3em; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 10000, \"comma\": true}' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg45Anim = new TimelineMax();\n          pg45Anim.fromTo(cOf(\"45-icon\"), 0.8, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, 1)\n          .fromTo(cOf(\"45-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"45-no\")[0])}}, \"-=0.4\");\n        }\n\n        function onPageLeave() {\n          pg45Anim.stop();\n          resetNumbers(\"45-no\");\n        }\n      ",
    "searchText": "10,000 The communities living around the Prespa Lakes, in the border region of Greece, Albania and North Macedonia, face a difficult challenge, needing to balance the conservation of the region's rich biodiversity with their socio-economic needs. A haven for fish, birds and mammals, the fragile Prespa ecosystem is under increasing pressure from unsustainable human activities, amplified by the impacts of climate change. THE SOCIETY FOR THE PROTECTION OF PRESPA (SPP) engages diverse local stakeholders in preserving the region's unique natural and cultural heritage through habitat restoration, environmental education and the promotion of nature-friendly livelihood opportunities, including sustainable agriculture and ecotourism. To date, SPP and its partners have restored and managed over 10,000 hectares of wetlands, reducing the negative impacts of fires and flooding.  hectares of wetland managed  Protecting nature, fostering resilience - 45"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 46,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg46.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 46-text\" style=\"top:91px;left:90px;\" src=\"/AR2025-26/static/_content/46-title-1.png\"/>\n        <img class=\"abs halfScale 46-text\" style=\"top:256px;left:90px;\" src=\"/AR2025-26/static/_content/46-text-1.png\"/>\n        <img class=\"abs halfScaleC 46-icon\" style=\"top:109px;left:278px;\" src=\"/AR2025-26/static/_content/46-icon-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg46Anim = new TimelineMax();\n          pg46Anim.staggerFromTo(cOf(\"46-text\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"46-icon\"), 0.8, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.4\")\n        }\n\n        function onPageLeave() {\n          pg46Anim.stop();\n        }\n      ",
    "searchText": "SELECTED HIGHLIGHTS FROM OUR PORTFOLIO Zero  Namibia's rhino, elephant and lion populations have grown thanks to sound conservation policies since independence in 1990, while they've plummeted in most neighbouring countries. IRDNC has been instrumental in this community-led wildlife conservation success story from the beginning and remains central to it today. In 2025, the organisation worked closely with 46 of the country's 86 community conservancies to strengthen their governance and natural resource management, create and expand sustainable income sources, and enable wildlife population growth and the related ecological benefits. Some 5 million hectares of community land are now managed by conservancies supported by IRDNC. In the Kunene region, IRDNC and its partner conservancies work with the Save the Rhino  46 - Protecting nature, fostering resilience  rhino poaching for five years  Trust, local community rangers, the Ministry of Environment, Forestry and Tourism, and the Namibian Police Force, to safeguard the world's largest free-roaming population of Black rhinos from the ever-present threat of poaching. Together, they keep the region's rhinos under constant watch, tracking each individual and recording its location daily. In total, these ranger teams cover more than 5,000 km on foot each year. The rhino's presence attracts tourists to the conservancies and thus generates income for local communities, creating a strong incentive to conserve this rare species. This locally led and anchored conservation model has been remarkably successful. Rhino poaching remains an acute challenge across Namibia and the wider region - but 2025 marked the fifth consecutive year without a single case of rhino poaching in the six IRDNC partner conservancies where the species occurs."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 47,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg47.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 47-text\" style=\"top:94px;left:235px;\" src=\"/AR2025-26/static/_content/47-text-1.png\"/>\n        <img class=\"abs halfScaleC 47-icon\" style=\"top:407px;left:388px;\" src=\"/AR2025-26/static/_content/47-icon-1.png\"/>\n\n        <h1 id=\"47-no\" class=\"abs brillCutMedium 47-no\" style=\"top:533px;left:486px; font-size: 1.3em; color: #27815b; padding: 0px; margin: 0px;\" data-number='{\"to\": 300, \"append\": \"%\"}' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg47Anim = new TimelineMax();\n          pg47Anim.fromTo(cOf(\"47-text\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"47-icon\"), 0.8, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.4\")\n          .fromTo(cOf(\"47-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"47-no\")[0])}}, \"-=0.4\")\n        }\n\n        function onPageLeave() {\n          pg47Anim.stop();\n          resetNumbers(\"47-no\");\n        }\n      ",
    "searchText": "Planet Indonesia supports indigenous people and local communities to steward their land and drive conservation. It works with over 100 community groups in West Kalimantan to govern more than 1.29 million hectares of forests, mangroves, and marine ecosystems. Over the last five years, their collective efforts have reduced deforestation by as much as 160%, illegal activities such as encroachment, hunting, and logging by 90%, and stabilised populations of several threatened species. Planet Indonesia has been scaling this transformative work across Indonesia since 2022. It partners with, strengthens and financially supports smaller, locally-rooted civil society organisations to adapt its model to their own contexts. Planet Indonesia currently has ten active partnerships with local organisations from Sumatra to the  Maluku Islands, supporting the conservation of 375,000 hectares. Many of these partners have had remarkable impact since they began working with Planet Indonesia. For example, communities in Sulawesi have reduced forest loss by nearly 300% with JAPESDA, while also sharply reducing illegal activities and promoting sustainable farming. In Sumatra, two communities working with AKAR cut deforestation by 61% and 44% respectively. This approach is very cost-effective. Planet Indonesia estimates that a local organisation spends an average of USD 1.29 per hectare of protected land to implement Planet Indonesia's conservation model in a new area, while Planet Indonesia would spend USD 2.27 per hectare to do so on its own. Forest loss reduced by  300% with Japesda  Protecting nature, fostering resilience - 47"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 48,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg48.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 48-text\" style=\"top:90px;left:90px;\" src=\"/AR2025-26/static/_content/48-text-1.png\"/>\n        <img class=\"abs halfScaleC 48-icon\" style=\"top:190px;left:176px;\" src=\"/AR2025-26/static/_content/48-icon-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg48Anim = new TimelineMax();\n          pg48Anim.fromTo(cOf(\"48-text\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"48-icon\"), 0.8, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.4\")\n        }\n\n        function onPageLeave() {\n          pg48Anim.stop();\n        }\n      ",
    "searchText": "Rising Phoenix manages Cambodia's globally irreplaceable Siem Pang Wildlife Sanctuary, a haven for Critically Endangered bird, mammal and reptile species. It restores forests and key water sources in Siem Pang, while also reintroducing important lost species that play a key role in the ecosystem's natural processes. To secure the buy-in of local communities, the organisation helps families grow and sell organic, wildlife-friendly “Ibis rice” at a premium to generate a sustainable income. Participating farmers agree not to hunt or cut wood in the Sanctuary and take part in ecosystem restoration activities.  Banteng herd moved to safety  48 - Protecting nature, fostering resilience  In May 2025, Rising Phoenix and its government and NGO partners successfully completed a landmark wildlife capture and translocation: they moved a herd of sixteen rare Banteng from a degraded and dwindling forest patch to safety in the Siem Pang Wildlife Sanctuary in Cambodia's Stung Treng province. Banteng are a wild cattle species listed as Critically Endangered on the IUCN Red List of Threatened Species. Their numbers have declined dramatically as a result of snaring and shooting, to the point where the population in Cambodia now hovers around a thousand. Rising Phoenix's successful operation was the first-ever translocation of Banteng, and the first helicopter-assisted game capture in Cambodia. The herd has now settled successfully in Siem Pang, as evidenced by the birth of two additional calves in late 2025. By moving these Banteng to Siem Pang, Rising Phoenix not only saved the individual animals but also laid the foundation for re-establishing a viable population in the reserve."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 49,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg49.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 49-text\" style=\"top:89px;left:90px;\" src=\"/AR2025-26/static/_content/49-text-1.png\"/>\n        <img class=\"abs halfScaleC 49-icon\" style=\"top:472px;left:492px;\" src=\"/AR2025-26/static/_content/49-icon-1.png\"/>\n\n        <h1 id=\"49-no\" class=\"abs brillCutMedium 49-no\" style=\"top:572px;left:569px; font-size: 0.95em; color: #27815b; padding: 0px; margin: 0px;\" data-number='{\"to\": 4600, \"comma\": true,\"append\": \" sq.km\"}' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg49Anim = new TimelineMax();\n          pg49Anim.fromTo(cOf(\"49-text\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"49-icon\"), 0.8, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.4\")\n          .fromTo(cOf(\"49-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"49-no\")[0])}}, \"-=0.4\")\n        }\n\n        function onPageLeave() {\n          pg49Anim.stop();\n          resetNumbers(\"49-no\");\n        }\n      ",
    "searchText": "Mongolia's Gobi is a unique but changing dryland landscape that offers a crucial habitat for the country's nomadic wildlife – gazelles, khulan, snow leopards and other species – but also provides vast rangelands for pastoralists to graze their livestock. Intensifying climate change, mining operations and the construction of roads pose growing threats to wildlife. Linear infrastructure such as railways also cut across ancient migration routes, leaving animals to move along fence lines and railway tracks in search of crossings that no longer exist. To tackle these challenges, the Wildlife Conservation Society (WCS) Mongolia works with herder groups in the South Gobi region to sustainably manage and protect water sources and grasslands for wildlife as well as livestock. It also engages with authorities, railway operators and private sector partners to improve wildlife passage across railways and other linear infrastructures. When this work started, in early 2024, there was very little conservation outside of protected areas in this region. By April 2026, WCS had supported seven local herder groups to bring 4,600 sq. km of  Gobi habitat under active community monitoring and management, with 2,800 sq. km secured under formal agreements that strengthen community rights and responsibilities for natural resource management. Many of these areas are important wildlife corridors. Across these landscapes, 23 trained community rangers had covered more than 10,000 km during patrols, detecting and reporting illegal activity and collecting real-time data on wildlife, water sources and rare plants. In parallel, WCS teams are addressing the threat that linear infrastructure poses to animal migrations. They have studied the way gazelles and khulans use crossing points with camera traps and GPS collars, building evidence to guide more effective measures to secure their mobility. The region's first two herder groups are now working on mobility solutions for people and wildlife.  4,600 sq. km under active community management  Protecting nature, fostering resilience - 49"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 50,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg50.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 51,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg51.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 51-text\" style=\"top:185px;left:90px;\" src=\"/AR2025-26/static/_content/51-title-1.png\"/>\n        <img class=\"abs halfScale 51-text\" style=\"top:554px;left:90px;\" src=\"/AR2025-26/static/_content/51-text-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg51Anim = new TimelineMax();\n          pg51Anim.staggerFromTo(cOf(\"51-text\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n        }\n\n        function onPageLeave() {\n          pg51Anim.stop();\n        }\n      ",
    "searchText": "A FOREST'S LONG ROAD TO RECOVERY Ecuador's Chocó region, which stretches from the foothills of the Andes to the Pacific Ocean, is one of the most biodiverse ecoregions on Earth. It supports an astonishing array of rare plants and animals, including rare mammals such as the jaguar and mountain tapir, thousands of different kinds of flowers and eight percent of the world's known bird species. However, one would hardly suspect such richness of life on approaching the Chocó from Ecuador's capital, Quito. Driving past miles of monoculture, the deforestation that has devastated much of the region is all too obvious. 97% of Western Ecuador's lowland forests have vanished in just 70 years – and countless animals have disappeared with them.  This diversity of habitats not only makes Canandé and its surrounding areas a vital refuge for rare species but also means it could be a laboratory for studying how a tropical forest ecosystem can recover over time if given the chance.  Nonetheless, nature not only persists in the Chocó, it is making a comeback thanks to the long-term conservation efforts of Fundación Jocotoco. Some of the Chocó's most pristine remaining habitats can be found in the Canandé reserve, established by Jocotoco through a land purchase in 2000, and now covering 19,500 hectares. Here, patches of untouched old-growth forest are interspersed with younger, so-called “secondary” forest that has reclaimed abandoned farmland through natural regeneration in recent decades.  Protecting nature, fostering resilience - 51"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 52,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg52.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Working with 30 Ecuadorian and international universities, Schaefer and his teams have done just that, monitoring and mapping the distribution and abundance of thousands of species in Canandé using camera traps, acoustic monitoring devices, drones and DNA samples, among other methods.  same thing, but in a much shorter time, by measuring in over 60 locations that are at different stages if recovery. Jocotoco's research has revealed a compelling truth: when given the chance, nature is able to heal itself within 30 years. Secondary forests have recovered and  Jocotoco's detailed records and deep community ties have enabled it to retrace and map the history of the forest and determine how old each area is. It then designated more than 60 monitoring plots in which to identify and count species, including forest patches in different stages of recovery as well as areas actively used for agriculture and old-growth forest stands to set baselines. The recovery of a forest ecosystem takes decades. While it would be possible to document this journey by measuring biodiversity in the same patch of land year after year as it transitions from farmland to regrown forest, results would only emerge very slowly. Jocotoco's approach achieved the  regrown naturally in parts of the reserve that used to be pastures and cacao plantations, doing so without any active reforestation or reintroductions. After 30 years of recovery, these areas contain 90% of the number of species and 90% of the biomass weight of all animals found in mature forests. The species composition isn't quite the same yet, but three out of four of the original species that would have lived in the area before it was logged have returned. These results were published in the scientific journal “Nature” in April 2026. Along the way, Jocotoco partnered with scientists at the University of Stuttgart who made other remarkable scientific  52 - Protecting nature, fostering resilience"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 53,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg53.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScaleC 53-icon\" style=\"top:36px;left:266px;\" src=\"/AR2025-26/static/_content/53-icon-1.png\"/>\n\n        <h1 id=\"53-no\" class=\"abs brillCutMedium 53-no\" style=\"top:151px;left:388px; font-size: 1.3em; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 90, \"append\": \"%\"}' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg53Anim = new TimelineMax();\n          pg53Anim.fromTo(cOf(\"53-icon\"), 0.8, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, 1)\n          .fromTo(cOf(\"53-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"53-no\")[0])}}, \"-=0.4\")\n        }\n\n        function onPageLeave() {\n          pg53Anim.stop();\n          resetNumbers(\"53-no\");\n        }\n      ",
    "searchText": "90%  of wildlife recovered in 30 years  advancements. In 2025, while monitoring the return of jaguars to Canandé with camera traps, a research group was able to automate the individual identification of jaguars by their spot patterns, achieving an accuracy of 87%. This breakthrough – which had eluded specialists from some of the world's leading tech companies for years – will help speed up vital research work that previously took hundreds of hours of manpower. Jocotoco hopes that the progress its team has made will not only help make its own work more efficient, but also be useful for other researchers around the world. Another Jocotoco team has used camera traps and AI-powered acoustic monitoring  devices to understand where illegal activities such as logging or poaching are most prevalent, and to map these threats throughout the reserve - allowing them to focus conservation efforts where they are needed most. For Cartier Philanthropy for People and Nature, Jocotoco's findings are a beacon of hope. They show that nature can indeed recover when we give it space and time. While this is cause for celebration, it also serves as a cautionary reminder. Forests teeming with life can be destroyed rapidly, yet take decades to regain their vitality. Therefore, it is crucial to conserve existing intact ecosystems.  Protecting nature, fostering resilience - 53"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 54,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg54.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 55,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg55.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 55-text\" style=\"top:809px;left:91px;\" src=\"/AR2025-26/static/_content/55-title-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg55Anim = new TimelineMax();\n          pg55Anim.fromTo(cOf(\"55-text\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n        }\n\n        function onPageLeave() {\n          pg55Anim.stop();\n        }\n      ",
    "searchText": "RESPONDING TO EMERGENCIES, SUSTAINING LIFE"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 56,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg56.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Timely emergency relief for those struck by natural disasters, disease outbreaks or other disruptive events can save lives, reduce suffering and protect livelihoods. In the immediate aftermath, food, shelter, medical assistance and other humanitarian aid are generally most vital. But support can be equally critical months later, when the crisis has often faded from the world's attention. It can help repair damaged infrastructure, replace lost or destroyed assets, and boost livelihoods. Emergency interventions also play an important role in protecting the environment. They may take the form of short-term support for communities, ecosystems and threatened wildlife facing climate shocks or extreme weather events that would otherwise set back decades of conservation efforts. Our efforts in the focus area Emergency Relief therefore see us partnering with organisations that have the expertise and experience to provide relief rapidly and at scale in difficult contexts.  56 - Responding to emergencies, sustaining life"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 57,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg57.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 57-text\" style=\"top:143px;left:90px;\" src=\"/AR2025-26/static/_content/57-text-1.png\"/>\n        <img class=\"abs halfScaleC 57-icon\" style=\"top:376px;left:448px;\" src=\"/AR2025-26/static/_content/57-icon-1.png\"/>\n\n        <h1 id=\"57-no\" class=\"abs brillCutMedium 57-no\" style=\"top:492px;left:534px; font-size: 1.3em; color: #b09456; padding: 0px; margin: 0px;\" data-number='{\"to\": 50000, \"comma\": true}' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg57Anim = new TimelineMax();\n          pg57Anim.fromTo(cOf(\"57-text\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"57-icon\"), 0.8, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.4\")\n          .fromTo(cOf(\"57-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"57-no\")[0])}}, \"-=0.4\")\n        }\n\n        function onPageLeave() {\n          pg57Anim.stop();\n          resetNumbers(\"57-no\");\n        }\n      ",
    "searchText": "When a 7.7-magnitude earthquake devastated Myanmar on 28 March 2025, we moved swiftly to support the relief operations of Medical Action Myanmar (MAM).  More than  50,000 In the weeks following the earthquake, MAM provided immediate medical treatment for more than 10,000 people suffering from injuries and acute infections, distributed over 1 million litres of safe drinking water, and installed more than 40 mobile toilets. It also distributed over 8,000 household kits including medical and hygiene supplies and tarpaulins, while providing cash and food assistance to over 50,000 people. Following this initial phase, MAM transitioned from immediate relief to recovery-focused interventions, including the operation of two temporary clinics, the provision of mental health and psychosocial support for individuals affected by postdisaster stress and trauma, and the drilling of 2 boreholes to provide reliable water sources.  people supported  In addition to supporting MAM, we allocated an emergency grant to our long-term partner Proximity Designs to assist smallholder farmers affected by the earthquake to restore the health and productivity of their soils. The disaster caused a widespread loss of soil nutrients due to soil compaction, increased sandy soil and, in some areas, soil liquefaction. To address this serious threat to crop productivity, Proximity Designs distributed over 10,000 agricultural input packages to help boost soil health and give the most severely impacted farming families a better chance of securing a good harvest.  Responding to emergencies, sustaining life - 57"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 58,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg58.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 58-text\" style=\"top:89px;left:90px;\" src=\"/AR2025-26/static/_content/58-text-1.png\"/>\n        <img class=\"abs halfScaleC 58-icon\" style=\"top:286px;left:479px;\" src=\"/AR2025-26/static/_content/58-icon-1.png\"/>\n\n        <h1 id=\"58-no\" class=\"abs brillCutMedium 58-no\" style=\"top:390px;left:557px; font-size: 1.3em; color: #b09456; padding: 0px; margin: 0px;\" data-number='{\"to\": 300000, \"comma\": true}' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg58Anim = new TimelineMax();\n          pg58Anim.fromTo(cOf(\"58-text\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"58-icon\"), 0.8, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.4\")\n          .fromTo(cOf(\"58-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"58-no\")[0])}}, \"-=0.4\")\n        }\n\n        function onPageLeave() {\n          pg58Anim.stop();\n          resetNumbers(\"58-no\");\n        }\n      ",
    "searchText": "Afghanistan continues to face one of the world's most acute humanitarian crises. An estimated 21.9 million people - 45% of the population - require humanitarian assistance, including 14.4 million in urgent need of healthcare and 7.5 million who require immediate nutritional support. With the recent reduction in international aid budgets, many of these vital needs are unmet. In August 2025, the crisis reached a new critical point when an earthquake struck 12 districts in eastern Afghanistan, near the border with Pakistan. Medair has been providing essential healthcare, nutrition, water and sanitation to people in Afghanistan since 1996. We supported its efforts to provide life-saving medical supplies  to clinics that faced stock shortages due to global aid funding cuts. In total, more than 300,000 doses of medicine were supplied to partners on the ground through this effort. Additional support was provided for the thousands of people affected by the earthquake. This included the provision of emergency shelter kits (tents and tarpaulins), basic hygiene items, access to clean water and basic healthcare, and nutrition. Over  300,000 doses of medicine provided  58 - Responding to emergencies, sustaining life"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 59,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg59.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 59-text\" style=\"top:391px;left:386px;\" src=\"/AR2025-26/static/_content/59-text-1.png\"/>\n        <img class=\"abs halfScaleC 59-icon\" style=\"top:83px;left:274px;\" src=\"/AR2025-26/static/_content/59-icon-1.png\"/>\n\n        <h1 id=\"59-no\" class=\"abs brillCutMedium 59-no\" style=\"top:180px;left:356px; font-size: 1.3em; color: #b09456; padding: 0px; margin: 0px;\" data-number='{\"to\": 5000, \"comma\": true, \"preppend\": \"> \"}' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg59Anim = new TimelineMax();\n          pg59Anim.fromTo(cOf(\"59-text\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"59-icon\"), 0.8, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.4\")\n          .fromTo(cOf(\"59-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"59-no\")[0])}}, \"-=0.4\")\n        }\n\n        function onPageLeave() {\n          pg59Anim.stop();\n          resetNumbers(\"59-no\");\n        }\n      ",
    "searchText": "> 5,000 malnourished children treated  The recurring armed conflict in the east of the Democratic Republic of Congo (DRC) has displaced almost one million people, mainly in and around Goma. Ongoing instability and violence have left many families without reliable access to food, water or medical care. In 2025, we provided emergency support for Médecins Sans Frontières (MSF) to help meet these displaced populations' immediate needs. MSF is one of the few organisations still providing medical services and other humanitarian assistance in the region. In response to the ever-changing situation on the ground, MSF deployed mobile clinics, helped strengthen existing health centres facing sharp increases in patients, and continued providing care in several health centres and hospitals across North Kivu province. It also offered dedicated support to victims of sexual violence and responded to urgent healthcare needs in the remote Angumu region, northwest of Goma.  Responding to emergencies, sustaining life - 59"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 60,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg60.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 61,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg61.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 61-text\" style=\"top:740px;left:288px;\" src=\"/AR2025-26/static/_content/61-title-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg61Anim = new TimelineMax();\n          pg61Anim.fromTo(cOf(\"61-text\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n        }\n\n        function onPageLeave() {\n          pg61Anim.stop();\n        }\n      ",
    "searchText": "STRENGTHENING ORGANISATIONS, DEEPENING IMPACT"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 62,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg62.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "The challenges non-profits face in helping vulnerable communities and ecosystems to thrive are complex and multi-layered. To tackle them successfully, these organisations need flexible, long-term funding – the provision of which is our primary role. However, to maximise their impact, even the best non-profits sometimes need skills and capabilities that may not be readily available to them. Some may struggle to communicate clearly and effectively, including who they are and why their work matters, which can limit their reach and ability to attract support. Others may need to fine-tune their understanding of people's behaviours so they can adjust their interventions to generate more positive outcomes. And some may need support in collecting, analysing and visualising data to gain a deeper understanding of the impact of their interventions and make informed decisions. We offer our partners the tailored support of specialist non-profit consultancies when needed to help overcome these challenges.  62 - Strengthening organisations, deepening impact"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 63,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg63.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 63-title\" style=\"top:90px;left:91px;\" src=\"/AR2025-26/static/_content/63-title-1.png\"/>\n        \n        <img class=\"abs halfScaleC 63-icon\" style=\"top:133px;left:15px;\" src=\"/AR2025-26/static/_content/63-icon-1.png\"/>\n        <img class=\"abs halfScaleC 63-icon\" style=\"top:347px;left:15px;\" src=\"/AR2025-26/static/_content/63-icon-2.png\"/>\n        <img class=\"abs halfScaleC 63-icon\" style=\"top:557px;left:15px;\" src=\"/AR2025-26/static/_content/63-icon-3.png\"/>\n        \n        <img class=\"abs halfScale 63-text\" style=\"top:266px;left:209px;\" src=\"/AR2025-26/static/_content/63-text-1.png\"/>\n        <img class=\"abs halfScale 63-text\" style=\"top:480px;left:208px;\" src=\"/AR2025-26/static/_content/63-text-2.png\"/>\n        <img class=\"abs halfScale 63-text\" style=\"top:690px;left:230px;\" src=\"/AR2025-26/static/_content/63-text-3.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg63Anim = new TimelineMax();\n          pg63Anim.fromTo(cOf(\"63-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n          .staggerFromTo(cOf(\"63-icon\"), 0.8, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, 0.2, \"-=0.4\")\n          .staggerFromTo(cOf(\"63-text\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, \"-=1\")\n        }\n\n        function onPageLeave() {\n          pg63Anim.stop();\n        }\n      ",
    "searchText": "OUR CAPACITY BUILDING PARTNERS  Appleseed  Appleseed is a behavioural research non-profit that helps early- and growth-stage social enterprises and non-profits achieve increased impact by harnessing behavioural insights, supported by human-centred research.  IDinsight  Mighty Ally  IDinsight is a global advisory, data analytics and research organisation that helps leaders in governments, non-profits and multilateral agencies in Asia and Africa generate and use evidence to inform decision-making and maximise social impact.  Mighty Ally guides non-profits to build findable and fundable brands to maximise funding. Mighty Ally has partnered with more than 500 non-profits fighting poverty and injustice in dozens of countries.  Strengthening organisations, deepening impact - 63"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 64,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg64.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "64"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 65,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg65.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 65-title\" style=\"top:91px;left:90px;\" src=\"/AR2025-26/static/_content/65-title-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg65Anim = new TimelineMax();\n          pg65Anim.fromTo(cOf(\"65-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n        }\n\n        function onPageLeave() {\n          pg65Anim.stop();\n        }\n      ",
    "searchText": "ALL OUR PARTNERS DURING THE FINANCIAL YEAR 2026 (1 APRIL 2025 – 31 MARCH 2026)  65"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 66,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg66.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 66-icon\" style=\"top:90px;left:90px;\" src=\"/AR2025-26/static/_content/66-icon-1.png\"/>\n        <img class=\"abs halfScale 66-icon\" style=\"top:228px;left:90px;\" src=\"/AR2025-26/static/_content/66-icon-2.png\"/>\n        <img class=\"abs halfScale 66-icon\" style=\"top:329px;left:90px;\" src=\"/AR2025-26/static/_content/66-icon-3.png\"/>\n        <img class=\"abs halfScale 66-icon\" style=\"top:457px;left:90px;\" src=\"/AR2025-26/static/_content/66-icon-4.png\"/>\n        <img class=\"abs halfScale 66-icon\" style=\"top:573px;left:90px;\" src=\"/AR2025-26/static/_content/66-icon-5.png\"/>\n        <img class=\"abs halfScale 66-icon\" style=\"top:89px;left:395px;\" src=\"/AR2025-26/static/_content/66-icon-6.png\"/>\n        <img class=\"abs halfScale 66-icon\" style=\"top:228px;left:395px;\" src=\"/AR2025-26/static/_content/66-icon-7.png\"/>\n        <img class=\"abs halfScale 66-icon\" style=\"top:385px;left:395px;\" src=\"/AR2025-26/static/_content/66-icon-8.png\"/>\n        <img class=\"abs halfScale 66-icon\" style=\"top:541px;left:395px;\" src=\"/AR2025-26/static/_content/66-icon-9.png\"/>\n        <img class=\"abs halfScale 66-icon\" style=\"top:689px;left:395px;\" src=\"/AR2025-26/static/_content/66-icon-10.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg66Anim = new TimelineMax();\n          pg66Anim.staggerFromTo(cOf(\"66-icon\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n        }\n\n        function onPageLeave() {\n          pg66Anim.stop();\n        }\n      ",
    "searchText": "Producing clean and affordable drinking water for underserved communities through innovative social business models  Harnessing behavioural insights to maximise the efficiency of social and environmental programmes.  CAMBODIA, MADAGASCAR  GLOBAL  Meeting the basic shelter, education, nutrition and health needs of Manila's street children PHILIPPINES  Providing scholarships for women from under-privileged backgrounds to become the African leaders of tomorrow GHANA  Equipping small-scale fishers to fish sustainably and sell at a premium on markets which value traceability SOUTH AFRICA  Bridging gaps that prevent the small-scale agriculture sector in Africa from accessing suitable business loans  Improving the wellbeing of children and migrant worker families in construction site camps THAILAND  AFRICA  Al Shouf Cedar Society  Assisting farmers to conserve a fragile ecosystem, increase their income and reduce the risk of forest fires LEBANON  Creating forest conservation incentives for farmers and strengthening the capacity of local conservationists for long-term impact SÃO TOMÉ & PRÍNCIPE  Empowering coastal communities to conserve and restore mangroves and fisheries and manage them sustainably MADAGASCAR  66"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 67,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg67.jpg",
    "zoom": null,
    "content": "       \n        <img class=\"abs halfScale 67-icon\" style=\"top:90px;left:90px;\" src=\"/AR2025-26/static/_content/67-icon-1.png\"/>\n        <img class=\"abs halfScale 67-icon\" style=\"top:219px;left:90px;\" src=\"/AR2025-26/static/_content/67-icon-2.png\"/>\n        <img class=\"abs halfScale 67-icon\" style=\"top:335px;left:90px;\" src=\"/AR2025-26/static/_content/67-icon-3.png\"/>\n        <img class=\"abs halfScale 67-icon\" style=\"top:459px;left:90px;\" src=\"/AR2025-26/static/_content/67-icon-4.png\"/>\n        <img class=\"abs halfScale 67-icon\" style=\"top:581px;left:90px;\" src=\"/AR2025-26/static/_content/67-icon-5.png\"/>\n        <img class=\"abs halfScale 67-icon\" style=\"top:716px;left:90px;\" src=\"/AR2025-26/static/_content/67-icon-6.png\"/>\n        <img class=\"abs halfScale 67-icon\" style=\"top:90px;left:395px;\" src=\"/AR2025-26/static/_content/67-icon-7.png\"/>\n        <img class=\"abs halfScale 67-icon\" style=\"top:224px;left:395px;\" src=\"/AR2025-26/static/_content/67-icon-8.png\"/>\n        <img class=\"abs halfScale 67-icon\" style=\"top:355px;left:395px;\" src=\"/AR2025-26/static/_content/67-icon-9.png\"/>\n        <img class=\"abs halfScale 67-icon\" style=\"top:476px;left:395px;\" src=\"/AR2025-26/static/_content/67-icon-10.png\"/>\n        <img class=\"abs halfScale 67-icon\" style=\"top:602px;left:395px;\" src=\"/AR2025-26/static/_content/67-icon-11.png\"/>\n        <img class=\"abs halfScale 67-icon\" style=\"top:726px;left:395px;\" src=\"/AR2025-26/static/_content/67-icon-12.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg67Anim = new TimelineMax();\n          pg67Anim.staggerFromTo(cOf(\"67-icon\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n        }\n\n        function onPageLeave() {\n          pg67Anim.stop();\n        }\n      ",
    "searchText": "Supporting women in dryland pastoral communities to start micro-businesses in small groups through a poverty graduation approach ETHIOPIA  Providing households with a path out of extreme poverty following a poverty graduation approach TANZANIA  Making salaried, skilled, supervised, and supplied community health workers the norm worldwide GLOBAL  Training community health workers to address social as well as medical needs in underserved communities UNITED STATES  Monitoring populations, conserving habitats, and reducing human-wildlife conflict to protect China's iconic snow leopards CHINA  Supporting local communities in managing natural resources sustainably, for the benefit of people and wildlife GLOBAL  Setting-up and managing pooled funds to advance gender equality and women's leadership GLOBAL  Summarising scientific research evidence and making it widely available to support effective conservation worldwide GLOBAL  Supporting wildlife conservation by empowering small farmers and ex-poachers with farming practices that restore soil health and boost production ZAMBIA  Improving learners' literacy and critical thinking in under-resourced middle and high schools using high-quality instructional materials UNITED STATES  Pioneering a conservation scheme that uses cash payments to incentivise farmers to protect intact forests on their land COMOROS  Helping students improve their maths skills through an AI-powered chatbot based on the official curriculum JORDAN  67"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 68,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg68.jpg",
    "zoom": null,
    "content": "       \n        <img class=\"abs halfScale 68-icon\" style=\"top:90px;left:90px;\" src=\"/AR2025-26/static/_content/68-icon-1.png\"/>\n        <img class=\"abs halfScale 68-icon\" style=\"top:227px;left:90px;\" src=\"/AR2025-26/static/_content/68-icon-2.png\"/>\n        <img class=\"abs halfScale 68-icon\" style=\"top:336px;left:90px;\" src=\"/AR2025-26/static/_content/68-icon-3.png\"/>\n        <img class=\"abs halfScale 68-icon\" style=\"top:462px;left:90px;\" src=\"/AR2025-26/static/_content/68-icon-4.png\"/>\n        <img class=\"abs halfScale 68-icon\" style=\"top:589px;left:90px;\" src=\"/AR2025-26/static/_content/68-icon-5.png\"/>\n        <img class=\"abs halfScale 68-icon\" style=\"top:722px;left:90px;\" src=\"/AR2025-26/static/_content/68-icon-6.png\"/>\n        <img class=\"abs halfScale 68-icon\" style=\"top:90px;left:395px;\" src=\"/AR2025-26/static/_content/68-icon-7.png\"/>\n        <img class=\"abs halfScale 68-icon\" style=\"top:224px;left:395px;\" src=\"/AR2025-26/static/_content/68-icon-8.png\"/>\n        <img class=\"abs halfScale 68-icon\" style=\"top:399px;left:395px;\" src=\"/AR2025-26/static/_content/68-icon-9.png\"/>\n        <img class=\"abs halfScale 68-icon\" style=\"top:551px;left:395px;\" src=\"/AR2025-26/static/_content/68-icon-10.png\"/>\n        <img class=\"abs halfScale 68-icon\" style=\"top:709px;left:395px;\" src=\"/AR2025-26/static/_content/68-icon-11.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg68Anim = new TimelineMax();\n          pg68Anim.staggerFromTo(cOf(\"68-icon\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n        }\n\n        function onPageLeave() {\n          pg68Anim.stop();\n        }\n      ",
    "searchText": "Development Media International  Promoting health-seeking behaviour in remote communities through engaging TV, radio and digital mass-media campaigns  Conserving biodiversity by creating and managing nature reserves that protect habitats and threatened species  TANZANIA  ECUADOR  Providing real-time information and support to smallholder farmers through an AI-enabled digital app INDIA  Gorongosa Restoration Project  Conserving biodiversity by supporting sustainable livelihoods in regenerative agriculture, crafts and tourism in the national park buffer zone MOZAMBIQUE  Mobilising rural communities to ensure all girls have access to quality education and learn INDIA  Building farmers' food and income security with sustainable practices to protect biodiverse forests and wildlife  Breaking the poverty cycle by building up opportunities for all to thrive in school, work, health and life UNITED STATES  NICARAGUA  Providing affordable, nutritious meals to improve children's attendance and learning in state schools KENYA  Designing, installing and servicing affordable, clean off-grid toilets in dense informal urban settlements KENYA, ZAMBIA  68  Training teachers to provide essential health services to Zambian state school students ZAMBIA  Training and equipping local communities to manage wildlife conservation areas effectively to shape their own futures TANZANIA"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 69,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg69.jpg",
    "zoom": null,
    "content": "       \n        <img class=\"abs halfScale 69-icon\" style=\"top:90px;left:90px;\" src=\"/AR2025-26/static/_content/69-icon-1.png\"/>\n        <img class=\"abs halfScale 69-icon\" style=\"top:204px;left:90px;\" src=\"/AR2025-26/static/_content/69-icon-2.png\"/>\n        <img class=\"abs halfScale 69-icon\" style=\"top:340px;left:90px;\" src=\"/AR2025-26/static/_content/69-icon-3.png\"/>\n        <img class=\"abs halfScale 69-icon\" style=\"top:465px;left:90px;\" src=\"/AR2025-26/static/_content/69-icon-4.png\"/>\n        <img class=\"abs halfScale 69-icon\" style=\"top:627px;left:90px;\" src=\"/AR2025-26/static/_content/69-icon-5.png\"/>\n        <img class=\"abs halfScale 69-icon\" style=\"top:90px;left:395px;\" src=\"/AR2025-26/static/_content/69-icon-6.png\"/>\n        <img class=\"abs halfScale 69-icon\" style=\"top:210px;left:395px;\" src=\"/AR2025-26/static/_content/69-icon-7.png\"/>\n        <img class=\"abs halfScale 69-icon\" style=\"top:358px;left:395px;\" src=\"/AR2025-26/static/_content/69-icon-8.png\"/>\n        <img class=\"abs halfScale 69-icon\" style=\"top:512px;left:395px;\" src=\"/AR2025-26/static/_content/69-icon-9.png\"/>\n        <img class=\"abs halfScale 69-icon\" style=\"top:648px;left:395px;\" src=\"/AR2025-26/static/_content/69-icon-10.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg69Anim = new TimelineMax();\n          pg69Anim.staggerFromTo(cOf(\"69-icon\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n        }\n\n        function onPageLeave() {\n          pg69Anim.stop();\n        }\n      ",
    "searchText": "Providing non-profits with monitoring and evaluation support to improve their social impact GLOBAL  Connecting community health workers with medical specialists through telemedicine to better serve rural patients' health needs INDIA, CENTRAL ASIA  International Development Enterprises  Nurturing adolescents' personal development and learning potential for them to succeed in life LEBANON, MADAGASCAR  Recruiting and training farm business entrepreneurs to provide smallholder farmers with access to quality inputs and services for improved livelihoods ZAMBIA  Addressing learning poverty through tech enabled, self-paced learning on tablet computers for primary school children SIERRA LEONE  Empowering local communities to manage natural resources and protect wildlife through secured legal rights, improved governance and income generation NAMIBIA  Supporting women eco-artisans from tribal communities to set-up craft cooperatives to improve their livelihoods INDIA  Providing vital health information to pregnant women and new mothers, and strengthening health systems through digital tools KENYA  Improving health outcomes and saving lives by strengthening primary healthcare systems in rural areas GUINEA, TOGO  Designing and selling affordable greenhouses backed by agronomic advisory support to improve smallholder farmers' incomes and resilience to climate change INDIA  69"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 70,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg70.jpg",
    "zoom": null,
    "content": "       \n        <img class=\"abs halfScale 70-icon\" style=\"top:90px;left:90px;\" src=\"/AR2025-26/static/_content/70-icon-1.png\"/>\n        <img class=\"abs halfScale 70-icon\" style=\"top:227px;left:90px;\" src=\"/AR2025-26/static/_content/70-icon-2.png\"/>\n        <img class=\"abs halfScale 70-icon\" style=\"top:366px;left:90px;\" src=\"/AR2025-26/static/_content/70-icon-3.png\"/>\n        <img class=\"abs halfScale 70-icon\" style=\"top:505px;left:90px;\" src=\"/AR2025-26/static/_content/70-icon-4.png\"/>\n        <img class=\"abs halfScale 70-icon\" style=\"top:638px;left:90px;\" src=\"/AR2025-26/static/_content/70-icon-5.png\"/>\n        <img class=\"abs halfScale 70-icon\" style=\"top:752px;left:90px;\" src=\"/AR2025-26/static/_content/70-icon-6.png\"/>\n        <img class=\"abs halfScale 70-icon\" style=\"top:90px;left:395px;\" src=\"/AR2025-26/static/_content/70-icon-7.png\"/>\n        <img class=\"abs halfScale 70-icon\" style=\"top:198px;left:395px;\" src=\"/AR2025-26/static/_content/70-icon-8.png\"/>\n        <img class=\"abs halfScale 70-icon\" style=\"top:311px;left:395px;\" src=\"/AR2025-26/static/_content/70-icon-9.png\"/>\n        <img class=\"abs halfScale 70-icon\" style=\"top:428px;left:395px;\" src=\"/AR2025-26/static/_content/70-icon-10.png\"/>\n        <img class=\"abs halfScale 70-icon\" style=\"top:545px;left:395px;\" src=\"/AR2025-26/static/_content/70-icon-11.png\"/>\n        <img class=\"abs halfScale 70-icon\" style=\"top:660px;left:395px;\" src=\"/AR2025-26/static/_content/70-icon-12.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg70Anim = new TimelineMax();\n          pg70Anim.staggerFromTo(cOf(\"70-icon\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n        }\n\n        function onPageLeave() {\n          pg70Anim.stop();\n        }\n      ",
    "searchText": "Building a network of quality, low-fee creches for children under three, run by women micro-entrepreneurs in urban informal settlements  Providing essential healthcare in humanitarian crises GLOBAL  KENYA  Helping non-profits develop their brands to optimise their fundraising Helping children in rural areas reach learning goals through language-adapted curricula and improved teaching  GLOBAL  INDIA  Providing nonsurgical clubfoot treatment for children in low and middle-income countries Giving out-of-school children a second chance to learn and continue their education in state schools ETHIOPIA, GAMBIA, GHANA, LEBANON, LIBERIA  GLOBAL  Offering quality daycare and meals for migrant workers' children INDIA  Protecting coral ecosystems by engaging authorities, fishing communities and other stakeholders in sustainable marine resource management SPAIN  Reporting on innovative, climate-smart conservation to inform and support effective biodiversity protection GLOBAL  Engaging pastoralists to improve herd health, strengthen livelihoods and protect pastures for livestock and wildlife ZAMBIA  Providing essential health care in humanitarian crises GLOBAL  70  Employing women living with HIV as community health workers who deliver integrated primary healthcare services SOUTHERN AFRICA"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 71,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg71.jpg",
    "zoom": null,
    "content": "       \n        <img class=\"abs halfScale 71-icon\" style=\"top:90px;left:90px;\" src=\"/AR2025-26/static/_content/71-icon-1.png\"/>\n        <img class=\"abs halfScale 71-icon\" style=\"top:229px;left:90px;\" src=\"/AR2025-26/static/_content/71-icon-2.png\"/>\n        <img class=\"abs halfScale 71-icon\" style=\"top:376px;left:90px;\" src=\"/AR2025-26/static/_content/71-icon-3.png\"/>\n        <img class=\"abs halfScale 71-icon\" style=\"top:547px;left:90px;\" src=\"/AR2025-26/static/_content/71-icon-4.png\"/>\n        <img class=\"abs halfScale 71-icon\" style=\"top:697px;left:90px;\" src=\"/AR2025-26/static/_content/71-icon-5.png\"/>\n        <img class=\"abs halfScale 71-icon\" style=\"top:90px;left:395px;\" src=\"/AR2025-26/static/_content/71-icon-6.png\"/>\n        <img class=\"abs halfScale 71-icon\" style=\"top:237px;left:395px;\" src=\"/AR2025-26/static/_content/71-icon-7.png\"/>\n        <img class=\"abs halfScale 71-icon\" style=\"top:400px;left:395px;\" src=\"/AR2025-26/static/_content/71-icon-8.png\"/>\n        <img class=\"abs halfScale 71-icon\" style=\"top:554px;left:395px;\" src=\"/AR2025-26/static/_content/71-icon-9.png\"/>\n        <img class=\"abs halfScale 71-icon\" style=\"top:658px;left:395px;\" src=\"/AR2025-26/static/_content/71-icon-10.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg71Anim = new TimelineMax();\n          pg71Anim.staggerFromTo(cOf(\"71-icon\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n        }\n\n        function onPageLeave() {\n          pg71Anim.stop();\n        }\n      ",
    "searchText": "Providing free access to quality sexual and reproductive health services for girls and women SENEGAL  Reducing child mortality through proactive home visits by community health workers and faster access to health centres CÔTE D'IVOIRE, MALI  Saving the lives of mothers and newborns by training medical staff and upgrading health facilities to be safe for childbirth NEPAL  Orda Ethiopia  Restoring and connecting Ethiopia's sacred forests as a stepping stone to wider restoration of the landscape ETHIOPIA  Providing affordable layaway packages of improved seeds and fertilizers as well as poultry for smallholder farmers to increase their incomes SENEGAL  Equipping family caregivers with the know-how to support hospitalised loved ones upon their return home and reduce re-admission  Protecting leopards by providing synthetic alternatives to the leopard skins used in traditional and religious ceremonies and gatherings SOUTH AFRICA, ZAMBIA  Sustainably managing a landscape of significant economic, cultural and natural value SWITZERLAND  BANGLADESH, INDONESIA, INDIA, NEPAL  Supplying affordable input packages of improved seeds and fertilisers, plus trainings, to help smallholder farmers increase yields  Improving herding practices to regenerate the land, reduce human-wildlife conflict and develop the wildlife economy SOUTH AFRICA, ZAMBIA  RWANDA  71"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 72,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg72.jpg",
    "zoom": null,
    "content": "       \n        <img class=\"abs halfScale 72-icon\" style=\"top:90px;left:90px;\" src=\"/AR2025-26/static/_content/72-icon-1.png\"/>\n        <img class=\"abs halfScale 72-icon\" style=\"top:234px;left:90px;\" src=\"/AR2025-26/static/_content/72-icon-2.png\"/>\n        <img class=\"abs halfScale 72-icon\" style=\"top:376px;left:90px;\" src=\"/AR2025-26/static/_content/72-icon-3.png\"/>\n        <img class=\"abs halfScale 72-icon\" style=\"top:555px;left:90px;\" src=\"/AR2025-26/static/_content/72-icon-4.png\"/>\n        <img class=\"abs halfScale 72-icon\" style=\"top:741px;left:90px;\" src=\"/AR2025-26/static/_content/72-icon-5.png\"/>\n        <img class=\"abs halfScale 72-icon\" style=\"top:90px;left:395px;\" src=\"/AR2025-26/static/_content/72-icon-6.png\"/>\n        <img class=\"abs halfScale 72-icon\" style=\"top:237px;left:395px;\" src=\"/AR2025-26/static/_content/72-icon-7.png\"/>\n        <img class=\"abs halfScale 72-icon\" style=\"top:388px;left:395px;\" src=\"/AR2025-26/static/_content/72-icon-8.png\"/>\n        <img class=\"abs halfScale 72-icon\" style=\"top:544px;left:395px;\" src=\"/AR2025-26/static/_content/72-icon-9.png\"/>\n        <img class=\"abs halfScale 72-icon\" style=\"top:697px;left:395px;\" src=\"/AR2025-26/static/_content/72-icon-10.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg72Anim = new TimelineMax();\n          pg72Anim.staggerFromTo(cOf(\"72-icon\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n        }\n\n        function onPageLeave() {\n          pg72Anim.stop();\n        }\n      ",
    "searchText": "Providing essential healthcare and supporting patients through a continuum of care in partnership with the Ministry of Health MADAGASCAR  Helping local communities establish cooperatives that monitor, protect and conserve threatened ecosystems INDONESIA  Proximity Designs  Designing and selling innovative agricultural products and services to help smallholder farmers increase their productivity and income MYANMAR  Supporting indigenous communities to secure land rights, establish protected areas and develop sustainable incomes  Restoring ecosystems and reintroducing previously lost wild species in degraded landscapes across Europe ROMANIA, SPAIN  Restoring forest ecosystems, reintroducing key species, and improving food security and cash income with a premium organic crop CAMBODIA  Leveraging the world's largest state daycare network by using AI-powered, play-based content and in-person coaching to ensure children achieve their development milestones INDIA  Reducing gender-based violence and harmful gender norms by engaging with young men and women RWANDA  PERU  Assisting vulnerable rural communities to lift themselves out of poverty UGANDA  72  Providing affordable, safe drinking water in rural Ghana using a last-mile water utility-style model GHANA"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 73,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg73.jpg",
    "zoom": null,
    "content": "       \n        <img class=\"abs halfScale 73-icon\" style=\"top:90px;left:90px;\" src=\"/AR2025-26/static/_content/73-icon-1.png\"/>\n        <img class=\"abs halfScale 73-icon\" style=\"top:237px;left:90px;\" src=\"/AR2025-26/static/_content/73-icon-2.png\"/>\n        <img class=\"abs halfScale 73-icon\" style=\"top:383px;left:90px;\" src=\"/AR2025-26/static/_content/73-icon-3.png\"/>\n        <img class=\"abs halfScale 73-icon\" style=\"top:530px;left:90px;\" src=\"/AR2025-26/static/_content/73-icon-4.png\"/>\n        <img class=\"abs halfScale 73-icon\" style=\"top:649px;left:90px;\" src=\"/AR2025-26/static/_content/73-icon-5.png\"/>\n        <img class=\"abs halfScale 73-icon\" style=\"top:90px;left:395px;\" src=\"/AR2025-26/static/_content/73-icon-6.png\"/>\n        <img class=\"abs halfScale 73-icon\" style=\"top:210px;left:395px;\" src=\"/AR2025-26/static/_content/73-icon-7.png\"/>\n        <img class=\"abs halfScale 73-icon\" style=\"top:349px;left:395px;\" src=\"/AR2025-26/static/_content/73-icon-8.png\"/>\n        <img class=\"abs halfScale 73-icon\" style=\"top:471px;left:395px;\" src=\"/AR2025-26/static/_content/73-icon-9.png\"/>\n        <img class=\"abs halfScale 73-icon\" style=\"top:601px;left:395px;\" src=\"/AR2025-26/static/_content/73-icon-10.png\"/>\n        <img class=\"abs halfScale 73-icon\" style=\"top:727px;left:395px;\" src=\"/AR2025-26/static/_content/73-icon-11.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg73Anim = new TimelineMax();\n          pg73Anim.staggerFromTo(cOf(\"73-icon\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n        }\n\n        function onPageLeave() {\n          pg73Anim.stop();\n        }\n      ",
    "searchText": "Reducing road fatalities by providing state administrations with hands-on technical assistance on road safety and emergency trauma care  Promoting community-led conservation to help ensure cultures, people and wildlife thrive in their shared landscape KENYA  INDIA  Producing affordable, drought-resistant biofortified maize seeds for smallholder farmers, and distributing them to address stunting and improve yields  Restoring the habitats of a fire-ravaged raptor refuge, monitoring wildlife and reducing biodiversity threats GREECE  GUATEMALA  Providing access to group therapy mental health care for people affected by depression Building a network of affordable daycare centres run by women micro-entrepreneurs to provide quality early learning opportunities for children under six  UGANDA, ZAMBIA, KENYA, UNITED STATES  SOUTH AFRICA  Conserving, restoring and sustainably managing a vulnerable cross-border wetland landscape  Providing leading non-profits with targeted expert support to leverage the power of AI for good GLOBAL  GREECE  Protecting ecosystems using indigenous fire management that reduces emissions and builds sustainable livelihoods AUSTRALIA  Providing safe container-based toilets and waste collection for underserved urban communities HAITI  Leveraging public, private and philanthropic funding for the future of critical ecosystems and their populations BURUNDI, MALAYSIA, THAILAND  73"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 74,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg74.jpg",
    "zoom": null,
    "content": "       \n        <img class=\"abs halfScale 74-icon\" style=\"top:90px;left:90px;\" src=\"/AR2025-26/static/_content/74-icon-1.png\"/>\n        <img class=\"abs halfScale 74-icon\" style=\"top:204px;left:90px;\" src=\"/AR2025-26/static/_content/74-icon-2.png\"/>\n        <img class=\"abs halfScale 74-icon\" style=\"top:349px;left:90px;\" src=\"/AR2025-26/static/_content/74-icon-3.png\"/>\n        <img class=\"abs halfScale 74-icon\" style=\"top:503px;left:90px;\" src=\"/AR2025-26/static/_content/74-icon-4.png\"/>\n        <img class=\"abs halfScale 74-icon\" style=\"top:644px;left:90px;\" src=\"/AR2025-26/static/_content/74-icon-5.png\"/>\n        <img class=\"abs halfScale 74-icon\" style=\"top:90px;left:395px;\" src=\"/AR2025-26/static/_content/74-icon-6.png\"/>\n        <img class=\"abs halfScale 74-icon\" style=\"top:251px;left:395px;\" src=\"/AR2025-26/static/_content/74-icon-7.png\"/>\n        <img class=\"abs halfScale 74-icon\" style=\"top:370px;left:395px;\" src=\"/AR2025-26/static/_content/74-icon-8.png\"/>\n        <img class=\"abs halfScale 74-icon\" style=\"top:519px;left:395px;\" src=\"/AR2025-26/static/_content/74-icon-9.png\"/>\n        <img class=\"abs halfScale 74-icon\" style=\"top:647px;left:395px;\" src=\"/AR2025-26/static/_content/74-icon-10.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg74Anim = new TimelineMax();\n          pg74Anim.staggerFromTo(cOf(\"74-icon\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n        }\n\n        function onPageLeave() {\n          pg74Anim.stop();\n        }\n      ",
    "searchText": "Developing and broadcasting culturally relevant TV and radio edutainment to support children's learning WEST, EAST AND SOUTHERN AFRICA  WCS Mongolia  Partnering with herders, authorities and railway operators to protect wildlife habitats and nomadic practices MONGOLIA  Empowering girls and boys to end genderbased violence through a programme delivered by state school teachers MALAWI  Assisting marginalised women in postconflict countries to develop agency, improve wellbeing and build livelihoods KOSOVO, RWANDA  Improving women's livelihoods through a poverty graduation programme that involves setting up micro-businesses and savings groups DR CONGO, ETHIOPIA, KENYA, MOZAMBIQUE, RWANDA, UGANDA  Designing and delivering heavy-duty bicycles for rural students, community healthcare workers and farmers to improve school attendance, healthcare and market access ZAMBIA  Deploying drones to overcome critical drug shortages and provide lab testing access in remote communities DR CONGO, MALAWI, MOZAMBIQUE  Providing vision tests by trained nonmedical staff and selling affordable reading glasses to increase the quality of life and earning potential of low-income workers BANGLADESH  74  Responding to hunger crises with food and cash assistance GLOBAL  Understanding and protecting vulnerable carnivore species and their habitats, and fostering coexistence with local communities ZAMBIA"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 75,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg75.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "75"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 76,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg76.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Governance Cartier Philanthropy for People and Nature (Cartier Philanthropy) is the Maison Cartier's grant-making foundation. Based in Geneva, Switzerland, it is governed by Swiss law and operates under the supervision of the Federal Supervisory Board for Foundations of the Swiss Federal Department of Home Affairs in Bern. Cartier Philanthropy is funded by Cartier but operates in full independence of its commercial interests. A Board of seven* members provides leadership and supervises Cartier Philanthropy's operations. During the reporting period, the Board members were: Cyrille Vigneron (President of the Board and Chairman of Cartier Culture and Philanthropy) and, in alphabetical order, Grégoire Blanche (Senior VP and Chief Commercial Officer, Cartier SA), Erica Lovett (VP Community & Workplace Engagement, Cartier North America), Wendy Luhabe (Non-Executive Director, Richemont), Pierre Rainero (Image, Style and Heritage Director of Cartier), and Jacqueline Ronconi (Head Counsel Cartier, Richemont). *One Board seat was vacant during the reporting period. It has been filled as of 1 April 2026 by Aurélie Bergugnat-Gerbel (Senior VP and Chief Financial Officer, Cartier SA).  Photo credits Cover: Ben Buckland / Cartier Philanthropy P. 4: Karin Schermbrucker / Cartier Philanthropy P. 6: Jason J Mulikita / Healthy Learners P. 8: Frank Papushka / Makmende Media P. 10: Muso / Makmende P. 12-13: Cyril Le Tourneur / Cartier Philanthropy P. 15: Darsel P. 16: Allan Gichigi / Jacaranda Health P. 16: RWAMREC P. 17: Tikeshwar Bastar / LLF P. 18: Jason J Mulikita / Healthy Learners P. 19: Monica Dalmasso / Cartier Philanthropy P. 20: Rocket Learning P. 21: Sara Hylton / Cartier Philanthropy P. 22: Noora Health P. 24: One Heart Worldwide; Noora Health; Noora Health P. 25: Naresh Newar / One Heart Worldwide; Simon Needham / One Heart Worldwide; Noora Health; Noora Health P. 26: Ben Buckland / Cartier Philanthropy P. 29: Digital Green P. 30: Raising the Village P. 31: Franz Thiel / Aceli Africa P. 31: Mafisa P. 32: Abalobi P. 33: Shatabdi Chakrabarti / Cartier Philanthropy P. 34: Proximity Designs P. 35: World Bicycle Relief P. 36: Andrea Borgarello / Cartier Philanthropy  P. 38: VisionSpring; Bracket limited / VisionSpring; VisionSpring P. 39: VisionSpring P. 40: Naiot Espinoza / Fairpicture P. 43: Panthera P. 43: Conserve Global P. 44: Javier Rebollo Ferrer / Marilles Foundation P. 44: nonophotography.ch / Jura Parc Vaudois P. 45: SPP / Francisco Marquez P. 46: Ben Buckland / Cartier Philanthropy P. 47: Planet Indonesia P. 48: Jonathan Eames / Rising Phoenix P. 49: Ben Buckland / Cartier Philanthropy P. 50-51: James Muchmore / Fundación Jocotoco P. 52: Alex Wiles / Fundación Jocotoco; James Muchmore / Fundación Jocotoco P. 53: Javier Anzar / Fundación Jocotoco; Leovigildo Cabrera / Fundación Jocotoco P. 54: Andrea Borgarello / Cartier Philanthropy P. 57: Medical Action Myanmar P. 58: Medair / Afghanistan P. 59: MSF P. 60: Ben Buckland / Cartier Philanthropy P. 64: Karin Schermbrucker / Cartier Philanthropy P. 75: Ben Buckland / Cartier Philanthropy P. 77: Karin Schermbrucker / Cartier Philanthropy  Address  Website  Rue André-De-Garrini 3 - CH-1217 Meyrin-Genève  www.cartierphilanthropy.org"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 77,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg77.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 78,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg78.jpg",
    "zoom": null,
    "content": "       \n        <img class=\"abs halfScale 78-title\" style=\"top:56px;left:89px;\" src=\"/AR2025-26/static/_content/78-title-1.png\"/>\n        \n        <img class=\"abs halfScaleC 78-map\" style=\"top:-53px;left:-288px;\" src=\"/AR2025-26/static/_content/78-map-1.png\"/>\n        <img class=\"abs halfScale 78-sub\" style=\"top:218px;left:322px;\" src=\"/AR2025-26/static/_content/78-sub-1.png\"/>\n        <h1 id=\"78-no\" class=\"abs brillCutRegular 78-no\" style=\"top:190px;left:185px; font-size: 4.5em; color: #6e7186; padding: 0px; margin: 0px;\"  data-number='{\"to\": 195}' ></h1>\n\n        <img class=\"abs halfScale 78-timeline-text-1\" style=\"top:496px;left:92px;\" src=\"/AR2025-26/static/_content/78-timeline-text-1.png\"/>\n        <img class=\"abs halfScale 78-timeline-text-2\" style=\"top:728px;left:186px;\" src=\"/AR2025-26/static/_content/78-timeline-text-2.png\"/>\n        <img class=\"abs halfScale 78-timeline-text-3\" style=\"top:727px;left:391px;\" src=\"/AR2025-26/static/_content/78-timeline-text-3.png\"/>\n        <img class=\"abs halfScale 78-timeline-text-4\" style=\"top:521px;left:318px;\" src=\"/AR2025-26/static/_content/78-timeline-text-4.png\"/>\n        <img class=\"abs halfScale 78-timeline-text-5\" style=\"top:728px;left:551px;\" src=\"/AR2025-26/static/_content/78-timeline-text-5.png\"/>\n\n        <div class=\"abs noOverflow 78-timeline\" style=\"top:697px;left:85px;width:654px; height:37px;\">\n          <img class=\"abs halfScale\" style=\"top:0px;left:0px;\" src=\"/AR2025-26/static/_content/78-timeline-1.png\"/>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          if(Publish.isDoublePage) {\n            pg78Anim = new TimelineMax();\n            pg78Anim.fromTo(cOf(\"78-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"78-map\"), 0.6, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.6\")\n            .fromTo(cOf(\"78-sub\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, \"-=0.3\")\n            .fromTo(cOf(\"78-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"78-no\")[0])}}, \"-=0.6\")\n            .fromTo(cOf(\"79-sub-1\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, \"-=0.9\")\n            .fromTo(cOf(\"79-pie-1\"), 0.6, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.6\")\n            .fromTo(cOf(\"79-line-1\"), 0.3, {opacity:0}, {opacity: 1, ease: Power2.easeOut}, \"-=0.3\")\n            .fromTo(cOf(\"79-text-1\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, \"-=0.1\")\n            .fromTo(cOf(\"79-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"79-no\")[0])}}, \"-=0.6\")\n            .fromTo(cOf(\"79-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"79-no\")[1])}}, \"-=0.9\")\n            .fromTo(cOf(\"79-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"79-no\")[2])}}, \"-=0.9\")\n            .fromTo(cOf(\"79-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"79-no\")[3])}}, \"-=0.9\")\n            .fromTo(cOf(\"79-no\")[4], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"79-no\")[4])}}, \"-=0.9\")\n            .fromTo(cOf(\"79-no\")[5], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"79-no\")[5])}}, \"-=0.9\")\n            .fromTo(cOf(\"79-no\")[6], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"79-no\")[6])}}, \"-=0.9\")\n            .fromTo(cOf(\"79-sub-2\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, \"-=0.8\")\n            .fromTo(cOf(\"79-bar-1\"), 0.6, {width:0}, {width: 157}, \"-=0.6\")\n            .fromTo(cOf(\"79-bar-2\"), 0.6, {width:0}, {width: 79}, \"-=0.5\")\n            .fromTo(cOf(\"79-bar-3\"), 0.6, {width:0}, {width: 113}, \"-=0.5\")\n            .fromTo(cOf(\"79-bar-4\"), 0.6, {width:0}, {width: 16}, \"-=0.5\")\n            .fromTo(cOf(\"79-bar-5\"), 0.6, {width:0}, {width: 13}, \"-=0.5\")\n            .fromTo(cOf(\"79-text-2\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, \"-=0.4\")\n            .fromTo(cOf(\"79-no\")[7], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"79-no\")[7])}}, \"-=0.6\")\n            .fromTo(cOf(\"79-no\")[8], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"79-no\")[8])}}, \"-=0.9\")\n            .fromTo(cOf(\"79-no\")[9], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"79-no\")[9])}}, \"-=0.9\")\n            .fromTo(cOf(\"79-no\")[10], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"79-no\")[10])}}, \"-=0.9\")\n            .fromTo(cOf(\"79-no\")[11], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"79-no\")[11])}}, \"-=0.9\")\n            .fromTo(cOf(\"78-timeline\"), 0.6, {width:0}, {width: 654}, \"-=0.3\")\n            .fromTo(cOf(\"79-timeline\"), 0.6, {width:0}, {width: 1454}, \"-=0.2\")\n            .fromTo(cOf(\"78-timeline-text-1\"), 0.6, {opacity:0, y: 40}, {opacity: 1, y: 0, ease: Power2.easeOut}, \"-=0.6\")\n            .fromTo(cOf(\"78-timeline-text-2\"), 0.6, {opacity:0, y: -40}, {opacity: 1, y: 0, ease: Power2.easeOut}, \"-=0.5\")\n            .fromTo(cOf(\"78-timeline-text-3\"), 0.6, {opacity:0, y: -40}, {opacity: 1, y: 0, ease: Power2.easeOut}, \"-=0.5\")\n            .fromTo(cOf(\"78-timeline-text-4\"), 0.6, {opacity:0, y: 40}, {opacity: 1, y: 0, ease: Power2.easeOut}, \"-=0.5\")\n            .fromTo(cOf(\"78-timeline-text-5\"), 0.6, {opacity:0, y: -40}, {opacity: 1, y: 0, ease: Power2.easeOut}, \"-=0.5\")\n            .fromTo(cOf(\"79-timeline-text-1\"), 0.6, {opacity:0, y: -40}, {opacity: 1, y: 0, ease: Power2.easeOut}, \"-=0.5\")\n            .fromTo(cOf(\"79-timeline-text-2\"), 0.6, {opacity:0, y: -40}, {opacity: 1, y: 0, ease: Power2.easeOut}, \"-=0.5\")\n            .fromTo(cOf(\"79-timeline-text-3\"), 0.6, {opacity:0, y: -40}, {opacity: 1, y: 0, ease: Power2.easeOut}, \"-=0.5\")\n          } else {\n            pg78Anim = new TimelineMax();\n            pg78Anim.fromTo(cOf(\"78-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"78-map\"), 0.6, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.4\")\n            .fromTo(cOf(\"78-sub\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, \"-=0.3\")\n            .fromTo(cOf(\"78-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"78-no\")[0])}}, \"-=0.4\")\n            .fromTo(cOf(\"78-timeline\"), 0.6, {width:0}, {width: 654}, \"-=0.3\")\n            .fromTo(cOf(\"78-timeline-text-1\"), 0.6, {opacity:0, y: 40}, {opacity: 1, y: 0, ease: Power2.easeOut}, \"-=0.3\")\n            .fromTo(cOf(\"78-timeline-text-2\"), 0.6, {opacity:0, y: -40}, {opacity: 1, y: 0, ease: Power2.easeOut}, \"-=0.5\")\n            .fromTo(cOf(\"78-timeline-text-3\"), 0.6, {opacity:0, y: -40}, {opacity: 1, y: 0, ease: Power2.easeOut}, \"-=0.5\")\n            .fromTo(cOf(\"78-timeline-text-4\"), 0.6, {opacity:0, y: 40}, {opacity: 1, y: 0, ease: Power2.easeOut}, \"-=0.5\")\n            .fromTo(cOf(\"78-timeline-text-5\"), 0.6, {opacity:0, y: -40}, {opacity: 1, y: 0, ease: Power2.easeOut}, \"-=0.5\")\n\n          }\n        }\n\n        function onPageLeave() {\n          pg78Anim.stop();\n          resetNumbers(\"78-no\")\n          resetNumbers(\"79-no\")\n        }\n      ",
    "searchText": "BUDGET ALLOCATION  195  million Swiss francs  invested since inception  FOLLOW-UP GRANTS FRESHLIFE  Kenya  ACELI AFRICA  APPLESEED  KHEYTI  Tanzania  Global  India  NEW GRANTS  WORLD BICYCLE RELIEF  Senegal  Spain  ONE HEART WORLDWIDE  Global  Tanzania  TOP-UP GRANT  SOCIETY FOR THE  MOTHERS2MOTHERS  Greece  May  2025  July  SOIL  DARSEL  Haiti  Jordan  INTEGRATE HEALTH  PROTECTION OF PRESPA  Sub-Saharan Africa  Kenya, Mozambique, Namibia, Cameroon  MIRACLEFEET  MSI  Nepal  CONSERVE GLOBAL  MYAGRO  MARILLES FOUNDATION  Zambia  April  NEW GRANTS  FOLLOW-UP GRANTS  DIGITAL GREEN  Togo, Guinea  September  India  October EMERGENCY GRANTS  EMERGENCY GRANTS  EMERGENCY GRANTS  MEDICAL ACTION MYANMAR & PROXIMITY DESIGNS  MEDAIR  MEDAIR  Afghanistan  Afghanistan  LIVESAVING MEDICAL SUPPLIES  EARTHQUAKE RESPONSE  Myanmar EARTHQUAKE RESPONSE  MEDECINS SANS FRONTIERES  Democratic Rep. of Congo ESSENTIAL HEALTHCARE IN ANGUMU REGION"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 79,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg79.jpg",
    "zoom": null,
    "content": "       \n        <img class=\"abs halfScale 79-sub-1\" style=\"top:69px;left:41px;\" src=\"/AR2025-26/static/_content/79-sub-1.png\"/>\n\n        <img class=\"abs halfScale 79-line-1\" style=\"top:148px;left:241px;\" src=\"/AR2025-26/static/_content/79-line-1.png\"/>\n        <img class=\"abs halfScaleC 79-pie-1\" style=\"top:-7px;left:-86px;\" src=\"/AR2025-26/static/_content/79-pie-1.png\"/>\n        <img class=\"abs halfScale 79-text-1\" style=\"top:183px;left:351px;\" src=\"/AR2025-26/static/_content/79-text-1.png\"/>\n        \n        <h1 id=\"79-no\" class=\"abs brillCutBold 79-no\" style=\"top:183px;left:329px; font-size: 0.75em; color: #082542; padding: 0px; margin: 0px;\" data-number='{\"to\": 52, \"append\": \"%\"}' ></h1>\n        <h1 id=\"79-no\" class=\"abs brillCutBold 79-no\" style=\"top:207px;left:329px; font-size: 0.75em; color: #082542; padding: 0px; margin: 0px;\" data-number='{\"to\": 23, \"append\": \"%\"}' ></h1>\n        <h1 id=\"79-no\" class=\"abs brillCutBold 79-no\" style=\"top:232px;left:329px; font-size: 0.75em; color: #082542; padding: 0px; margin: 0px;\" data-number='{\"to\": 5, \"append\": \"%\"}' ></h1>\n        <h1 id=\"79-no\" class=\"abs brillCutBold 79-no\" style=\"top:256px;left:329px; font-size: 0.75em; color: #082542; padding: 0px; margin: 0px;\" data-number='{\"to\": 5, \"append\": \"%\"}' ></h1>\n        <h1 id=\"79-no\" class=\"abs brillCutBold 79-no\" style=\"top:280px;left:329px; font-size: 0.75em; color: #082542; padding: 0px; margin: 0px;\" data-number='{\"to\": 2, \"append\": \"%\"}' ></h1>\n        <h1 id=\"79-no\" class=\"abs brillCutBold 79-no\" style=\"top:305px;left:329px; font-size: 0.75em; color: #082542; padding: 0px; margin: 0px;\" data-number='{\"to\": 2, \"append\": \"%\"}' ></h1>\n        <h1 id=\"79-no\" class=\"abs brillCutBold 79-no\" style=\"top:329px;left:329px; font-size: 0.75em; color: #082542; padding: 0px; margin: 0px;\" data-number='{\"to\": 11, \"append\": \"%\"}' ></h1>\n\n\n        <img class=\"abs halfScale 79-sub-2\" style=\"top:69px;left:493px;\" src=\"/AR2025-26/static/_content/79-sub-2.png\"/>\n\n        <div class=\"abs noOverflow 79-bar-1\" style=\"top:105px;left:491px;width:157px; height:14px;\">\n          <img class=\"abs halfScale\" style=\"top:0px;left:0px;\" src=\"/AR2025-26/static/_content/79-bar-1.png\"/>\n        </div>\n        <div class=\"abs noOverflow 79-bar-2\" style=\"top:170px;left:491px;width:79px; height:14px;\">\n          <img class=\"abs halfScale\" style=\"top:0px;left:0px;\" src=\"/AR2025-26/static/_content/79-bar-2.png\"/>\n        </div>\n        <div class=\"abs noOverflow 79-bar-3\" style=\"top:235px;left:491px;width:113px; height:14px;\">\n          <img class=\"abs halfScale\" style=\"top:0px;left:0px;\" src=\"/AR2025-26/static/_content/79-bar-3.png\"/>\n        </div>\n        <div class=\"abs noOverflow 79-bar-4\" style=\"top:290px;left:491px;width:16px; height:14px;\">\n          <img class=\"abs halfScale\" style=\"top:0px;left:0px;\" src=\"/AR2025-26/static/_content/79-bar-4.png\"/>\n        </div>\n        <div class=\"abs noOverflow 79-bar-5\" style=\"top: 346px;left: 491px;width: 13px;height: 14px;\">\n          <img class=\"abs halfScale\" style=\"top:0px;left:0px;\" src=\"/AR2025-26/static/_content/79-bar-5.png\"/>\n        </div>\n\n        <h1 id=\"79-no\" class=\"abs brillCutBold 79-no\" style=\"top:122px;left:502px; font-size: 0.75em; color: #082542; padding: 0px; margin: 0px;\" data-number='{\"to\": 42, \"append\": \"%\"}' ></h1>\n        <h1 id=\"79-no\" class=\"abs brillCutBold 79-no\" style=\"top:189px;left:502px; font-size: 0.75em; color: #082542; padding: 0px; margin: 0px;\" data-number='{\"to\": 21, \"append\": \"%\"}' ></h1>\n        <h1 id=\"79-no\" class=\"abs brillCutBold 79-no\" style=\"top:252px;left:502px; font-size: 0.75em; color: #082542; padding: 0px; margin: 0px;\" data-number='{\"to\": 30, \"append\": \"%\"}' ></h1>\n        <h1 id=\"79-no\" class=\"abs brillCutBold 79-no\" style=\"top:307px;left:502px; font-size: 0.75em; color: #082542; padding: 0px; margin: 0px;\" data-number='{\"to\": 4, \"append\": \"%\"}' ></h1>\n        <h1 id=\"79-no\" class=\"abs brillCutBold 79-no\" style=\"top:363px;left:502px; font-size: 0.75em; color: #082542; padding: 0px; margin: 0px;\" data-number='{\"to\": 3, \"append\": \"%\"}' ></h1>\n\n        <img class=\"abs halfScale 79-text-2\" style=\"top:126px;left:491px;\" src=\"/AR2025-26/static/_content/79-text-2.png\"/>\n\n        <img class=\"abs halfScale 79-timeline-text-1\" style=\"top:415px;left:-94px;\" src=\"/AR2025-26/static/_content/79-timeline-text-1.png\"/>\n        <img class=\"abs halfScale 79-timeline-text-2\" style=\"top:447px;left:246px;\" src=\"/AR2025-26/static/_content/79-timeline-text-2.png\"/>\n        <img class=\"abs halfScale 79-timeline-text-3\" style=\"top:531px;left:530px;\" src=\"/AR2025-26/static/_content/79-timeline-text-3.png\"/>\n\n        <div class=\"abs noOverflow 79-timeline\" style=\"top:697px;left:-655px;width:1454px; height:37px;\">\n          <img class=\"abs halfScale\" style=\"top:0px;left:0px;\" src=\"/AR2025-26/static/_content/78-timeline-1.png\"/>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          if(Publish.isDoublePage) {\n          \n          } else {\n            pg79Anim = new TimelineMax();\n            pg79Anim.fromTo(cOf(\"79-sub-1\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"79-pie-1\"), 0.6, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.4\")\n            .fromTo(cOf(\"79-line-1\"), 0.3, {opacity:0}, {opacity: 1, ease: Power2.easeOut}, \"-=0.3\")\n            .fromTo(cOf(\"79-text-1\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, \"-=0.1\")\n            .fromTo(cOf(\"79-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"79-no\")[0])}}, \"-=0.4\")\n            .fromTo(cOf(\"79-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"79-no\")[1])}}, \"-=0.8\")\n            .fromTo(cOf(\"79-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"79-no\")[2])}}, \"-=0.8\")\n            .fromTo(cOf(\"79-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"79-no\")[3])}}, \"-=0.8\")\n            .fromTo(cOf(\"79-no\")[4], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"79-no\")[4])}}, \"-=0.8\")\n            .fromTo(cOf(\"79-no\")[5], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"79-no\")[5])}}, \"-=0.8\")\n            .fromTo(cOf(\"79-no\")[6], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"79-no\")[6])}}, \"-=0.8\")\n            .fromTo(cOf(\"79-sub-2\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, \"-=0.4\")\n            .fromTo(cOf(\"79-bar-1\"), 0.6, {width:0}, {width: 157}, \"-=0.3\")\n            .fromTo(cOf(\"79-bar-2\"), 0.6, {width:0}, {width: 79}, \"-=0.5\")\n            .fromTo(cOf(\"79-bar-3\"), 0.6, {width:0}, {width: 113}, \"-=0.5\")\n            .fromTo(cOf(\"79-bar-4\"), 0.6, {width:0}, {width: 16}, \"-=0.5\")\n            .fromTo(cOf(\"79-bar-5\"), 0.6, {width:0}, {width: 13}, \"-=0.5\")\n            .fromTo(cOf(\"79-text-2\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, \"-=0.4\")\n            .fromTo(cOf(\"79-no\")[7], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"79-no\")[7])}}, \"-=0.4\")\n            .fromTo(cOf(\"79-no\")[8], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"79-no\")[8])}}, \"-=0.8\")\n            .fromTo(cOf(\"79-no\")[9], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"79-no\")[9])}}, \"-=0.8\")\n            .fromTo(cOf(\"79-no\")[10], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"79-no\")[10])}}, \"-=0.8\")\n            .fromTo(cOf(\"79-no\")[11], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"79-no\")[11])}}, \"-=0.8\")\n            .fromTo(cOf(\"79-timeline\"), 0.6, {width:0}, {width: 1454}, \"-=0.3\")\n            .fromTo(cOf(\"79-timeline-text-1\"), 0.6, {opacity:0, y: 40}, {opacity: 1, y: 0, ease: Power2.easeOut}, \"-=0.3\")\n            .fromTo(cOf(\"79-timeline-text-2\"), 0.6, {opacity:0, y: 40}, {opacity: 1, y: 0, ease: Power2.easeOut}, \"-=0.5\")\n            .fromTo(cOf(\"79-timeline-text-3\"), 0.6, {opacity:0, y: 40}, {opacity: 1, y: 0, ease: Power2.easeOut}, \"-=0.5\")\n          }\n        }\n\n        function onPageLeave() {\n          pg79Anim.stop();\n          resetNumbers(\"78-no\")\n          resetNumbers(\"79-no\")\n        }\n      ",
    "searchText": "Geographic distribution  By focus area 42%  Unlocking women's potential, transforming communities  5 2% Africa  21%  Investing in sustainable livelihoods and craftsmanship  2 3% Asia 5% Europe  30%  5% Americas  Protecting nature, fostering resilience  2 % Oceania 2 % Middle East  4 %  Responding to emergencies, sustaining life  11% Global  3 %  Capacity Building FOLLOW-UP GRANTS PIVOT  Madagascar  FOLLOW-UP GRANTS  MUSO  LANGUAGE & LEARNING FOUNDATION  India PARC JURA VAUDOIS  Switzerland RAISING THE VILLAGE  Uganda ZAMBIAN CARNIVORE PROJECT  Zambia  COMMUNITY HEALTH WORKER INSTITUTE  United States HEALTHY LEARNERS  Zambia IDINSIGHT  Global MIGHTY ALLY  Philippines  ONE HEART WORLDWIDE  BAAN DEK FOUNDATION  RISING PHOENIX  ANAK-TNK  Mali, Côte d'Ivoire, Zambia  NEW GRANTS JACARANDA HEALTH  Africa  Thailand  Cambodia  CONSERVATION EVIDENCE  SAHA GLOBAL  Global IRDNC  Namibia Kenya  Australia  DAHARI  THE AGENCY FUND  MOBILE CRECHES  VILLAGE ENTERPRISE  Comoros  Global  India  Africa  November  January  India  Kenya  KIDOGO  Europe  INDUSTREE FOUNDATION  SORALO  Rwanda  REWILDING EUROPE  FOLLOW-UP GRANTS  Ghana  THE NATURE CONSERVANCY  Global  RWAMREC  Nepal  2026  MOTHERS2MOTHERS  Sub-Saharan Africa NEW GRANTS  UBONGO  MAFISA  STRONGMINDS  Zambia  Zambia  Tanzania  March"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 80,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg80.jpg",
    "zoom": null,
    "content": "       \n        <img class=\"abs halfScale 80-title\" style=\"top:92px;left:82px;\" src=\"/AR2025-26/static/_content/80-text-1.png\"/>\n\n        <img class=\"abs halfScaleC 80-text\" style=\"top:393px;left:-70px;\" src=\"/AR2025-26/static/_content/80-text-2.png\"/>\n        <img class=\"abs halfScaleC 80-text\" style=\"top:455px;left:-23px;\" src=\"/AR2025-26/static/_content/80-text-3.png\"/>\n        <img class=\"abs halfScaleC 80-text\" style=\"top:595px;left:96px;\" src=\"/AR2025-26/static/_content/80-text-4.png\"/>\n        <img class=\"abs halfScaleC 80-text\" style=\"top:48px;left:401px;\" src=\"/AR2025-26/static/_content/80-text-5.png\"/>\n        <img class=\"abs halfScaleC 80-text\" style=\"top:353px;left:394px;\" src=\"/AR2025-26/static/_content/80-text-6.png\"/>\n        <img class=\"abs halfScaleC 80-text\" style=\"top:555px;left:483px;\" src=\"/AR2025-26/static/_content/80-text-7.png\"/>\n        <img class=\"abs halfScaleC 80-text\" style=\"top:618px;left:461px;\" src=\"/AR2025-26/static/_content/80-text-8.png\"/>\n        <img class=\"abs halfScaleC 80-text\" style=\"top:653px;left:-22px;\" src=\"/AR2025-26/static/_content/80-text-9.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg80Anim = new TimelineMax();\n          pg80Anim.fromTo(cOf(\"80-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.8)\n          .staggerFromTo(cOf(\"80-text\"), 0.6, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, 0.2, \"-=0.4\")\n        }\n\n        function onPageLeave() {\n          pg80Anim.stop();\n        }\n      ",
    "searchText": "THE PROGRAMMES WE SUPPORT  EUROPE Marilles Foundation Parc Jura Vaudois Rewilding Europe Society for the Protection of Prespa SPBT Women 4 Women Kosova  NORTHERN AMERICA  WEST AFRICA  CommonLit Community Health Worker Institute  Birdlife International Imagine Worldwide Integrate Health Jacaranda Health MSI Reproductive Choices Muso myAgro Saha Global Ubongo  CENTRAL AMERICA AND THE CARIBBEAN Fauna & Flora FreshLife Semilla Nueva SOIL  CENTRAL AFRICA Ubongo Village Enterprise  SOUTH AMERICA Fundación Jocotoco  GLOBAL Co-impact CHIC Community Health Impact Coalition Conservation Evidence Médecins Sans Frontières MiracleFeet The Agency Fund  CAPACITY BUILDING FOR PARTNERS Appleseed, IDinsight, Mighty Ally  SOUTHERN AFRICA Abalobi Conserve Global IRDNC mothers2mothers Panthera Peace Parks Foundation SmartStart"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 81,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg81.jpg",
    "zoom": null,
    "content": "       \n        <img class=\"abs halfScaleC 81-text\" style=\"top:443px;left:-112px;\" src=\"/AR2025-26/static/_content/81-text-1.png\"/>\n        <img class=\"abs halfScaleC 81-text\" style=\"top:-95px;left:-5px;\" src=\"/AR2025-26/static/_content/81-text-2.png\"/>\n        <img class=\"abs halfScaleC 81-text\" style=\"top:-29px;left:75px;\" src=\"/AR2025-26/static/_content/81-text-3.png\"/>\n        <img class=\"abs halfScaleC 81-text\" style=\"top:90px;left:252px;\" src=\"/AR2025-26/static/_content/81-text-4.png\"/>\n        <img class=\"abs halfScaleC 81-text\" style=\"top:186px;left:64px;\" src=\"/AR2025-26/static/_content/81-text-5.png\"/>\n        <img class=\"abs halfScaleC 81-text\" style=\"top:430px;left:127px;\" src=\"/AR2025-26/static/_content/81-text-6.png\"/>\n        <img class=\"abs halfScaleC 81-text\" style=\"top:601px;left:352px;\" src=\"/AR2025-26/static/_content/81-text-7.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg81Anim = new TimelineMax();\n          pg81Anim.staggerFromTo(cOf(\"81-text\"), 0.6, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, 0.2, 1.4)\n        }\n\n        function onPageLeave() {\n          pg81Anim.stop();\n        }\n      ",
    "searchText": "NORTH AFRICA AND MIDDLE EAST Al Shouf Cedar Society Darsel Intelehealth Luminos Fund  CENTRAL ASIA Noora Health WCS Mongolia  EAST ASIA China Green Foundation  SOUTH ASIA Digital Green Educate Girls Industree Foundation Intelehealth Kheyti Language & Learning Foundation Mobile Creches Noora Health One Heart Worldwide Rocket Learning SaveLife Foundation VisionSpring  SOUTHEAST ASIA 1001fontaines ANAK-Tnk Baan Dek Foundation Planet Indonesia Proximity Designs Rising Phoenix Ltd. The Nature Investment Facility  OCEANIA The Nature Conservancy  EAST AFRICA 1001fontaines Aceli Africa Ashesi University Comaco Conserve Global Dahari Food4Education Gorongosa Restoration Project Healthy Learners Honeyguide Foundation iDE Jacaranda Health Kidogo Luminos Fund  Mafisa mothers2mothers MSI Reproductive Choices Orda Ethiopia Panthera Peace Parks Foundation Pivot Raising the Village RWAMREC StrongMinds The Nature Investment Facility Ubongo Ujamaa Africa World Bicycle Relief Zambian Carnivore Programme"
  }]],
  "script": "\n      function idOf(id) {\n        return document.getElementById(id)\n      }\n  \n      function cOf(klass) {\n        return document.getElementsByClassName(klass)\n      }\n      \n      function removeContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) { \n          return e.className = 'addContentLink'\n        })\n      }\n  \n      function addContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) {\n          return e.className = 'contentLink addContentLink'\n        })\n      }\n  \n      function showOverlay(idx) {\n        idOf(idx).className = 'contentOverlay visible'\n      }\n  \n      function hideOverlay(idx) {\n        idOf(idx).className = 'contentOverlay hidden noclick'\n      }\n\n      function animateNumber(element){\n        if(element.getAttribute(\"data-number\")){\n          var args = JSON.parse(element.getAttribute(\"data-number\"));\n          var from = 0;\n          var to = 100;\n          var append = \"\";\n          var preppend = \"\";\n          var decimals = 0;\n          var duration = 1;\n          var ease = \"Linear.easeNone\";\n          var comma = false;\n          var separator = \",\";\n          var decChar = \".\";\n          for(obj in args){\n            if(obj == \"from\") from = args[obj];\n            if(obj == \"to\") to = args[obj];\n            if(obj == \"append\") append = args[obj];\n            if(obj == \"preppend\") preppend = args[obj];\n            if(obj == \"decimals\") decimals = args[obj];\n            if(obj == \"duration\") duration = args[obj];\n            if(obj == \"ease\") ease = args[obj];\n            if(obj == \"comma\") comma = args[obj];\n            if(obj == \"separator\") separator = args[obj];\n            if(obj == \"decChar\") decChar = args[obj];\n          }\n          var obj = {number: from}\n          TweenMax.to(obj, duration, {number: to, onUpdate: function(){\n            if(comma){\n              // console.log(obj.number)\n              var str = obj.number.toFixed(decimals).toString();\n              var predec = str.split(/^d*/)[0];\n              // console.log(\"PREDEC\", predec, typeof(predec));\n              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')\n              var comp = newstr.replace(/^,/, '')\n              // console.log(\"NEWSTR\", newstr, typeof(newstr));\n              // console.log({newstr})\n              // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : \"\";\n              // if(dp[0]) dp = dp[0].replace(\".\", decChar);\n              var dp = \"\";\n              element.innerHTML = preppend+comp+dp+append;\n            }else{\n              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(\".\", decChar)+append;\n            }\n          }, ease: eval(ease)});\n        }else{\n          return;\n        }\n      }\n\n      function resetNumbers(ele){\n        var numbers = cOf(ele)\n        for(var i=0; i<numbers.length; i++) {\n        console.log('resetting' + i)\n          numbers[i].innerText = \"\"\n          numbers[i].innerHTML = \"\"\n          numbers[i].style.opacity = 0\n        }\n      }\n    ",
  "mobilePages": null,
  "mobileTemplate": null
});
// CONCATENATED MODULE: ./src/router/index.js





vue_esm["default"].use(vue_router_esm["a" /* default */]);
/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  base: src_document.basePath,
  routes: [{
    path: '/',
    name: 'Home',
    component: src_components_PublishPage,
    redirect: '/0-1'
  }, {
    path: '/:page-:section',
    name: 'PublishPage',
    component: src_components_PublishPage
  }]
}));
// CONCATENATED MODULE: ./src/store/actions.js





/* harmony default export */ var actions = ({
  goToPage: function goToPage(context, payload) {
    if (payload === null) {
      // console.log('Page does not exist')
      return;
    }

    // var evt = window.document.createEvent('UIEvents'); 
    // evt.initUIEvent('resize', true, false, window, 0); 
    // window.dispatchEvent(evt);


    if (typeof payload == "number") {
      if (context.getters.pageInRange(payload, 1)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          router.push(context.getters.routeFromIndex(payload - 1, 1), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload, 1), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        }
      }
    } else {
      if (context.getters.pageInRange(payload.pageIndex, payload.sectionIndex)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 != 0) {
          console.log('1');
          router.push(context.getters.routeFromIndex(payload.pageIndex, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        } else if (!Publish.isDoublePage) {
          router.push(context.getters.routeFromIndex(payload.pageIndex, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        } else if (payload.pageIndex % 2 == 0) {
          router.push(context.getters.routeFromIndex(payload.pageIndex, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload.pageIndex - 1, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        }
      }
    }
  },

  goToPreviousPage: function goToPreviousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else if (context.state.isDoublePage && context.getters.doublePage && context.getters.zeroedPageIndex == 1) {
      context.dispatch('goToPage', { pageIndex: 0, sectionIndex: 1 });
    } else if (!context.state.isDoublePage && context.getters.doublePage && context.getters.zeroedPageIndex == 1) {
      context.dispatch('goToPage', { pageIndex: 0, sectionIndex: 1 });
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  goToNextPage: function goToNextPage(context) {
    if (context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  previousPage: function previousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  nextPage: function nextPage(context) {
    if (context.getters.nextNextPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  goToPreviousMobilePage: function goToPreviousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  goToNextMobilePage: function goToNextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  goToPreviousSection: function goToPreviousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  goToNextSection: function goToNextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },
  previousMobilePage: function previousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  nextMobilePage: function nextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  previousSection: function previousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  nextSection: function nextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },

  resetSectionIndices: function resetSectionIndices(context) {
    var sectionIndices = context.getters.pages.map(function (page, index) {
      if (index == context.getters.zeroedPageIndex) return context.getters.sectionIndex - 1;
      return page.startIndex || 0;
    });
    context.commit('RESET_SECTION_INDICES', sectionIndices);
  },

  updateVideoURL: function updateVideoURL(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  openVideo: function openVideo(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  setInitialWindowSize: function setInitialWindowSize(context, payload) {
    context.commit('UPDATE_INITIAL_WINDOW_SIZE', extends_default()({}, payload));
  },

  changePageSize: function changePageSize(context, payload) {
    var pageWidth = context.getters.width;
    if (context.getters.currentPage.pageIndex == 0) {
      context.commit('UPDATE_IS_FRONT_PAGE', true);
    } else {
      context.commit('UPDATE_IS_FRONT_PAGE', false);
    }
  },

  changeWindowSize: function changeWindowSize(context, payload) {
    if (context.getters.zeroedPageIndex % 2 !== 0 && context.getters.zeroedPageIndex !== 0 && context.getters.zeroedPageIndex !== 1) {
      var currentPage = context.getters.previousPage;
    } else {
      var currentPage = context.getters.currentPage;
    }
    var pageWidth = context.getters.width;
    if (currentPage.pageIndex == 0 || currentPage.pageIndex == 1) {
      pageWidth = 2 * context.getters.width;
    }
    var pageHeight = context.getters.height;
    if (context.getters.contentsPinned) {
      if (payload.width < 992) {
        var windowWidth = payload.width;
        var mobile = true;
      } else {
        var windowWidth = payload.width - 300;
        var mobile = false;
      }
    } else {
      var windowWidth = payload.width;
    }
    var windowHeight = payload.height - 48;
    var widthRatio = windowWidth / pageWidth;
    var heightRatio = windowHeight / pageHeight;
    if (context.getters.doublePage) {
      if (windowWidth / (pageWidth * 2) < heightRatio) {
        context.commit('UPDATE_IS_DOUBLE_PAGE', false);
      } else {
        context.commit('UPDATE_IS_DOUBLE_PAGE', true);
      }
    }

    if (pageWidth <= windowWidth && pageHeight <= windowHeight) {
      var newScale = Math.min(widthRatio, heightRatio);
      // console.log('widthratio', widthRatio)
      // console.log('heightratio', heightRatio)
      context.commit('UPDATE_PAGE_SCALE', { pageScale: newScale });
    } else {
      var _newScale = Math.min(widthRatio, heightRatio);
      context.commit('UPDATE_PAGE_SCALE', { pageScale: _newScale });
    }
    if (context.getters.contentsPinned) {
      if (windowWidth <= 992 && mobile) {
        context.commit('UPDATE_CONTENT_PANEL', false);
      } else {
        context.commit('UPDATE_CONTENT_PANEL', true);
      }
    }
  },

  checkMobileLanding: function checkMobileLanding(context, payload) {
    var isMobile = context.getters.isMobile;
    var landingPage = context.getters.currentMobilePage;
    var mobileSwitch = context.getters.mobileSwitch;
    if (!mobileSwitch || !isMobile) return;
    if (landingPage) {
      return;
    } else {
      router.replace('/1-1');
    }
  },

  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    // if(newX < -context.getters.width  ) newX = (-context.getters.width -  100) / newZ
    // if(newY < -context.getters.height ) newY = (-context.getters.height - 100) / newZ
    // if(newX > context.getters.width ) newX = (context.getters.width + 100) / newZ
    // if(newY > context.getters.height) newY = (context.getters.height + 100) / newZ
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  scrollZoom: function scrollZoom(context, payload) {
    var zoomLevel = context.state.zoomLevel + payload.zoomDelta;
    zoomLevel = zoomLevel > 2 ? 2 : zoomLevel;
    zoomLevel = zoomLevel < 1 ? 1 : zoomLevel;
    var windowWidthAdjustment = context.getters.contentsPinned ? 300 : 0;
    var newX = payload.x - (window.innerWidth - windowWidthAdjustment) / 2;
    var newY = payload.y - (window.innerHeight + 48) / 2;
    var translateX = context.state.translateX + (newX - context.state.zoomOriginX) * (1 - 1 / (context.state.zoomLevel * context.state.pageScale));
    var translateY = context.state.translateY + (newY - context.state.zoomOriginY) * (1 - 1 / (context.state.zoomLevel * context.state.pageScale));

    // console.log({zoomOriginX: newX, zoomOriginY: newY, zoomLevel: zoomLevel, translateX: translateX, translateY: translateY})

    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: zoomLevel, translateX: translateX, translateY: translateY });
  },
  pinchZoom: function pinchZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY / newZ;
    // if(newX < -context.getters.width  ) newX = -context.getters.width -  100
    // if(newY < -context.getters.height ) newY = -context.getters.height - 100
    // if(newX > context.getters.width ) newX = context.getters.width + 100
    // if(newY > context.getters.height) newY = context.getters.height + 100
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  panZoom: function panZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - payload.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY - payload.zoomOriginY / newZ;
    // console.log("Pan Zoom: " + newZ + ", " + newX + ", " + newY)
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: context.state.zoomLevel });
  },
  openGallery: function openGallery(context, payload) {
    context.commit('UPDATE_GALLERY', payload);
  },
  openGalleryTwo: function openGalleryTwo(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload[1]);
    context.commit('UPDATE_GALLERY', payload[0]);
  },
  closeGallery: function closeGallery(context, payload) {
    context.commit('UPDATE_GALLERY', []);
  },
  goToGallerySlide: function goToGallerySlide(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload);
  },
  nextGallerySlide: function nextGallerySlide(context, payload) {
    if (context.state.galleryIndex < context.state.galleryImages.length - 1) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex + 1);else context.commit('UPDATE_GALLERY_INDEX', 0);
  },
  previousGallerySlide: function previousGallerySlide(context, payload) {
    if (context.state.galleryIndex > 0) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex - 1);else context.commit('UPDATE_GALLERY_INDEX', context.state.galleryImages.length - 1);
  },


  updateAudioURL: function updateAudioURL(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  },

  openAudio: function openAudio(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  }
});
// EXTERNAL MODULE: ./node_modules/util/util.js
var util = __webpack_require__("OMJi");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// CONCATENATED MODULE: ./src/store/getters.js


/* harmony default export */ var getters = ({
  title: function title(state) {
    return state.document.title;
  },
  description: function description(state) {
    return state.document.description;
  },
  basePath: function basePath(state) {
    return state.document.basePath;
  },
  pages: function pages(state) {
    return state.document.pages.map(function (page, pageIndex) {
      return page.map(function (section, sectionIndex) {
        section.pageIndex = pageIndex;
        section.sectionIndex = sectionIndex;
        return section;
      });
    });
  },
  titledPages: function titledPages(state) {
    return state.document.pages.filter(function (page) {
      return page[0].title;
    });
  },
  videoURL: function videoURL(state) {
    return state.videoURL;
  },
  audioURL: function audioURL(state) {
    return state.audioURL;
  },
  showContents: function showContents(state, getters) {
    return state.activePanel == "Contents" || getters.contentsPinned;
  },
  showLanguages: function showLanguages(state) {
    return state.activePanel == "Languages";
  },
  showSearch: function showSearch(state) {
    return state.activePanel == "Search";
  },
  showGuide: function showGuide(state) {
    return state.activePanel == "Guide";
  },
  showEditions: function showEditions(state) {
    return state.activePanel == "Editions";
  },
  isZoomed: function isZoomed(state) {
    return state.zoomLevel != 1;
  },
  zoomLevel: function zoomLevel(state) {
    return state.zoomLevel;
  },
  companyLogo: function companyLogo(state, getters) {
    if (state.document.companyLogo != "") {
      return getters.basePath + "/static/_content/" + state.document.companyLogo;
    } else return getters.basePath + "/static/kp-logo-white.svg";
  },
  galleryImages: function galleryImages(state) {
    return state.galleryImages;
  },
  galleryCaptions: function galleryCaptions(state) {
    return state.document.options.galleryCaptions;
  },
  galleryIndex: function galleryIndex(state) {
    return state.galleryIndex;
  },
  isGalleryOpen: function isGalleryOpen(state) {
    return state.galleryImages.length > 0;
  },
  isMobile: function isMobile(state, getters) {
    return function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|)|g1 u|g560|gene|gf-5|g-mo|go(.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) return true;
    }(navigator.userAgent || navigator.vendor || window.opera) ? true : false;
  },
  isMobileFontLarge: function isMobileFontLarge(state) {
    return state.isMobileFontLarge;
  },
  isIE11: function isIE11(state, getters) {
    return !!navigator.userAgent.match(/Trident\/7\./);
  },
  isPhantom: function isPhantom(state, getters) {
    return !!(navigator.userAgent.match("PhantomJS") != null);
  },
  initialWindowWidth: function initialWindowWidth(state) {
    return state.initialWindowWidth;
  },
  initialWindowHeight: function initialWindowHeight(state) {
    return state.initialWindowHeight;
  },
  publishURL: function publishURL(state) {
    return state.document.publishURL;
  },
  doublePage: function doublePage(state) {
    return state.document.options.doublePage;
  },
  contentsEnabled: function contentsEnabled(state) {
    return state.document.options.contents.enabled;
  },
  contentsPinned: function contentsPinned(state, getters) {
    return state.document.options.contents.pinned && getters.contentsEnabled && !getters.isMobile && !getters.isFullscreen;
  },
  contentsNumbers: function contentsNumbers(state) {
    return state.document.options.contents.numbers;
  },
  contentsTitles: function contentsTitles(state) {
    return state.document.options.contents.titles;
  },
  downloadEnabled: function downloadEnabled(state) {
    return state.document.options.downloadEnabled;
  },
  languagesEnabled: function languagesEnabled(state) {
    return state.document.options.languagesEnabled;
  },
  readerEnabled: function readerEnabled(state) {
    return state.document.options.readerEnabled;
  },
  printEnabled: function printEnabled(state) {
    return state.document.options.printEnabled;
  },
  searchEnabled: function searchEnabled(state) {
    return state.document.options.searchEnabled;
  },
  guideEnabled: function guideEnabled(state) {
    return state.document.options.guideEnabled;
  },
  editionsEnabled: function editionsEnabled(state) {
    return state.document.options.editionsEnabled;
  },
  zoomNavEnabled: function zoomNavEnabled(state) {
    return state.document.options.zoom.navEnabled;
  },
  zoomClickEnabled: function zoomClickEnabled(state) {
    return state.document.options.zoom.clickEnabled;
  },
  zoomScrollEnabled: function zoomScrollEnabled(state) {
    return state.document.options.zoom.scrollEnabled;
  },
  zoomSliderEnabled: function zoomSliderEnabled(state) {
    return state.document.options.zoom.sliderEnabled;
  },
  zoomEnabled: function zoomEnabled(state) {
    return state.document.options.zoom.navEnabled || state.document.options.zoom.clickEnabled || state.document.options.zoom.scrollEnabled || state.document.options.zoom.sliderEnabled;
  },
  mobileSwitch: function mobileSwitch(state) {
    return state.document.options.mobileSwitch;
  },
  rightToLeft: function rightToLeft(state, getters) {
    return state.document.options.rightToLeft;
  },
  pagesVisible: function pagesVisible(state, getters) {
    return !getters.showSearch;
  },
  downloadPath: function downloadPath(state, getters) {
    return state.document.options.downloadPath;
  },
  fullscreenEnabled: function fullscreenEnabled(state) {
    return state.document.options.fullscreenEnabled && document.documentElement.requestFullscreen;
  },
  isFullscreen: function isFullscreen(state) {
    return state.isFullscreen;
  },
  width: function width(state) {
    return state.document.width;
  },
  height: function height(state) {
    return state.document.height;
  },
  languages: function languages(state) {
    return state.document.languages;
  },
  currentLanguage: function currentLanguage(state) {
    return state.document.currentLanguage;
  },
  editions: function editions(state) {
    return state.document.editions;
  },
  zeroedPageIndex: function zeroedPageIndex(state, getters) {
    return getters.pageIndex;
  },
  zeroedSectionIndex: function zeroedSectionIndex(state, getters) {
    return getters.sectionIndex - 1;
  },
  currentPages: function currentPages(state, getters) {
    return getters.pages[getters.zeroedPageIndex];
  },
  currentPage: function currentPage(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  currentSection: function currentSection(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  routeFromIndex: function routeFromIndex(state, getters) {
    return function (pageIndex, sectionIndex) {
      return "/" + pageIndex + "-" + sectionIndex;
    };
  },
  externalResources: function externalResources(state) {
    return state.document.externalResources;
  },
  pageInRange: function pageInRange(state, getters) {
    return function (pageIndex, sectionIndex) {
      return (getters.pages[pageIndex] || [])[sectionIndex - 1] !== undefined;
    };
  },
  isDoublePage: function isDoublePage(state, getters) {
    return state.isDoublePage;
  },
  visiblePages: function visiblePages(state, getters) {
    if (state.isDoublePage && getters.doublePage) {
      if (getters.zeroedPageIndex == 0) {
        return {
          previousLeftPage: null,
          previousRightPage: null,
          leftPage: null,
          previousSection: getters.previousSection,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: null,
          nextRightPage: getters.nextPage
        };
      } else if (getters.zeroedPageIndex == 1) {
        return {
          previousLeftPage: getters.previousPage,
          previousRightPage: null,
          leftPage: null,
          previousSection: getters.previousSection,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else if (getters.nextPage == null && getters.nextNextPage == null) {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: null,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: null,
          nextRightPage: null
        };
      } else if (getters.zeroedPageIndex == 2) {
        return {
          previousLeftPage: null,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: getters.currentPage,
          rightPage: getters.nextPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextNextPage,
          nextRightPage: getters.nextNextNextPage
        };
      } else if (getters.zeroedPageIndex % 2 != 1 && getters.zeroedPageIndex != 80) {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: getters.currentPage,
          rightPage: getters.nextPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextNextPage,
          nextRightPage: getters.nextNextNextPage
        };
      } else if (getters.zeroedPageIndex % 2 != 1 && getters.zeroedPageIndex == 80) {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: getters.currentPage,
          rightPage: getters.nextPage,
          nextSection: getters.nextSection,
          nextLeftPage: null,
          nextRightPage: null
        };
      } else if (getters.zeroedPageIndex % 2 == 1) {
        return {
          previousLeftPage: getters.previousPreviousPreviousPage,
          previousRightPage: getters.previousPreviousPage,
          previousSection: getters.previousSection,
          leftPage: getters.previousPage,
          rightPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: getters.currentPage,
          rightPage: getters.nextPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextNextPage,
          nextRightPage: getters.nextNextNextPage
        };
      }
    } else {
      return {
        previousPreviousPage: getters.previousPreviousPage,
        previousPage: getters.previousPage,
        previousSection: getters.previousSection,
        currentPage: getters.currentPage,
        nextSection: getters.nextSection,
        nextPage: getters.nextPage,
        nextNextPage: getters.nextNextPage
      };
    }
  },
  previousPreviousPreviousPage: function previousPreviousPreviousPage(state, getters) {
    if (getters.pageIndex <= 3) return null;
    return getters.pages[getters.pageIndex - 3][state.sectionIndices[0]];
  },

  previousPreviousPage: function previousPreviousPage(state, getters) {
    if (getters.pageIndex <= 2) return null;
    return getters.pages[getters.pageIndex - 2][state.sectionIndices[0]];
  },

  previousPage: function previousPage(state, getters) {
    if (getters.pageIndex == 1) {
      return getters.pages[0][state.sectionIndices[0]];
    }
    if (getters.pageIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 1][state.sectionIndices[0]];
  },

  nextPage: function nextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 1) return null;
    return getters.pages[getters.pageIndex + 1][state.sectionIndices[0]];
  },

  nextNextPage: function nextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 1) return null;
    if (getters.pageIndex == getters.pages.length - 2) return getters.pages[getters.pageIndex + 1][state.sectionIndices[0]];
    return getters.pages[getters.pageIndex + 2][state.sectionIndices[0]];
  },

  nextNextNextPage: function nextNextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 2) return null;
    return getters.pages[getters.pageIndex + 3][state.sectionIndices[0]];
  },

  previousSection: function previousSection(state, getters) {
    if (getters.sectionIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex - 2];
  },

  nextSection: function nextSection(state, getters) {
    if (getters.sectionIndex >= getters.pages[getters.pageIndex].length) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex];
  },

  previousPageURI: function previousPageURI(state, getters) {
    if (getters.previousPage == null) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.previousPreviousPage == null) {
        if (getters.pages[getters.pageIndex][0].pageIndex == 1) {
          return getters.routeFromIndex(0, 1);
        }
        return getters.routeFromIndex(1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex - 2) / 2.0), 1);
    } else {
      if (getters.pages[getters.pageIndex][0].pageIndex == 1) {
        return getters.routeFromIndex(0, 1);
      }
      return getters.routeFromIndex(getters.pageIndex - 1, state.sectionIndices[getters.pageIndex - 2] + 1);
    }
  },

  nextPageURI: function nextPageURI(state, getters) {
    var evt = window.document.createEvent('UIEvents');
    evt.initUIEvent('resize', true, false, window, 0);
    window.dispatchEvent(evt);

    if (state.isDoublePage && getters.doublePage) {
      if (getters.nextPage == null || getters.nextPage.index == Publish.$store.state.document.pages.length - 1) return null;

      if (getters.nextNextPage == null) {
        return getters.routeFromIndex(Publish.$store.state.document.pages.length - 1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex + 2) / 2.0), 1);
    } else if (!state.isMobile) {
      if (getters.nextPage == null || getters.nextPage.index == Publish.$store.state.document.pages.length) return null;
    }
    return getters.routeFromIndex(getters.pageIndex + 1, state.sectionIndices[getters.pageIndex] + 1);
  },

  previousSectionURI: function previousSectionURI(state, getters) {
    if (getters.previousSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex - 1);
  },

  nextSectionURI: function nextSectionURI(state, getters) {
    if (getters.nextSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex + 1);
  },

  previousPageIndices: function previousPageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    if (getters.previousPage.pageIndex == 1) return 1, 1;
    return {
      pageIndex: getters.pageIndex - 1,
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  previousDoublePageIndices: function previousDoublePageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: Math.ceil(getters.pageIndex - 2),
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  nextPageIndices: function nextPageIndices(state, getters) {
    if (getters.nextPage == null) return null;
    return {
      pageIndex: getters.pageIndex + 1,
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  nextDoublePageIndices: function nextDoublePageIndices(state, getters) {
    if (getters.nextNextPage == null) return null;
    return {
      pageIndex: 2 * parseInt((getters.pageIndex + 2) / 2.0),
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  previousSectionIndices: function previousSectionIndices(state, getters) {
    if (getters.previousSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex - 1
    };
  },

  nextSectionIndices: function nextSectionIndices(state, getters) {
    if (getters.nextSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex + 1
    };
  },

  pageContainerStyle: function pageContainerStyle(state, getters) {
    var styleObject = {};

    styleObject.transformOrigin = state.zoomOriginX + "px " + state.zoomOriginY + "px";

    styleObject.transform = "scale(" + getters.pageContainerZoomLevel * state.pageScale + ") translate(" + state.translateX + "px, " + state.translateY + "px)";

    return styleObject;
  },

  pageContainerZoomLevel: function pageContainerZoomLevel(state, getters) {
    return state.zoomLevel;
  },

  searchObject: function searchObject(state, getters) {
    var searchArray = [];
    getters.pages.forEach(function (sections, pageIndex) {
      sections.forEach(function (section, sectionIndex) {
        searchArray.push({
          id: pageIndex + "-" + (sectionIndex + 1),
          pageIndex: pageIndex,
          sectionIndex: sectionIndex + 1,
          title: section.title,
          body: section.searchText || "",
          image: section.original || "",
          thumb: section.index
        });
      });
    });
    return searchArray;
  },

  pageScripts: function pageScripts(state, getters) {
    return getters.pages.map(function (page, pageIndex) {
      return page.filter(function (e) {
        return e.script;
      }).map(function (section, sectionIndex) {
        return section.script.replace("onPageEnter", "p" + pageIndex + "s" + sectionIndex + "onPageEnter").replace("onPageLeave", "p" + pageIndex + "s" + sectionIndex + "onPageLeave");
      });
    }).reduce(function (a, b) {
      return a.concat(b);
    }).join("\n");
  },

  documentScript: function documentScript(state) {
    return state.document.script;
  },

  //#region Mobile
  mobilePages: function mobilePages(state) {
    return state.document.mobilePages;
  },
  mobilePageLink: function mobilePageLink(state, getters) {
    return function (page) {
      if (page.pageLinks.length) {
        var pageLink = page.pageLinks[0];
        return "/" + (pageLink.index + 1) + "-" + (pageLink.subIndex + 1);
      }
    };
  },
  currentMobilePage: function currentMobilePage(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch || getters.readerEnabled)) return;
    var currentPage = getters.mobilePages.find(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
    if (currentPage) return currentPage;else return null;
  },
  currentMobilePageIndex: function currentMobilePageIndex(state, getters) {
    if (!getters.mobilePages) return;
    return getters.mobilePages.findIndex(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
  },
  nextMobilePage: function nextMobilePage(state, getters) {
    if (getters.currentMobilePageIndex >= getters.mobilePages.length) return null;
    return getters.mobilePages[getters.currentMobilePageIndex + 1];
  },
  nextMobilePageIndices: function nextMobilePageIndices(state, getters) {
    if (getters.nextMobilePage == null) return null;
    return {
      pageIndex: getters.nextMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.nextMobilePage.pageLinks[0].subIndex + 1
    };
  },
  previousMobilePage: function previousMobilePage(state, getters) {
    if (getters.currentMobilePageIndex <= 0) return null;
    return getters.mobilePages[getters.currentMobilePageIndex - 1];
  },
  previousMobilePageIndices: function previousMobilePageIndices(state, getters) {
    if (getters.previousMobilePage == null) return null;
    return {
      pageIndex: getters.previousMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.previousMobilePage.pageLinks[0].subIndex + 1
    };
  },

  mobilePageContent: function mobilePageContent(state, getters) {
    return function (mobilePage) {
      return mobilePage.pageLinks.map(function (e) {
        return getters.pages[e.index][e.subIndex].mobileHtml;
      }).reduce(function (a, b) {
        return a + b;
      }, "");
    };
  }

  //#endregion

  //#region doublePage

  //#endregion
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/number/epsilon.js
var epsilon = __webpack_require__("NnIC");
var epsilon_default = /*#__PURE__*/__webpack_require__.n(epsilon);

// CONCATENATED MODULE: ./src/store/mutations.js



var _types$RESET_SECTION_;



/* harmony default export */ var mutations = (_types$RESET_SECTION_ = {}, defineProperty_default()(_types$RESET_SECTION_, RESET_SECTION_INDICES, function (state, payload) {
  state.sectionIndices = payload;
}), defineProperty_default()(_types$RESET_SECTION_, CHANGE_SECTION_INDEX, function (state, payload) {
  state.sectionIndices[payload.pageIndex] = payload.sectionIndex;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_PAGE_SCALE, function (state, payload) {
  state.pageScale = payload.pageScale;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_IS_FRONT_PAGE, function (state, payload) {
  // console.log(payload)
  if (payload) {
    state.document.width = 1448;
    // console.log(state.document.width)
  } else {
    state.document.width = 724;
    // console.log(state.document.width)
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_VIDEO_URL, function (state, payload) {
  state.videoURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_AUDIO_URL, function (state, payload) {
  state.audioURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel = "";
  } else {
    state.activePanel = "Languages";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_EDITIONS, function (state) {
  if (state.activePanel == "Editions") {
    state.activePanel = "";
  } else {
    state.activePanel = "Editions";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel = "";
  } else {
    state.activePanel = "Contents";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel = "";
  } else {
    state.activePanel = "Search";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_GUIDE, function (state) {
  if (state.activePanel == "Guide") {
    state.activePanel = "";
  } else {
    state.activePanel = "Guide";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_FONT_SIZE, function (state) {
  state.isMobileFontLarge = !state.isMobileFontLarge;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  // console.log('toggleZoom', payload.zoomOriginX)
  if (state.zoomLevel != 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
  } else {
    state.zoomLevel = payload.zoomLevel || 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  }

  Publish.$refs.app.$refs.navBar.$refs.zoomSlider.setValue(Math.round((state.zoomLevel + epsilon_default.a) * 100) / 100);
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_FULLSCREEN, function (state) {
  if (!document.fullscreenElement) {
    document.documentElement.requestFullscreen();
    state.isFullscreen = true;
  } else if (document.exitFullscreen) {
    document.exitFullscreen();
    state.isFullscreen = false;
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_FULLSCREEN, function (state) {
  if (document.fullscreenElement || window.fullscreenElement) {
    state.isFullscreen = true;
  } else {
    state.isFullscreen = false;
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.translateX = payload.translateX || state.translateX;
  state.translateY = payload.translateY || state.translateY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;

  if (state.zoomLevel <= 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
    state.translateX = 0;
    state.translateY = 0;
  }

  Publish.$refs.app.$refs.navBar.$refs.zoomSlider.setValue(Math.round((state.zoomLevel + epsilon_default.a) * 100) / 100);
}), defineProperty_default()(_types$RESET_SECTION_, SLIDE_ZOOM, function (state, payload) {
  var zoomDelta = payload.zoomValue - state.zoomLevel;

  if (zoomDelta < 0) {
    var zoomDeltaScale = zoomDelta / (1 - state.zoomLevel);
    state.zoomOriginX = state.zoomOriginX * (1 - zoomDeltaScale);
    state.zoomOriginY = state.zoomOriginY * (1 - zoomDeltaScale);
  }

  state.zoomLevel = payload.zoomValue || state.zoomLevel;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_INITIAL_WINDOW_SIZE, function (state, payload) {
  state.initialPageWidth = payload.width;
  state.initialPageHeight = payload.height;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_IS_DOUBLE_PAGE, function (state, payload) {
  state.isDoublePage = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY, function (state, payload) {
  state.galleryImages = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY_INDEX, function (state, payload) {
  state.galleryIndex = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_READER, function (state, payload) {
  state.isReader = !state.isReader;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_CONTENT_PANEL, function (state, payload) {
  state.contentsPanel = payload;
}), _types$RESET_SECTION_);
// CONCATENATED MODULE: ./src/store/modules/contents.js



// initial state
var contents_state = {
  showContents: false

  // getters
};var contents_getters = {};

// actions
var contents_actions = {};

// mutations
var contents_mutations = defineProperty_default()({}, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel == "";
  } else {
    state.activePanel == "Contents";
  }
});

/* harmony default export */ var contents = ({
  state: contents_state,
  getters: contents_getters,
  actions: contents_actions,
  mutations: contents_mutations
});
// CONCATENATED MODULE: ./src/store/modules/languages.js



// initial state
var languages_state = {
  showLanguages: false

  // getters
};var languages_getters = {};

// actions
var languages_actions = {};

// mutations
var languages_mutations = defineProperty_default()({}, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel == "";
  } else {
    state.activePanel == "Languages";
  }
});

/* harmony default export */ var languages = ({
  state: languages_state,
  getters: languages_getters,
  actions: languages_actions,
  mutations: languages_mutations
});
// CONCATENATED MODULE: ./src/store/modules/zoom.js


var _mutations;



// initial state
var zoom_state = {
  isZoomed: false,
  zoomLevel: 1,
  zoomOriginX: 0,
  zoomOriginY: 0

  // getters
};var zoom_getters = {
  // isZoomed: (state, getters) => state.isZoomed,
  zoomLevel: function zoomLevel(state, getters) {
    return state.zoomLevel;
  }

  // actions
};var zoom_actions = {
  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.rootState.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    if (newX < -context.getters.width) newX = -context.getters.width;
    if (newY < -context.getters.height) newY = -context.getters.height;
    if (newX > context.getters.width) newX = context.getters.width;
    if (newY > context.getters.height) newY = context.getters.height;
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY });
  }
};

// mutations
var zoom_mutations = (_mutations = {}, defineProperty_default()(_mutations, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (state.activePanel == 'Zoom') {
    state.activePanel = "";
  } else {
    state.activePanel = 'Zoom';
  }
  if (state.activePanel == 'Zoom') {
    state.zoomLevel = 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  } else {
    state.zoomLevel = 1;
  }
}), defineProperty_default()(_mutations, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;
}), _mutations);

/* harmony default export */ var zoom = ({
  state: zoom_state,
  getters: zoom_getters,
  actions: zoom_actions,
  mutations: zoom_mutations
});
// CONCATENATED MODULE: ./src/store/modules/search.js



// initial state
var search_state = {
  showSearch: false

  // getters
};var search_getters = {}
// allProducts: state => state.all


// actions
;var search_actions = {}
// getAllProducts ({ commit }) {
//   shop.getProducts(products => {
//     commit(types.RECEIVE_PRODUCTS, { products })
//   })
// }


// mutations
;var search_mutations = defineProperty_default()({}, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel == "";
  } else {
    state.activePanel == "Search";
  }
});

/* harmony default export */ var modules_search = ({
  state: search_state,
  getters: search_getters,
  actions: search_actions,
  mutations: search_mutations
});
// CONCATENATED MODULE: ./src/store/modules/route.js



// initial state - straight from the router i.e.
// route:{
// fullPath:"/5-1",
// meta: {},
// name:"PublishPage",
// params: {
//     section: "1",
//     page: "5"
// },
// path:"/5-1",
// query: {},
// }

// getters
var route_getters = {
  pageIndex: function pageIndex(state) {
    return parseInt(state.params.page);
  },
  sectionIndex: function sectionIndex(state) {
    return parseInt(state.params.section);
  }

  // actions
};var route_actions = {};

// mutations
var route_mutations = {};

/* harmony default export */ var route = ({
  getters: route_getters,
  actions: route_actions,
  mutations: route_mutations
});
// CONCATENATED MODULE: ./src/store/index.js












vue_esm["default"].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: {
    document: src_document,
    sectionIndices: [],
    pageScale: 1,
    videoURL: "",
    audioURL: "",
    activePanel: "",
    contentsPanel: true,
    zoomLevel: 1,
    zoomOriginX: 0,
    zoomOriginY: 0,
    translateX: 0,
    translateY: 0,
    isDoublePage: false,
    isFullscreen: false,
    galleryImages: [],
    galleryIndex: 0,
    isReader: false,
    initialWindowWidth: 300,
    initialWindowHeight: 476,
    isMobileFontLarge: false
  },
  actions: actions,
  getters: getters,
  mutations: mutations,
  modules: {
    // contents,
    // languages,
    // search,
    // zoom,
    route: route
  },
  strict: debug
}));
// EXTERNAL MODULE: ./node_modules/hammerjs/hammer.js
var hammer = __webpack_require__("rxKx");
var hammer_default = /*#__PURE__*/__webpack_require__.n(hammer);

// CONCATENATED MODULE: ./src/helpers/modules/inputHandler.js


/* harmony default export */ var inputHandler = ({
  init: function init() {
    window.mouseDown = false;
    window.mouse = {
      x: 0,
      y: 0,
      startX: 0,
      startY: 0,
      lastX: 0,
      lastY: 0,
      upX: 0,
      upY: 0,
      deltaX: 0,
      deltaY: 0
      // Mouse Events
      // document.addEventListener("mousedown", this.mouseDownHandler)
      // document.addEventListener("mousemove", this.mouseMoveHandler)
      // document.addEventListener("mouseup", this.mouseUpHandler)
    };document.addEventListener("wheel", this.mouseWheelHandler, { passive: false });
    document.addEventListener("dblclick", this.doubleClickHandler);
    //Touch Events
    // document.addEventListener( "touchstart", this.touchStartHandler)
    // document.addEventListener( "touchend", this.touchEndHandler)
    // document.addEventListener( "touchmove", this.touchMoveHandler)
    //Keyboard Events
    document.onkeydown = this.keyDownHandler;
    var hammertime;
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto",
        inputClass: hammer_default.a.SUPPORT_POINTER_EVENTS ? hammer_default.a.PointerEventInput : hammer_default.a.TouchInput,
        recognizers: [[hammer_default.a.Swipe, {
          direction: hammer_default.a.DIRECTION_HORIZONTAL
        }]]
      });
      hammertime.add(new hammer_default.a.Swipe());
    } else {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto"
      });
    }

    hammertime.get("swipe").set({ direction: hammer_default.a.DIRECTION_ALL });

    // hammertime.add(new Hammer.Tap({ event: "doubletap", taps: 2 }))
    // hammertime.add(new Hammer.Tap({ event: "singletap" }))
    // hammertime.get("doubletap").recognizeWith("singletap")
    // hammertime.get("singletap").requireFailure("doubletap")

    // hammertime.on("singletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1)
    //   ) {
    //     mouse.lastX = e.srcEvent.clientX
    //     mouse.lastY = e.srcEvent.clientY
    //   } else {
    //     console.log("Could not single tap")
    //   }
    // })

    // hammertime.on("doubletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     console.log("WORKING - MOBILE")
    //     Publish.toggleZoom({
    //       zoomOriginX: e.srcEvent.clientX,
    //       zoomOriginY: e.srcEvent.clientY,
    //     })
    //   } else {
    //     console.log("Could not double tap")
    //   }
    // })

    // hammertime.on("pinchin", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch in")
    //   }
    // })


    // hammertime.on("pinchout", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch out")
    //   }
    // })

    hammertime.on("pan", function (e) {
      if (!Publish.isMobile) {
        mouse.x = e.srcEvent.clientX;
        mouse.y = e.srcEvent.clientY;
        mouse.deltaX = mouse.x - mouse.lastX;
        mouse.deltaY = mouse.y - mouse.lastY;
        mouse.lastX = mouse.x;
        mouse.lastY = mouse.y;
        // console.log(mouse.deltaX + ", " + mouse.deltaY)
        // console.log("Panning")
        if (mouseDown && Publish.isZoomed && mouse.y > 50) {
          Publish.updateZoom({
            x: mouse.x,
            y: mouse.y
          });
        }
      }
    });

    hammertime.on("panstart", function (e) {
      if (!Publish.isMobile) {
        if (Publish.isZoomed) {
          mouseDown = true;
          mouse.lastX = e.srcEvent.clientX;
          mouse.lastY = e.srcEvent.clientY;
        }
      }
    });

    hammertime.on("panend", function (e) {
      if (!Publish.isMobile) {
        if (mouseDown && Publish.pagesVisible) {
          mouse.lastX = mouse.x;
          mouse.lastX = mouse.y;
          mouseDown = false;
        }
      }
    });

    hammertime.on("swipe", function (e) {
      if (Publish.isMobile && document.documentElement.dataset.mobile == "iOS" && screen.width != window.innerWidth && screen.width != window.innerHeight) //Safari
        {
          // console.log('zoomed portrait')
        } else {
        if (Publish.isGalleryOpen) {
          if (e.direction === hammer_default.a.DIRECTION_LEFT) {
            if (!Publish.rightToLeft) {
              Publish.nextGallerySlide();
            } else {
              Publish.previousGallerySlide();
            }
          } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
            if (!Publish.rightToLeft) {
              Publish.previousGallerySlide();
            } else {
              Publish.nextGallerySlide();
            }
          }
        } else if (Publish.videoURL == "" && Publish.audioURL == "" && !Publish.isZoomed) {
          if (Publish.isMobile || Publish.isReader) {
            if (Publish.mobileSwitch || Publish.isReader) {
              if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                if (!Publish.rightToLeft) {
                  Publish.goToNextMobilePage();
                } else {
                  Publish.goToPreviousMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                if (!Publish.rightToLeft) {
                  Publish.goToPreviousMobilePage();
                } else {
                  Publish.goToNextMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                console.log('Hammering Up');
                if (Publish.pagesVisible) Publish.goToNextSection();
              } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                console.log('Hammering Down');
                if (Publish.pagesVisible) Publish.goToPreviousSection();
              }
            } else {
              if (!Publish.isZoomed) {
                if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToNextPage();
                  } else {
                    Publish.goToPreviousPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToPreviousPage();
                  } else {
                    Publish.goToNextPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                  console.log('Hammering Up');
                  if (Publish.pagesVisible) Publish.goToNextSection();
                } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                  console.log('Hammering Down');
                  if (Publish.pagesVisible) Publish.goToPreviousSection();
                }
              }
            }
          } else {
            if (e.direction === hammer_default.a.DIRECTION_LEFT) {
              if (!Publish.rightToLeft) {
                Publish.goToNextPage();
              } else {
                Publish.goToPreviousPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
              if (!Publish.rightToLeft) {
                Publish.goToPreviousPage();
              } else {
                Publish.goToNextPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_UP) {
              console.log('Hammering Up');
              if (Publish.pagesVisible) Publish.goToNextSection();
            } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
              console.log('Hammering Down');
              if (Publish.pagesVisible) Publish.goToPreviousSection();
            }
          }
        }
        // else {
        //   if (e.direction === Hammer.DIRECTION_LEFT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToNextPage()
        //     } else {
        //       Publish.goToPreviousPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_RIGHT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToPreviousPage()
        //     } else {
        //       Publish.goToNextPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_UP) {
        //     if (Publish.pagesVisible) Publish.goToPreviousSection()
        //   } else if (e.direction === Hammer.DIRECTION_DOWN) {
        //     if (Publish.pagesVisible) Publish.goToNextSection()
        //   }
        // }
      }
    });
  },
  mouseWheelHandler: function mouseWheelHandler(e) {
    if (e.ctrlKey) {
      e.preventDefault();
      mouse.x = e.clientX;
      mouse.y = e.clientY;

      if (e.wheelDelta > 0) {
        Publish.scrollZoom({
          x: mouse.x,
          y: mouse.y,
          zoomDelta: 0.08
        });
      } else {
        Publish.scrollZoom({
          x: mouse.x,
          y: mouse.y,
          zoomDelta: -0.08
        });
      }
    } else {
      if (e.wheelDelta > 0) {
        Publish.goToPreviousSection();
      } else {
        Publish.goToNextSection();
      }
    }
  },
  mouseMoveHandler: function mouseMoveHandler(e) {
    if (Publish.pagesVisible && Publish.zoomEnabled) {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
      if (mouseDown && !Publish.isZoomed) {
        if (mouse.x - mouse.lastX < -100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToPreviousPage()
          //   else
          //     Publish.goToNextPage()
          // }
          mouseDown = false;
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
        } else if (mouse.x - mouse.lastX > 100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToNextPage()
          //   else
          //     Publish.goToPreviousPage()
          // }
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY < -100) {
          // if (Publish.pagesVisible) Publish.goToNextSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY > 100) {
          // if (Publish.pagesVisible) Publish.goToPreviousSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        }
      }
      if (mouseDown && Publish.isZoomed) {
        Publish.updateZoom({
          x: mouse.x,
          y: mouse.y
        });
      }
    }
  },
  mouseDownHandler: function mouseDownHandler(e) {
    if (!mouseDown && Publish.pagesVisible) {
      mouseDown = true;
      mouse.lastX = mouse.x;
      mouse.lastY = mouse.y;
    }
  },
  mouseUpHandler: function mouseUpHandler(e, fromTouch) {
    if (mouseDown && Publish.pagesVisible) {
      mouse.upX = mouse.x;
      mouse.upY = mouse.y;
      mouseDown = false;
    }
  },
  doubleClickHandler: function doubleClickHandler(e) {
    if (Publish.zoomClickEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" && (e.target.className.search("currentPage") !== -1 || e.target.className.search("leftPage") !== -1 || e.target.className.search("rightPage") !== -1 || e.path.indexOf(document.getElementById("page-container") !== -1))) {
      Publish.toggleZoom({
        zoomOriginX: e.pageX - window.innerWidth / 2,
        zoomOriginY: e.pageY - window.innerHeight / 2
      });
    } else {
      console.log("Double click failed!");
    }
  },
  keyDownHandler: function keyDownHandler(e) {
    e = e || window.event;
    if (e.target.tagName == "INPUT" || e.ctrlKey == true || e.metaKey == true) return;
    if (Publish.isGalleryOpen) {
      if (e.keyCode == "37") {
        if (!Publish.rightToLeft) {
          Publish.previousGallerySlide();
        } else {
          Publish.nextGallerySlide();
        }
      }
      if (e.keyCode == "39") {
        if (!Publish.rightToLeft) {
          Publish.nextGallerySlide();
        } else {
          Publish.previousGallerySlide();
        }
      }
    } else if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
      // if(!Publish.isZoomed){
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextMobilePage();else Publish.goToPreviousMobilePage();
      }
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousMobilePage();else Publish.goToNextMobilePage();
      }
      // }
    } else if (!Publish.videoURL == "" || !Publish.audioURL == "") {} else {
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextPage();else Publish.goToPreviousPage();
      } // left arrow
      if (e.keyCode == "38") Publish.goToPreviousSection(); // up arrow
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousPage();else Publish.goToNextPage();
      } // right arrow
      if (e.keyCode == "40") Publish.goToNextSection(); // down arrow
    }
  },
  throttle: function throttle(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

    var timer = null;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (timer === null) {
        timer = setTimeout(function () {
          func.apply(_this, args);
          timer = null;
        }, wait);
      }
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/platformHandler.js
/* harmony default export */ var platformHandler = ({
  init: function init() {
    var documentElement = document.documentElement;
    documentElement.setAttribute("data-useragent", navigator.userAgent);
    documentElement.setAttribute("data-platform", navigator.platform);
    documentElement.setAttribute("data-mobile", this.getMobileOperatingSystem());
    documentElement.setAttribute("data-browser", this.getBrowserInformation());
  },

  /**
   * Determine the mobile operating system.
   * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
   *
   * @returns {String}
   */
  getMobileOperatingSystem: function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  },
  getBrowserInformation: function getBrowserInformation() {
    var ua = navigator.userAgent,
        tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M[0];
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/pageHandler.js
/* harmony default export */ var pageHandler = ({
  init: function init() {
    var delay = 250;
    var timeout = false;
    // this.actualResizeHandler()
    window.addEventListener('resize', this.debounce(this.actualResizeHandler, 250));
    document.addEventListener('fullscreenchange', this.updateFullscreen);
  },
  actualResizeHandler: function actualResizeHandler(event) {
    if (typeof Publish !== 'undefined') {
      if (!Publish.isMobile) {
        Publish.changeWindowSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      } else {
        Publish.changeWindowSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      }
    }
  },
  updateFullscreen: function updateFullscreen() {
    Publish.updateFullscreen();
  },
  debounce: function debounce(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;

    var timeout = void 0;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(_this, args);
      }, wait);
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/index.js





/* harmony default export */ var helpers = ({
  inputHandler: inputHandler,
  platformHandler: platformHandler,
  pageHandler: pageHandler,
  trackingHandler: trackingHandler
});
// EXTERNAL MODULE: ./node_modules/vuex-router-sync/index.js
var vuex_router_sync = __webpack_require__("9JMe");
var vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(vuex_router_sync);

// CONCATENATED MODULE: ./src/main.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









var unsync = Object(vuex_router_sync["sync"])(store, router);

vue_esm["default"].config.productionTip = false;

vue_esm["default"].use(vue_gtag_esm["a" /* default */], {
  config: { id: "G-W417MPF50H" }
}, router);

/* eslint-disable no-new */
window.Publish = new vue_esm["default"]({
  el: "#app",
  router: router,
  store: store,
  template: '<App ref="app"/>',
  components: {
    App: src_App
  },
  created: function created() {
    if (this.mobileSwitch) this.checkMobileLanding();
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
  }), Object(vuex_esm["c" /* mapGetters */])(["currentPage", "pagesVisible", "isZoomed", "showContents", "zoomLevel", "rightToLeft", "zoomEnabled", "zoomClickEnabled", "isMobile", "mobileSwitch", "currentMobilePageIndex", "videoURL", "isGalleryOpen", "doublePage", "isPhantom", "isDoublePage", "showGuide", "initialWindowWidth", "initialWindowHeight", "audioURL"])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleZoom: "TOGGLE_ZOOM",
    updateFullscreen: "UPDATE_FULLSCREEN"
  }), Object(vuex_esm["b" /* mapActions */])(["goToPage", "goToNextPage", "goToPreviousPage", "goToNextSection", "goToPreviousSection", "goToPreviousMobilePage", "goToNextMobilePage", "nextPage", "previousPage", "nextSection", "previousSection", "previousMobilePage", "nextMobilePage", "scrollZoom", "updateZoom", "startZoom", "changeWindowSize", "checkMobileLanding", "updateVideoURL", "pinchZoom", "panZoom", "openVideo", "isPhantom", "openGallery", "openGalleryTwo", "closeGallery", "goToGallerySlide", "nextGallerySlide", "previousGallerySlide", 'changeWindowSize', 'setInitialWindowSize', "updateAudioURL", "openAudio"])),
  mounted: function mounted() {
    helpers.pageHandler.init();
    helpers.inputHandler.init();
    helpers.platformHandler.init();
    helpers.trackingHandler.init();
    // if (!Publish.isPhantom) {
    // this.changeWindowSize({
    //   width: window.innerWidth,
    //   height: window.innerHeight,
    // })
    // }
  }
});

router.beforeEach(function (to, from, next) {
  if (Publish.isMobile && Publish.mobileSwitch) next();
  // console.log('Navigating from', from, ' to ', to)
  var p = parseInt(from.params.page);
  var s = parseInt(from.params.section) - 1;
  try {
    if (window["p" + p + "s" + s + "onPageLeave"] && !Publish.$store.getters.tmpMobile) {
      window["p" + p + "s" + s + "onPageLeave"]();
    }
    if (Publish.$store.state.isDoublePage && Publish.doublePage) {
      window["p" + p + "s" + s + "onPageLeave"]();
      window["p" + (p + 1) + "s" + s + "onPageLeave"]();
    }
  } catch (err) {
    console.error("WARNING - p" + p + "s" + s + "onPageLeave caused an error:");
    console.error(err.message);
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
    document.getElementById('mobile-container').style.position = "fixed";
    setTimeout(function () {
      document.getElementById('mobile-container').style.position = "";
    }, 100);
  }
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

/***/ }),

/***/ "NXlJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NYpa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OGji":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P1S/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QkI9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WAiT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YibV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "biBg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bp21":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i9d8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oPvi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "opfQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pXbK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u/WO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uDJ7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zUAv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.5c2a080d5cb9261f3fd7.js